/* eslint-disable prettier/prettier */
import { gql } from "@apollo/client";
import { isTemplatesV2 } from "../constant/TemplateConstant";

export const GET_POSTS = gql`
  query GetPosts($older: DateTime, $newer: DateTime, $range: Int, $hideViewed: Boolean) {
    getPosts(older: $older, newer: $newer, range: $range, hideViewed: $hideViewed) {
      data {
        id
        body
        url
        author
        authorProfileUrl
        location
        timestamp
        source
        status
        sourceType
        sourceId
        sourceUrl
        tags
        threadTitle
        review
      }
      count
    }
  }
`;

export const GET_CURRENT_USER = gql`
  {
    me {
      id
      firstName
      lastName
      fullName
      phone
      company {
        id
        timezone
        isOptinConsentMethod
        isGlobalCrm
      }
      userAccounts {
        company {
          id
          name
          timezone
          isOptinConsentMethod
          isGlobalCrm
        }
      }
    }
  }
`;

export const GET_CURRENT_USER_COMPANY_USERS = gql`
  {
    me {
      id
      firstName
      lastName
      fullName
      email
      phone
      companyRole {
        id
        name
        parentRoleId
      }
      company {
        id
        isGlobalCrm
        users {
          id
          firstName
          lastName
          fullName
          email
          isDisabled
          phone
        }
      }
      locationId
    }
  }
`;

export const GET_CURRENT_USER_COMPANY_TEAMS = gql`
  {
    getTeams {
      id
      name
      leaderId
      status
      leader {
        id
        fullName
      }
      members {
        memberId
        member {
          id
          fullName
        }
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getUsers(
    $page: Int
    $pageSize: Int
    $search: String
    $companyId: Int!
    $isGlobalLeadOwner: Boolean
    $isLocationFilter: Boolean
    $locationIds: [Int]
    $allUser: Boolean
    $companyRoles: [Int]
    $isActive: Boolean
    $status: [String]
    $hasPhoneNumber: Boolean
    $departmentIds: [Int]
    $orderBy: String
    $orderDirection: String
  ) {
    getUsers(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      isGlobalLeadOwner: $isGlobalLeadOwner
      isLocationFilter: $isLocationFilter
      locationIds: $locationIds
      allUser: $allUser
      companyRoles: $companyRoles
      isActive: $isActive
      status: $status
      hasPhoneNumber: $hasPhoneNumber
      departmentIds: $departmentIds
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        companyId
        id
        cognitoId
        firstName
        lastName
        fullName
        email
        isDisabled
        dateCreated
        locationId
        settings
        userRoles {
          id
          companyId
          roleId
          role {
            id
            name
          }
          company {
            id
            name
            timezone
            locationLink
            isOptinConsentMethod
            isGlobalCrm
          }
        }
        status
        phone
        companyRoleId
        companyRole {
          id
          name
          locations {
            locationId
            location {
              id
              title
            }
          }
        }
        userAccounts {
          id
          userId
          companyId
          isDisabled
          company {
            id
            isGlobalCrm
          }
        }
        role {
          id
          name
          canViewAutoAnalytics
          canViewAdExport
        }
        location {
          id
          title
        }
        locations {
          id
          userId
          locationId
          location {
            id
            title
          }
          isPrimary
        }
        departmentIds
        dsUsers {
          id
          dsUserId
          dsUserName
          active
        }
      }
      count
    }
  }
`;
export const GET_FILTER_USERS = gql`
  query getUsers(
    $page: Int
    $pageSize: Int
    $search: String
    $companyId: Int!
    $isGlobalLeadOwner: Boolean
    $isLocationFilter: Boolean
    $locationIds: [Int]
    $allUser: Boolean
    $companyRoles: [Int]
    $isActive: Boolean
    $status: [String]
    $isAllLocationUsers: Boolean
  ) {
    getUsers(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      isGlobalLeadOwner: $isGlobalLeadOwner
      isLocationFilter: $isLocationFilter
      locationIds: $locationIds
      allUser: $allUser
      companyRoles: $companyRoles
      isActive: $isActive
      status: $status
      isAllLocationUsers: $isAllLocationUsers
    ) {
      data {
        id
        firstName
        lastName
        fullName
        profilePic
        phone
        status
        companyRole {
          id
          name
        }
      }
      count
    }
  }
`;
export const GET_ALL_TEAMS = gql`
  query getTeams($page: Int, $pageSize: Int, $search: String, $companyId: Int!, $locationId: Int) {
    getTeams(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      locationId: $locationId
    ) {
      data {
        id
        name
        leaderId
        status
        locationId
        leader {
          id
          fullName
        }
        members {
          memberId
          member {
            id
            fullName
          }
        }
      }
      count
    }
  }
`;

export const GET_ALL_ROLES = gql`
  query roles($companyId: Int!) {
    roles(companyId: $companyId) {
      id
      name
      canCreateUsers
      canCreateTeams
      canViewProspects
      isCompanyAdmin
      canViewAutoAnalytics
      canViewAdExport
      canViewClm
      canViewGle
      canViewEngagements
    }
  }
`;

export const GET_USER_FILTERS = gql`
  {
    me {
      id
      filters {
        id
        type
        typeName
        value
        companyFilterId
        setType
        filterType {
          isDynamic
        }
      }
      filterSets {
        userId
        name
        setType
        id
      }
      responseTemplates {
        id
        message
        isInitialResponse
      }
    }
  }
`;

export const GET_DISPLAY_FILTERS = gql`
  {
    getUserDisplayFilters {
      id
      type
      typeName
      value
      selectionOption {
        id
        value
        query
      }
    }
  }
`;

export const ALL_EVENTS = gql`
  {
    allEvents {
      duration
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const GET_SAVED_POSTS = gql`
  query getSavedPosts($setType: String) {
    getSavedPosts(setType: $setType) {
      id
      userId
      companyId
      aingineDataId
      status
      post {
        id
        body
        url
        author
        authorProfileUrl
        location
        timestamp
        source
        status
        sourceId
        sourceUrl
        sourceType
        tags
        review
      }
    }
  }
`;

export const GET_DEALS = gql`
  query GetDeals($status: String, $orderBy: String, $orderDirection: String, $postType: String) {
    getDeals(
      status: $status
      postType: $postType
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      id
      userId
      salesPerson {
        fullName
        id
      }
      companyId
      aingineDataId
      screenName
      firstName
      lastName
      email
      phone
      location
      url
      profileUrl
      source
      strength
      status
      dateCreated
      followupDate
      subscribed
      tags
      allowNotifications
      conversations {
        id
        type
        message
        postTime
        aingineUserId
        aingineDataId
      }
      postType
    }
  }
`;

export const GET_COMPANIES = gql`
  query getCompanies($orderBy: String, $orderDirection: String) {
    getCompanies(orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      name
      address
      city
      state
      postalCode
      country
      phone
      userCount
      dateCreated
      isDisabled
      timezone
      locationLink
      isOptinConsentMethod
      website
      isGlobalCrm
      isOpenCrmWarningPopup
      profilePic
      crmIntegration {
        integrationType
      }
      isPushToCrm
      isPushToDms
    }
  }
`;

export const GET_COMPANY = gql`
  query GetCompany($id: Int!) {
    company(id: $id) {
      id
      name
      phone
      address
      city
      state
      postalCode
      country
      website
      industry
      addressDetail
      userCount
      dateCreated
      isDisabled
      timezone
      locationLink
      isOptinConsentMethod
      isGlobalCrm
      isOpenCrmWarningPopup
    }
  }
`;

export const GET_MY_COMPANY = gql`
  query GetMyCompany {
    me {
      id

      company {
        id
        name
        phone
        address
        city
        state
        postalCode
        country
        website
        industry
        addressDetail
        userCount
        dateCreated
        isDisabled
        automaticEngagement
        timezone
        locationLink
        isOptinConsentMethod
        isGlobalCrm
        isOpenCrmWarningPopup
        profilePic
      }
    }
  }
`;

export const GET_COMPANY_USERS = gql`
  query GetCompanyUsers($id: Int!, $locationIds: [Int]) {
    company(id: $id, locationIds: $locationIds) {
      id
      name
      users {
        id
        fullName
        phone
        email
        locationId
        companyRoleId
        companyRole {
          id
          name
        }
        locations {
          location {
            id
            title
          }
        }
      }
      userAccounts {
        isDisabled
        user {
          id
          fullName
          userRoles {
            id
            companyId
            roleId
            role {
              id
              name
            }
            company {
              id
              name
              timezone
              locationLink
              isOptinConsentMethod
              isGlobalCrm
            }
          }
          location {
            id
            title
            locationType
          }
          firstName
          lastName
          email
          phone
          isDisabled
          dateCreated
          status
          locationId
          companyRoleId
          responseTemplates {
            id
            message
            isInitialResponse
          }
          role {
            id
            name
          }
          locations {
            location {
              id
              title
            }
          }
        }
      }
    }
  }
`;

export const GET_FILTER_TYPES = gql`
  query GetFilterTypes {
    getFilterTypes {
      id
      type
      name
      filterField
      optionsCount
      selectionOptions {
        id
        value
        query
      }
    }
  }
`;

export const FILTER_TYPE = gql`
  query FilterType($id: Int!) {
    filterType(id: $id) {
      selectionOptions {
        id
        value
        query
      }
    }
  }
`;

export const GET_COMPANY_FILTERS = gql`
  query GetCompanyFilters($id: Int!) {
    company(id: $id) {
      filters {
        id
        value
        type
        typeName
        filterField
        userCanChange
        selectionOption {
          id
        }
      }
    }
  }
`;

export const SEARCH_COMPANIES = gql`
  query SearchCompanyByName($name: String!) {
    searchCompanyByName(name: $name) {
      id
      name
      address
      city
      state
      postalCode
      country
      phone
      userCount
      dateCreated
      isDisabled
      timezone
      locationLink
      isOpenCrmWarningPopup
      profilePic
    }
  }
`;

export const USER_FILTERS_BY_ID = gql`
  query GetUserFilters($id: Int!) {
    user(id: $id) {
      filters {
        id
        type
        typeName
        value
        setType
      }
    }
  }
`;

export const ROLES = gql`
  query Roles($companyId: Int) {
    roles(companyId: $companyId) {
      id
      name
      canCreateUsers
      canCreateTeams
      canViewProspects
      isCompanyAdmin
      canViewAutoAnalytics
      canViewAdExport
      canViewClm
      canViewGle
      canViewEngagements
    }
  }
`;

// TODO: add id ?
export const SCREEN_NAME_CHECK = gql`
  query ScreenNameCheck($sourceId: Int!) {
    screenNameCheck(sourceId: $sourceId) {
      hasScreenName
      screenName {
        id
        screenName
      }
    }
  }
`;

export const GET_CRM_INTEGRATION = gql`
  query GetCrmIntegration($companyId: Int!, $locationId: Int, $search: String) {
    crmIntegration: crmIntegrationByCompany(
      companyId: $companyId
      locationId: $locationId
      search: $search
    ) {
      id
      companyId
      integrationType
      adfEmail
      crmDealerId
      crmSiteId
      vsLeadSourceId
      sfApiUrl
      sfApiKey
      sfApiUser
      sfCertificateKey
      elSubscriptionId
      crmFranchiseId
      locationId
      active
      location {
        id
        title
        locationType
      }
    }
  }
`;

export const GET_USER_TEAM = gql`
  query GetUserTeam {
    me {
      id
      teamsLeader {
        members {
          member {
            firstName
            lastName
            fullName
            id
          }
        }
      }
      isCompanyAdmin
      isDisabled
      company {
        id
        isGlobalCrm
        userAccounts {
          isDisabled
          user {
            firstName
            lastName
            fullName
            id
            locationId
          }
        }
      }
    }
  }
`;

export const SEARCH_DEALS = gql`
  query SearvhDeals($searchTerm: String!) {
    searchDeals(searchTerm: $searchTerm) {
      id
      userId
      salesPerson {
        fullName
        id
      }
      companyId
      aingineDataId
      screenName
      firstName
      lastName
      email
      phone
      location
      url
      profileUrl
      source
      strength
      status
      dateCreated
      followupDate
      tags
      allowNotifications
      conversations {
        id
        type
        message
        postTime
        aingineUserId
        aingineDataId
      }
    }
  }
`;

// TODO: add id ?
export const GET_ANALYTICS_KPIS = gql`
  query GetAnalyticsKpis($range: Int!, $teamId: Int!, $allMembers: Boolean) {
    getAnalyticsKpis(range: $range, allMembers: $allMembers) {
      date
      userId
      status
      count
      source
      userName
    }
    team(id: $teamId) {
      members {
        member {
          id
          fullName
        }
      }
    }
  }
`;

export const GET_USER_SCREENNAMES = gql`
  query GetUserScreenNames {
    me {
      id
      screenNames {
        id
        source
        sourceId
        screenName
        sourceUrl
      }
    }
  }
`;

export const GET_SOURCES = gql`
  query GetSources {
    getSources {
      source
      sourceId
      sourceUrl
    }
  }
`;

export const GET_USER_RESPONSE_TEMPLATES = gql`
  query GetUserResponseTemplates {
    me {
      id
      responseTemplates {
        id
        message
        isInitialResponse
      }
    }
  }
`;

// TODO: add id ?
export const GET_APP_USAGE_ALL = gql`
  query getAppUsage {
    getAnalyticsAppUsage {
      date
      time
      userName
      converted
      provided
      engaged
      crm
    }
  }
`;

// TODO: add id ?
export const GET_APP_USAGE = gql`
  query getAppUsage {
    getAnalyticsAppUsage {
      date
      time
      userName
    }
  }
`;

// TODO: add id ?
export const GET_ANALYTICS_POSTS = gql`
  query getAnalyticsPosts($range: Int) {
    getAnalyticsPosts(range: $range) {
      timestamp
      count
    }
  }
`;

// TODO: add id ?
export const GET_ANALYTICS_CATEGORIES = gql`
  query getAnalyticsCategories($range: Int) {
    getAnalyticsCategories(range: $range) {
      name
      total
      children {
        name
        count
      }
    }
  }
`;
export const GET_PERMISSION_LEAD_IDS = gql`
  query getPermissionLeadIds {
    getPermissionLeadIds
  }
`;
export const GET_NOTIFICATIONS = gql`
  query getNotifications(
    $older: DateTime
    $notificationTypes: [String]
    $leadIds: [Int]
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
  ) {
    getNotifications(
      older: $older
      notificationTypes: $notificationTypes
      leadIds: $leadIds
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
    ) {
      count
      data {
        leadId
        count
        notifications {
          id
          date
          notificationType
          text
          read
          clickableLink
          locationId
          leadId
          lead {
            locationId
            fullName
            phoneNumbers {
              id
              phone
              phoneType
            }
          }
        }
      }
    }
  }
`;

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  {
    getUnreadNotificationsCount
  }
`;

export const GET_EXPORT_CONFIGS = gql`
  query getExportConfigs {
    getExportConfigs {
      id
      userId
      user {
        firstName
        lastName
      }
      name
      email
      minimumCount
      frequency
      count
      lastExported
      filters {
        typeName
        value
        type
      }
      timezone
    }
  }
`;

export const GET_EXPORT_CONFIG = gql`
  query exportConfig($id: Int!) {
    exportConfig(id: $id) {
      id
      userId
      name
      email
      minimumCount
      frequency
      count
      lastExported
      emailTime
      filters {
        id
        type
        typeName
        value
        companyFilterId
        setType
      }
      timezone
    }
  }
`;

export const GET_EXPORTS = gql`
  query getExports {
    getExports {
      id
      name
      createdAt
      count
      exportConfig {
        userId
        user {
          firstName
          lastName
        }
        name
        adHoc
        email
        minimumCount
        count
        lastExported
        filters {
          type
          typeName
          value
        }
      }
    }
  }
`;

export const GET_ALL_PERSONS = gql`
  query allPersons($sourceId: Int) {
    allPersons(sourceId: $sourceId) {
      id
      fullName
      emails {
        address
      }
      phoneNumbers {
        number
      }
      addresses {
        line1
      }
    }
  }
`;

export const GET_PAGINATED_PERSONS = gql`
  query paginatedPersons(
    $sourceId: Int
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    paginatedPersons(
      sourceId: $sourceId
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        fullName
        emails {
          address
        }
        phoneNumbers {
          number
        }
        addresses {
          line1
        }
      }
      count
    }
  }
`;

export const GET_PERSON = gql`
  query person($id: Int!) {
    person(id: $id) {
      id
      firstName
      lastName
      dob
      addresses {
        id
        type
        current
        line1
        line2
        locality
        region
        country
        latitude
        longitude
        location
        postalCode
      }
      emails {
        id
        type
        address
      }
      phoneNumbers {
        id
        type
        number
      }
      languages {
        id
        language
      }
      education {
        id
        schoolName
        level
        degree
        startDate
        endDate
        location
        description
      }
      experience {
        id
        title
        company
        startDate
        endDate
        location
        description
      }
      certificates {
        id
        type
        title
        issuingAuthority
        date
      }
      volunteering {
        id
        role
        location
        dateStart
        dateEnd
        cause
        description
      }
      skills {
        id
        name
        strength
      }
      accomplishments {
        id
        type
        title
        url
        description
      }
      publications {
        id
        name
        publisher
        date
        url
      }
      awards {
        id
        name
        location
        date
        description
      }
      interests {
        id
        type
        name
        url
      }
      possessions {
        id
        type
        name
      }
      accounts {
        account {
          id
          profileUrl
          username
          location
          about
          source {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_LIFE_EVENTS_POSTS = gql`
  query GetLifeEventsPosts(
    $older: DateTime
    $newer: DateTime
    $range: Int
    $globalEvents: Boolean
  ) {
    getLifeEventsPosts(older: $older, newer: $newer, range: $range, globalEvents: $globalEvents) {
      data {
        id
        body
        url
        author
        authorProfileUrl
        location
        timestamp
        source
        status
        sourceType
        sourceId
        sourceUrl
        tags
        threadTitle
        review
        personId
        personFullName
      }
      count
    }
  }
`;

// TODO: add id ?
export const GET_PERSON_DESCRIPTOR = gql`
  {
    personDescriptor {
      modelName
      fields {
        name
        nullable
        type
        options
      }
    }
  }
`;

export const ALL_UNIQUE_SOURCES = gql`
  query AllUniqueSources($exclude: [String]) {
    allUniqueSources(exclude: $exclude) {
      sourceType
      id
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query getUserByEmail($email: String!) {
    getUserByEmail(email: $email) {
      email
      id
      fullName
      location {
        id
        title
      }
      userAccounts {
        id
        userId
        companyId
      }
      userRoles {
        roleId
        userId
        id
      }
    }
  }
`;

export const GET_EVAL_TERMS = gql`
  {
    getEvalTerms {
      id
      text
      include
      exclude
      intent
    }
  }
`;

export const GET_PAGINATED_LEADS = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $dsSources: [String]
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      dsSources: $dsSources
    ) {
      data {
        id
        fullName
        firstName
        lastName
        companyId
        leadSourceType
        leadSourceOriginalId
        dateOfBirth
        leadCreatedDate
        emailConsent
        textConsent
        textConsentDate
        textConsentStatus
        status
        otherSource
        unreadCount
        leadStatusTypeId

        leadStatusType {
          id
          type
          status
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          leadOpportunityUsers {
            id
            userTypeId
            userId
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          opportunityTypeId
          opportunityStatusId
          opportunitySourceId
          opportunityType {
            id
            name
          }
          opportunityStatus {
            id
            name
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          dsOpportunityEvents {
            dsEventId
            dsEntitySource
            dsMarketingChannelName
            dsTrackingCode
          }
          sfLeadOpportunities {
            sfOpportunityId
            sfOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
            vsLeadStatusMapping {
              vsLeadStatusType
              vsLeadStatus
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          appointments {
            id
            startDatetime
            endDatetime
          }
          users {
            id
            user {
              id
              firstName
              lastName
            }
            userType {
              id
              name
            }
          }
        }
        emails {
          id
          email
          emailType
          isPrimary
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
        }
        addresses {
          id
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        leadVehicleInventory {
          id
          make
          model
          year
          trim
          stockNumber
          vin
        }
        messages {
          id
          dateSent
          dateReceived
          messageStatus
          messageType
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }

        activeAppointment {
          id
          leadOpportunityId
          companyId
          leadId
          userId
          startDatetime
          endDatetime
          uid
          description
          location
          locationId
          sequence
          status
          summary
          leadEmail
          leadPhone
          timezone
          appointmentStatus
          isConfirmed
          discussedVoiId
          isConfirmed
          isLastActionByLead
          dateUpdated
          createdBy {
            id
            fullName
            dateCreated
          }
          updatedBy {
            id
            fullName
            dateCreated
          }
          user {
            id
            fullName
            companyRoleId
            companyRole {
              id
              name
            }
          }
          lead {
            id
            fullName
            firstName
            lastName
            dateOfBirth
            leadSourceType
            leadSourceOriginalId
            companyId
            leadFileId
            crmIntegrationId
            status
            emailConsent
            emailConsentDate
            textConsent
            textConsentDate
            textConsentStatus
            otherSource
            disableConversation
            leadStatusType {
              id
              type
              status
            }
            emails {
              id
              leadId
              email
              emailType
              isPrimary
            }
            phoneNumbers {
              id
              leadId
              phone
              phoneType
              lookupType
              isPrimary
            }
            addresses {
              id
              leadId
              locationText
              addressLine1
              addressLine2
              city
              state
              postalCode
              country
            }
            vehicleOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
            leadVehicleInventory {
              id
              make
              model
              year
              trim
              stockNumber
              vin
            }
            leadSource {
              name
              id
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
          }
          leadOpportunity {
            dsOpportunityEvents {
              dsEventId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
            }
            sfLeadOpportunities {
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
              vsLeadStatusMapping {
                vsLeadStatusType
                vsLeadStatus
              }
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            opportunityType {
              id
              name
              parentType {
                id
                name
              }
            }
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            id
            leadId
            name
          }
        }
        consentExpireDay
        conversationStatus {
          id
          userId
          disableConversation
          createdOn
        }
        location {
          id
          title
          locationType
          timezone
        }
        leadUsers {
          userType {
            id
            useCase
            name
          }
          user {
            id
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
        campaignObj {
          campaigns {
            id
            name
          }
          activelyCampaign
        }
        crmLeadObj {
          crmIntegrationType
          crmStatus
          parentCrmStatus
          customerType {
            id
            type
          }
          customerSubType {
            id
            type
          }
          dsExtractedLead {
            id
            dsLeadId
            dsSource
          }
          activeDsOpportunityEvent {
            id
            dsEventId
            dsMarketingChannelName
          }
          sfExtractedLead {
            id
            sfLeadId
          }
          mfExtractedLead {
            id
            mfProspectId
            mfCustomerId
          }
          activeSfOpportunityEvent {
            id
            sfOpportunityId
          }
        }
      }
      count
    }
  }
`;
export const GET_LEAD_NAMES = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $dsSources: [String]
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      dsSources: $dsSources
    ) {
      data {
        id
        fullName
        phoneNumbers {
          id
          phone
        }
      }
      count
    }
  }
`;
export const GET_LEAD_NAME_BY_ID = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      fullName
    }
  }
`;
export const GET_LEAD = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      fullName
      firstName
      lastName
      dateOfBirth
      leadSourceType
      leadSourceOriginalId
      companyId
      leadFileId
      crmIntegrationId
      status
      emailConsent
      emailConsentDate
      textConsent
      textConsentDate
      textConsentStatus
      otherSource
      disableConversation
      leadStatusTypeId
      locationId
      leadStatusType {
        id
        type
        status
      }
      emails {
        id
        leadId
        email
        emailType
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      phoneNumbers {
        id
        leadId
        phone
        phoneType
        lookupType
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      addresses {
        id
        leadId
        locationText
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      vehicleOfInterest {
        id
        leadId
        year
        make
        model
        trim
        description
        budget
        customerInterest
        inputType
        isCurrent
        isPrimary
        stockNumber
        vin
      }
      leadVehicleInventory {
        id
        make
        model
        year
        trim
        stockNumber
        vin
      }
      leadSource {
        name
        id
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }

      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
          firstName
          lastName
        }
      }
      location {
        id
        title
        timezone
      }
      crmLeadObj {
        crmIntegrationType
        crmStatus
        parentCrmStatus
        activeLeadOpportunity {
          id
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
        }
        customerType {
          id
          type
        }
        customerSubType {
          id
          type
        }
        dsExtractedLead {
          id
          dsLeadId
          dsSource
        }
        activeDsOpportunityEvent {
          id
          dsEventId
          dsMarketingChannelName
        }
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
        activeSfOpportunityEvent {
          id
          sfOpportunityId
        }
      }
    }
  }
`;

export const GET_LEAD_DESCRIPTOR = gql`
  {
    leadDescriptor {
      modelName
      fields {
        name
        nullable
        type
        options
      }
    }
  }
`;

export const GET_LEAD_SOURCES = gql`
  {
    leadSources {
      id
      name
      isAddedFromCrm
      parentSource {
        id
        name
        parentSource {
          id
          name
        }
      }
    }
  }
`;

export const GET_EXTENSION_LEAD_SOURCES = gql`
  {
    leadSources {
      id
      name
      isAddedFromCrm
    }
  }
`;

export const GET_ALL_CAMPAIGNS = gql`
  {
    campaigns {
      id
      name
      isDisabled
    }
  }
`;
export const GET_CAMPAIGN_PAGINATED_LIST = gql`
  query getCampaigns($page: Int, $pageSize: Int, $status: [String]) {
    getCampaigns(page: $page, pageSize: $pageSize, activeInd: $status) {
      data {
        id
        name
        startDate
        endDate
        method
        textMessage
        activeInd
        campaignType {
          id
          type
        }
        isDisabled
        isPrioritize
        source
        status
        extraData
        user {
          id
          fullName
          firstName
          lastName
          locationId
        }
        leadMessageCount {
          campaignId
          totalSent
          totalDelivered
          totalResponded
          totalUncontacted
          responseRate
          optOutRate
          totalEngaged
          avgAttemptsBeforeResponse
          soldOpportunityCount
          scheduledAppointmentCount
          rescheduledAppointmentCount
          showedAppointmentCount
          cancelledAppointmentCount
          noShowedAppointmentCount
          ottoAppointmentSchCount
          ottoAppointmentConfCount
          totalLeads
        }
      }
      count
    }
  }
`;

export const GET_CAMPAIGN_MESSAGES = gql`
  query campaignSchedules($campaignId: Int!) {
    campaignSchedules(campaignId: $campaignId) {
      id
      type
      numericValue
      temporalValue
      maxNumericValue
      maxTemporalValue
      messageType
      messagePreference
      title
      sortOrder
      campaignTemplates {
        id
        scheduleId
        sourceId
        isAfterHour
        afterHourTemplateText
        afterHourEmailTemplateText
        templateText
        emailTemplateText
        useAsTemplate
        afterHourEmailSubjectText
        emailSubjectText
      }
    }
  }
`;
export const GET_ALL_CAMPAIGN_SUMMARY = gql`
  query getCampaigns(
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $activeInd: [String]
  ) {
    getCampaigns(
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      activeInd: $activeInd
    ) {
      data {
        leadMessageCount {
          campaignId
          totalSent
          totalDelivered
          totalResponded
          totalUncontacted
          responseRate
          optOutRate
          totalEngaged
          avgAttemptsBeforeResponse
          soldOpportunityCount
          scheduledAppointmentCount
          rescheduledAppointmentCount
          showedAppointmentCount
          cancelledAppointmentCount
          noShowedAppointmentCount
          ottoAppointmentSchCount
          ottoAppointmentConfCount
          totalLeads
        }
      }
    }
  }
`;
export const GET_CAMPAIGN_DETAILS = gql`
  query campaign($campaignId: Int!, $startDate: DateTime, $endDate: DateTime) {
    campaign(campaignId: $campaignId, startDate: $startDate, endDate: $endDate) {
      data {
        leadMessageCount {
          campaignId
          totalSent
          totalDelivered
          totalResponded
          totalUncontacted
          responseRate
          optOutRate
          totalEngaged
          avgAttemptsBeforeResponse
          soldOpportunityCount
          scheduledAppointmentCount
          rescheduledAppointmentCount
          showedAppointmentCount
          cancelledAppointmentCount
          noShowedAppointmentCount
          ottoAppointmentSchCount
          ottoAppointmentConfCount
          totalLeads
        }
        # campaignSelections {
        #   id
        #   type
        #   value
        # }
        # campaignSchedules {
        #   id
        #   type
        #   numericValue
        #   temporalValue
        #   title
        #   sortOrder
        #   campaignTemplates {
        #     id
        #     scheduleId
        #     sourceId
        #     templateText
        #     activeInd
        #     isAfterHour
        #     afterHourTemplateText
        #   }
        # }
        # campaignTemplates {
        #   id
        #   scheduleId
        #   sourceId
        #   templateText
        #   activeInd
        #   isAfterHour
        #   afterHourTemplateText
        #   campaignSchedules {
        #     id
        #     type
        #     numericValue
        #     temporalValue
        #     title
        #     sortOrder
        #   }
        # }
      }
    }
  }
`;
export const GET_ALL_CAMPAIGN_TEMPLATES = gql`
  query getCampaignTemplates(
    $page: Int
    $pageSize: Int
    $search: String
    $campaignId: Int!
    $sourceId: Int
    $scheduleId: Int
  ) {
    getCampaignTemplates(
      page: $page
      pageSize: $pageSize
      search: $search
      campaignId: $campaignId
      sourceId: $sourceId
      scheduleId: $scheduleId
    ) {
      data {
        campaignId
        id
        sourceId
        scheduleId
        templateText
        activeInd
        isAfterHour
        afterHourTemplateText
        campaignSchedules {
          id
          type
          numericValue
          temporalValue
          title
          sortOrder
        }
        leadSource {
          id
          name
        }
      }
      count
    }
  }
`;
export const GET_CAMPAIGN_SCHEDULES = gql`
  query campaignSchedules($campaignId: Int!) {
    campaignSchedules(campaignId: $campaignId) {
      id
      type
      numericValue
      temporalValue
      maxNumericValue
      maxTemporalValue
      messagePreference
      title
      sortOrder
      messageType
      campaignTemplates {
        id
        scheduleId
        sourceId
        isAfterHour
        afterHourTemplateText
        afterHourEmailTemplateText
        templateText
        emailTemplateText
        useAsTemplate
        afterHourEmailSubjectText
        emailSubjectText
      }
    }
  }
`;

export const GET_MESSAGES = gql`
  query messages(
    $leadId: Int!
    $page: Int
    $pageSize: Int
    $campaignIds: [Int]
    $leadOpportunityId: Int
  ) {
    messages(
      leadId: $leadId
      page: $page
      pageSize: $pageSize
      campaignIds: $campaignIds
      leadOpportunityId: $leadOpportunityId
    ) {
      data {
        id
        systemUserId
        leadId
        userId
        user {
          firstName
          lastName
          fullName
          profilePic
        }
        # channelId
        # campaignId
        translatedContent
        campaign {
          name
        }
        # campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        translatedContent
        contentType
        messageType
        errorCode
        errorMessage
        # statusCode
        messageStatus
        messageFeedback
        mmsObjects {
          id
          mediaUrl
          mediaType
          thumbnail
          size
        }
        messageLog {
          id
          messageId
          toPhone
          fromPhone
        }
        trackingDetails {
          id
          actionType
          actionValue
        }
      }
      count
      lastId
      isRefresh
    }
  }
`;

export const GET_MESSAGES_V2 = gql`
  query messagesV2(
    $leadId: Int!
    $page: Int
    $pageSize: Int
    $campaignIds: [Int]
    $leadOpportunityId: Int
    $internalMessageId: Int
    $selectedOppTypeId: Int
  ) {
    messagesV2(
      leadId: $leadId
      page: $page
      pageSize: $pageSize
      campaignIds: $campaignIds
      leadOpportunityId: $leadOpportunityId
      internalMessageId: $internalMessageId
      selectedOppTypeId: $selectedOppTypeId
    ) {
      data {
        id
        systemUserId
        leadId
        messageNotesCount
        reasonForResponse
        userId
        # Reply-as (EAI-1530): the reply-as user the message is DISPLAYED as
        # (userId is the actual sender). The FE resolves the identity from its
        # user cache for the message avatar/name + the "on behalf of" tooltip.
        originalUserId
        user {
          id
          firstName
          lastName
          fullName
          profilePic
          companyRole {
            name
          }
          phone
          email
        }
        # channelId
        # campaignId
        translatedContent
        campaign {
          name
          method
          campaignType {
            type
          }
        }
        # campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        translatedContent
        contentType
        messageType
        hasLinkTracking
        errorCode
        errorMessage
        # statusCode
        messageStatus
        messageFeedback
        mmsObjects {
          id
          mediaUrl
          mediaType
          thumbnail
          size
        }
        messageLog {
          id
          messageId
          toPhone
          fromPhone
        }
        trackingDetails {
          id
          actionType
          actionValue
        }
        # Lead's free-text feedback response. Shown as a tooltip on the
        # "feedback submitted" tracking icon and in the View Feedback drawer.
        # user/leadOpportunity are nested here (not on a separate review
        # field) — BE contract for the review-response entity.
        reviewResponse {
          responseType
          comment
          commentTs
          user {
            id
            firstName
            lastName
            companyRole {
              name
            }
          }
          leadOpportunity {
            id
            leadId
            name
            # BE-resolved CRM deep-link. crmUrl is the plain URL string;
            # crmLink is the unified url+label payload. Together they let
            # Service / Repair-Order opps (e.g. Tekion, where tkLeadId is NULL
            # but tkRepairOrderId is set) render a correct clickable CRM id
            # instead of falling back to a non-linked EAI id. Mirrors the
            # opportunity card: prefer crmUrl, fall back to the FE-resolved link.
            crmUrl
            crmLink {
              url
              id
              prefix
              kind
            }
            vehiclesOfInterest {
              year
              make
              model
              customerInterest
              isPrimary
            }
          }
        }
        email {
          id
          from_
          to
          inReplyTo
          subject
          cc
          bcc
          createTs
          status
        }
        call {
          id
          callSid
          startedAt
          durationSeconds
          departmentType
          direction
          aiSentiment
          aiSummary
          aiTopics
          fromNumber
          fromName
          toNumber
          toName
          extraData
          lead {
            firstName
            lastName
            phoneNumbers {
              phone
              isPrimary
            }
          }
          user {
            firstName
            lastName
            phone
          }
          eaiCallerOutcome
          callRecordings {
            recordingUrl
          }
          callInitiationRequest {
            id
            callInitiationType
          }
        }
        # Notification-click flow needs the lead-opp id so we can
        # look the opp's root opp_type up in selectedLead.leadOpportunities
        # (already loaded by leadNew) and auto-switch the active tab to
        # match the message's root. MessageV2 only exposes the scalar
        # id - resolving the full LeadOpportunity row here would mean a
        # DB lookup per message, so we keep this lean and let the FE
        # do the join against the lead's already-cached opps.
        leadOpportunityId
      }
      count
      lastId
      isRefresh
    }
  }
`;

export const GET_CHANNEL = gql`
  query channel($id: Int!) {
    channel(id: $id) {
      id
      name
      channelType
    }
  }
`;

export const GET_MESSAGE_LOG = gql`
  query messageLog($id: Int!) {
    messageLog(id: $id) {
      id
      messageId
      fromPhone
      toPhone
    }
  }
`;

export const GET_COMPANY_USER_BY_ID = gql`
  query companyUserById($id: Int!) {
    companyUserById(id: $id) {
      id
      fullName
      firstName
    }
  }
`;

export const GET_SYSTEM_USER = gql`
  {
    systemUser {
      phone
    }
  }
`;

export const GET_ALL_VEHICLE_OF_INTEREST = gql`
  query getAllVoi(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
  ) {
    getAllVoi(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      make
      model
      year
      text
    }
  }
`;

export const GET_SOURCES_FROM_LEADS = gql`
  {
    getAllSourceOriginal
  }
`;

export const GET_LEADS_COUNT_BY_CAMPAIGN = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $leadStatusTypes: [Int]
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      leadStatusTypes: $leadStatusTypes
    ) {
      count
    }
  }
`;

export const GET_CAMPAIGN_LEAD_SUMMARY = gql`
  query getCampaignLeadSummary(
    $campaignId: Int
    $leadId: Int
    $attempt: [String]
    $status: [String]
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getCampaignLeadSummary(
      campaignId: $campaignId
      leadId: $leadId
      attempt: $attempt
      status: $status
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        campaignId
        leadId
        lastMessageSentDate
        lastMessageReceivedDate
        numAttemptsBeforeResponse
        status
        lead {
          id
          fullName
          firstName
          lastName
          companyId
          leadSourceType
          leadSourceOriginalId
          dateOfBirth
          leadCreatedDate
          emailConsent
          textConsent
          textConsentDate
          textConsentStatus
          status
          otherSource
          unreadCount
          leadStatusTypeId
          leadStatusType {
            id
            type
            status
          }
          emails {
            id
            email
            emailType
            isPrimary
          }
          phoneNumbers {
            id
            phone
            phoneType
            isPrimary
          }
          addresses {
            id
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
          vehicleOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          messages {
            id
            dateSent
            dateReceived
            messageStatus
            messageType
            content
            translatedContent
          }
          leadSource {
            id
            name
          }

          activeAppointment {
            id
            startDatetime
            appointmentStatus
            isConfirmed
          }
          consentExpireDay
          conversationStatus {
            id
            userId
            disableConversation
            createdOn
          }
          location {
            id
            title
            locationType
            timezone
          }
          leadUsers {
            userType {
              id
              useCase
              name
            }
            user {
              id
              firstName
              lastName
              companyRole {
                id
                name
              }
            }
          }
          campaignObj {
            campaigns {
              id
              name
            }
            activelyCampaign
          }
        }
      }
      count
    }
  }
`;

export const GET_ENGAGEMENT_ANALYTICS = gql`
  query getEngagementAnalytics(
    $range: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $opportunityTypeId: Int
    $teamIds: [Int]
  ) {
    getEngagementAnalytics(
      range: $range
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      opportunityTypeId: $opportunityTypeId
      teamIds: $teamIds
    ) {
      count
      status
      date
      attempts
    }
  }
`;
export const GET_USER_MESSAGE_ANALYSIS = gql`
  query getUserMessageAnalysis(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getUserMessageAnalysis(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        userFullName
        name
        value
      }
      count
    }
  }
`;
export const GET_ENGAGEMENT_LEADS_ANALYTICS = gql`
  query getEngagementLeadAnalytics($range: Int, $filterType: String) {
    getEngagementLeadAnalytics(range: $range, filterType: $filterType) {
      count
      status
      date
      source
    }
  }
`;

export const GET_LEADS_ANALYTICS = gql`
  query getLeadAnalytics($range: Int, $filterType: String) {
    getLeadAnalytics(range: $range, filterType: $filterType) {
      count
      source
    }
  }
`;

export const GET_APPOINTMENT_SOURCE = gql`
  query getAppointmentSource($range: Int) {
    getAppointmentSource(range: $range) {
      count
      source
    }
  }
`;

export const GET_APPOINTMENT_SALESPERSON = gql`
  query getAppointmentSalesperson($range: Int) {
    getAppointmentSalesperson(range: $range) {
      count
      userName
    }
  }
`;

export const GET_CRM_USERS = gql`
  {
    getCrmUsers {
      id
      userName
    }
  }
`;
export const GET_VIN_CRM_USER = gql`
  query getVinCrmUser($crmIntegrationId: Int!, $userId: Int!) {
    getVinCrmUser(crmIntegrationId: $crmIntegrationId, userId: $userId) {
      id
      userId
      vsUserId
      crmIntegrationId
    }
  }
`;
export const GET_SF_CRM_USER = gql`
  query getSfCrmUser($crmIntegrationId: Int!, $userId: Int!) {
    getSfCrmUser(crmIntegrationId: $crmIntegrationId, userId: $userId) {
      id
      userId
      sfUserId
      crmIntegrationId
    }
  }
`;

const TEMPLATES_QUERY_V2 = gql`
  query engagementMessageTemplates(
    $level: TemplateLevelEnum
    $companyId: Int
    $locationId: Int
    $departmentId: Int
    $opportunityTypeId: Int
    $isGlobal: Boolean
    $templateType: String
    $isActive: Boolean
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    engagementMessageTemplates(
      level: $level
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      opportunityTypeId: $opportunityTypeId
      isGlobal: $isGlobal
      templateType: $templateType
      isActive: $isActive
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      count
      data {
        id
        title
        message
        subject
        templateType
        level
        locationIds
        isActive
        isCompanyShared
        companyId
        locationId
        departmentId
        opportunityTypeId
        userId
        extraData
        updatedOn
        createdOn
        location {
          id
          title
        }
        user {
          id
          fullName
        }
      }
    }
  }
`;
// Pre-deploy schema: `templateType` doubles as the scope filter
// (ALL/OWN/COMPANY/LOCATION/GLOBAL) and is required, and the field returns a
// bare list with no paging. Kept so the app works before the API ships.
const TEMPLATES_QUERY_V1 = gql`
  query engagementMessageTemplates(
    $companyId: Int
    $userId: Int
    $isActive: Boolean
    $templateType: String!
    $search: String
    $locationId: Int
  ) {
    engagementMessageTemplates(
      companyId: $companyId
      userId: $userId
      isActive: $isActive
      templateType: $templateType
      search: $search
      locationId: $locationId
    ) {
      id
      title
      message
      userId
      companyId
      isActive
      isCompanyShared
      subject
      templateType
      updatedOn
      createdOn
      location {
        id
        title
      }
      user {
        id
        fullName
      }
    }
  }
`;

export const GET_ENGAGEMENT_MESSAGE_TEMPLATES = isTemplatesV2()
  ? TEMPLATES_QUERY_V2
  : TEMPLATES_QUERY_V1;

export const GET_USER_APPOINTMENTS = gql`
  query getUserAppointment(
    $userIds: [Int]
    $opportunityTypeId: Int
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $startDate: Date
    $endDate: Date
    $companyId: Int
    $appointmentStatus: [String]
    $leadId: Int
  ) {
    getUserAppointment(
      userIds: $userIds
      opportunityTypeId: $opportunityTypeId
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      startDate: $startDate
      endDate: $endDate
      companyId: $companyId
      appointmentStatus: $appointmentStatus
      leadId: $leadId
    ) {
      data {
        id
        leadOpportunityId
        companyId
        isConfirmed
        isLastActionByLead
        leadId
        userId
        startDatetime
        endDatetime
        uid
        description
        location
        locationId
        dateUpdated
        createdBy {
          id
          fullName
          dateCreated
        }
        updatedBy {
          id
          fullName
          dateCreated
        }
        sequence
        status
        summary
        leadEmail
        leadPhone
        timezone
        appointmentStatus
        isConfirmed
        discussedVoiId
        user {
          id
          fullName
          companyRoleId
          companyRole {
            id
            name
          }
        }
        lead {
          id
          fullName
          firstName
          lastName
          dateOfBirth
          leadSourceType
          leadSourceOriginalId
          companyId
          leadFileId
          crmIntegrationId
          status
          emailConsent
          emailConsentDate
          textConsent
          textConsentDate
          textConsentStatus
          otherSource
          disableConversation
          leadStatusType {
            id
            type
            status
          }
          emails {
            id
            leadId
            email
            emailType
            isPrimary
          }
          phoneNumbers {
            id
            leadId
            phone
            phoneType
            lookupType
            isPrimary
          }
          addresses {
            id
            leadId
            locationText
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
          vehicleOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          leadVehicleInventory {
            id
            make
            model
            year
            trim
            stockNumber
            vin
          }
          leadSource {
            id
            name
          }
        }
        leadOpportunity {
          dsOpportunityEvents {
            dsEventId
          }
          sfLeadOpportunities {
            sfOpportunityId
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          id
          leadId
          name
        }
      }
      count
    }
  }
`;
export const GET_APPOINTMENT_ANALYSIS = gql`
  query getAppointmentAnalysis(
    $range: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $dateType: String
    $opportunityTypeId: Int
  ) {
    getAppointmentAnalysis(
      range: $range
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      dateType: $dateType
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        title
        count
        prevCount
        growthRate
      }
      totalNewLeads
      totalAppointments
      totalBookedAppointments
      appointmentBookingRate
      percentageChange
    }
  }
`;
export const GET_APPOINTMENTS_BY_SOURCE = gql`
  query getAppointmentSource($range: Int, $filterType: String) {
    getAppointmentSource(range: $range, filterType: $filterType) {
      count
      source
    }
  }
`;
export const GET_APPOINTMENTS_BY_SALES_PERSON = gql`
  query getAppointmentSalesperson(
    $range: Int
    $filterType: String
    $page: Int
    $pageSize: Int
    $userIds: [Int]
    $teamIds: [Int]
    $outputFormat: String
    $fields: [String]
    $orderDirection: String
    $orderBy: String
    $dateRange: [DateTime]
    $dateType: String
    $viewMode: String
    $opportunityTypeId: Int
  ) {
    getAppointmentSalesperson(
      range: $range
      filterType: $filterType
      page: $page
      pageSize: $pageSize
      userIds: $userIds
      teamIds: $teamIds
      outputFormat: $outputFormat
      fields: $fields
      orderDirection: $orderDirection
      orderBy: $orderBy
      dateRange: $dateRange
      dateType: $dateType
      viewMode: $viewMode
      opportunityTypeId: $opportunityTypeId
    ) {
      count
      data {
        user {
          fullName
          profilePic
          id
        }
        scheduled
        cancelled
        showed
        noShowed
        confirmed
        rescheduled
        sold
        totalAppointments
      }
      totals {
        scheduled
        rescheduled
        showed
        cancelled
        noShowed
        confirmed
        sold
        totalAppointments
      }
      distributedData {
        user {
          fullName
        }
        name
        value
      }
    }
  }
`;
export const GET_MESSAGES_BY_SALES_PERSON = gql`
  query getMessagesBySalesperson(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getMessagesBySalesperson(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      count
      data {
        user {
          id
          firstName
          lastName
          email
        }
        textOttoSent
        textAiAssistedSent
        # textAiAcceptedSent
        # textAiModifiedSent
        textManualSent
        textReceived
        emailOttoSent
        emailAiAssistedSent
        # emailAiAcceptedSent
        # emailAiModifiedSent
        emailManualSent
        emailReceived
        callOutbound
        callInbound
        totalMessages
      }
      totals {
        textOttoSent
        textAiAssistedSent
        # textAiAcceptedSent
        # textAiModifiedSent
        textManualSent
        textReceived
        emailOttoSent
        emailAiAssistedSent
        # emailAiAcceptedSent
        # emailAiModifiedSent
        emailManualSent
        emailReceived
        callOutbound
        callInbound
        totalMessages
      }
    }
  }
`;
export const GET_ACTIVITIES_BY_SALES_PERSON = gql`
  query getActivitiesBySalesperson(
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getActivitiesBySalesperson(
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      count
      totals {
        createdCount
        assignedCount
        upcoming
        overdue
        completed
      }
      data {
        user {
          id
          firstName
          lastName
          email
        }
        createdCount
        assignedCount
        upcoming
        overdue
        completed
      }
    }
  }
`;

export const GET_OPPORTUNITY_BY_SALES_PERSON = gql`
  query GetOpportunityBySalesPerson(
    $locationIds: [Int]
    $columnStatusIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $viewMode: String
    $orderBy: String
    $orderDirection: String
    $dateType: String
    $opportunityTypeId: Int
  ) {
    getOpportunityBySalesPerson(
      locationIds: $locationIds
      columnStatusIds: $columnStatusIds
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      viewMode: $viewMode
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateType: $dateType
      opportunityTypeId: $opportunityTypeId
    ) {
      totalCount
      statusTotals {
        statusId
        statusName
        totalCount
      }
      data {
        userId
        userName
        userProfileImage
        companyRoleName
        totalOpportunities
        totalCount
        statusCounts {
          statusId
          statusName
          count
          totalCount
          children {
            statusId
            statusName
            count
            totalCount
            children {
              statusId
              statusName
              count
              totalCount
            }
          }
        }
      }
    }
  }
`;
export const GET_COMPANY_WORK_HOURS = gql`
  query getCompanyWorkingHours($companyId: Int!, $locationId: Int!, $isBusinessHour: Boolean) {
    getCompanyWorkingHours(
      companyId: $companyId
      locationId: $locationId
      isBusinessHour: $isBusinessHour
    ) {
      id
      companyId
      weekDay
      isWorkingDay
      startTime
      endTime
    }
  }
`;

export const GET_LEAD_COUNT_BY_STATUS = gql`
  {
    leadsByStatus {
      count
      status
    }
  }
`;

// export const GET_COMPANY_PHONE_BOTS = gql`
//   query getTwilioPhoneServices(
//     $companyId: Int!
//     $locationId: Int
//     $search: String
//     $orderBy: String
//     $orderDirection: String
//   ) {
//     getTwilioPhoneServices(
//       companyId: $companyId
//       locationId: $locationId
//       search: $search
//       orderBy: $orderBy
//       orderDirection: $orderDirection
//     ) {
//       data {
//         id
//         companyId
//         userId
//         type
//         serviceName
//         description
//         isActive
//         twilioAccountSid
//         twilioAuthToken
//         locationId
//         location {
//           id
//           title
//         }
//         user {
//           id
//           email
//           firstName
//           lastName
//           phone
//           locationId
//         }
//       }
//       count
//       message
//       statusCode
//     }
//   }
// `;
export const GET_COMPANY_PHONE_BOTS = gql`
  query getPhoneServices(
    $companyId: Int!
    $locationId: Int
    $types: [String]
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getPhoneServices(
      companyId: $companyId
      locationId: $locationId
      types: $types
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      count
      data {
        id
        phoneServiceProvider
        type
        serviceName
        description
        createdOn
        updatedOn
        isActive
        isDeleted
        accountSid
        authToken
        messagingProfileId
        voiceApiKey
        voiceApiSecret
        voiceTwimlSid
        extraData
        userId
        user {
          phone
        }
        locationId
        location {
          id
          title
        }
      }
    }
  }
`;

export const GET_LEAD_STATUS_TYPES = gql`
  {
    leadStatusTypes {
      id
      status
      type
    }
  }
`;
export const GET_ALL_VEHICLES = gql`
  {
    vehicleOfInterest {
      id
      year
      model
      make
    }
  }
`;

export const GET_VEHICLE_MAKES = gql`
  query getVehicleMakes($search: String) {
    getVehicleMakes(search: $search) {
      data {
        MakeId
        MakeName
      }
      count
    }
  }
`;
export const GET_VEHICLE_MODELS = gql`
  query getVehicleModels($makeName: String!, $year: Int!, $search: String) {
    getVehicleModels(makeName: $makeName, year: $year, search: $search) {
      data {
        ModelId
        ModelName
        VehicleTypeName
      }
      count
    }
  }
`;
export const GET_MEDIA_GALLERY_DETAILS = gql`
  query getMediaGalleryDetails($mediaGalleryCode: String!, $isLeadOpen: Boolean) {
    getMediaGalleryDetails(mediaGalleryCode: $mediaGalleryCode, isLeadOpen: $isLeadOpen) {
      company {
        id
        profilePic
        name
        isGlobalCrm
        timezone
      }
      location {
        id
        title
      }
      mediaUrls {
        mediaUrl
        thumbnail
        mediaType
        mmsObjectId
        messageId
      }
      statusCode
      message
    }
  }
`;
export const GET_APPOINTMENTS_FOR_CUSTOMER = gql`
  query getLeadAppointmentDetails($appointmentId: String!) {
    getLeadAppointmentDetails(appointmentId: $appointmentId) {
      appointment {
        id
        startDatetime
        timezone
        extraData
        lead {
          id
          fullName
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
        }
      }
      prevAppointment {
        id
        startDatetime
        timezone
        discussedVoiId
        extraData
      }
      workingHours {
        id
        weekDay
        isWorkingDay
        startTime
        endTime
      }
      isRescheduled
      activeAppointments {
        id
        startDatetime
        endDatetime
        status
        leadId
        appointmentStatus
        timezone
        lead {
          id
          fullName
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
        }
      }
      company {
        id
        profilePic
        name
        isGlobalCrm
        timezone
      }
      location {
        id
        title
        settings
      }
      user {
        id
        firstName
        lastName
      }
      lead {
        id
        firstName
        lastName
        fullName
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
      }

      statusCode
      message
      resolvedLeadOpportunityId
    }
  }
`;
export const GET_CAMPAIGN_BY_LEAD = gql`
  query getCampaignByLead($leadId: Int!, $page: Int, $pageSize: Int) {
    getCampaignByLead(leadId: $leadId, page: $page, pageSize: $pageSize) {
      data {
        id
        name
        startDate
        endDate
        method
        textMessage
        activeInd
        isDisabled
        isPrioritize
        # campaignSelections {
        #   id
        #   type
        #   value
        #   campaignId
        # }
        # campaignTemplates {
        #   id
        #   scheduleId
        #   sourceId
        #   templateText
        #   activeInd
        #   isAfterHour
        #   afterHourTemplateText
        #   campaignSchedules {
        #     id
        #     type
        #     numericValue
        #     temporalValue
        #     sortOrder
        #     title
        #   }
        # }
        # campaignSchedules {
        #   id
        #   type
        #   numericValue
        #   temporalValue
        #   title
        #   sortOrder
        # }
        user {
          id
          fullName
          firstName
          lastName
        }
        leadMessageCount {
          campaignId
          totalSent
          totalDelivered
          totalResponded
          totalUncontacted
          responseRate
          optOutRate
          totalEngaged
          avgAttemptsBeforeResponse
          soldOpportunityCount
          scheduledAppointmentCount
          rescheduledAppointmentCount
          showedAppointmentCount
          cancelledAppointmentCount
          noShowedAppointmentCount
          ottoAppointmentSchCount
          ottoAppointmentConfCount
          totalLeads
        }
      }
      count
    }
  }
`;
export const GET_CAMPAIGN_DROPDOWN_BY_LEAD = gql`
  query getCampaignByLead($leadId: Int!, $page: Int, $pageSize: Int) {
    getCampaignByLead(leadId: $leadId, page: $page, pageSize: $pageSize) {
      data {
        id
        name
      }
    }
  }
`;
export const GET_CAMPAIGN_NUDGE_EVENT = gql`
  query getCompanyNudgeEvent($companyId: Int!, $locationId: Int) {
    getCompanyNudgeEvent(companyId: $companyId, locationId: $locationId) {
      nudgeEvent {
        id
        code
        title
      }
      companyNudgeEvent {
        id
        nudgeEventId
        startDelay
        startDelayType
        frequency
        frequencyType
        firstTemplateText
        reminderTemplateText
        isSms
        isEmail
        parentTemplateText
        isWebPush
        isActive
        reminderCount
        assignedUserId
        tentativeTemplateText
        tentativeReminderTemplateText
      }
    }
  }
`;

// EAI-1598 — per-user nudge preferences. Passing assignedUserId makes the
// resolver return ONLY the caller's own override rows (company/location
// fallback rows are excluded). extraData carries notify_every_page_view.
export const GET_MY_NUDGE_PREFERENCES = gql`
  query getMyNudgePreferences($companyId: Int!, $assignedUserId: Int!) {
    getCompanyNudgeEvent(companyId: $companyId, assignedUserId: $assignedUserId) {
      nudgeEvent {
        id
        code
        title
      }
      companyNudgeEvent {
        id
        nudgeEventId
        startDelay
        startDelayType
        frequency
        frequencyType
        firstTemplateText
        reminderTemplateText
        isSms
        isEmail
        parentTemplateText
        isWebPush
        isActive
        reminderCount
        assignedUserId
        extraData
        tentativeTemplateText
        tentativeReminderTemplateText
      }
    }
  }
`;
export const GET_REGIONS = gql`
  query getRegions($companyId: Int!) {
    getRegions(companyId: $companyId) {
      id
      name
      isDefault
      isActive
    }
  }
`;

export const GET_LOCATIONS = gql`
  query getLocations($companyId: Int!, $isAllLocations: Boolean) {
    getLocations(companyId: $companyId, isAllLocations: $isAllLocations) {
      id
      companyId
      regionId
      locationType
      title
      phone
      email
      addressLine1
      city
      state
      postalCode
      country
      geoLink
      website
      timezone
      isActive
      isDefault
      region {
        id
        name
      }
      crmIntegration {
        integrationType
        active
      }
      settings
    }
  }
`;
export const GET_ALL_LOCATIONS = gql`
  query getAllLocations($companyId: Int!, $search: String, $isActive: Boolean) {
    getAllLocations(companyId: $companyId, search: $search, isActive: $isActive) {
      id
      companyId
      regionId
      locationType
      title
      phone
      email
      addressLine1
      city
      state
      postalCode
      country
      geoLink
      website
      timezone
      isActive
      isDefault
      inventoryUrlFormat
      region {
        id
        name
      }
      workingHours {
        id
      }
      opportunityStatuses {
        id
      }
      openaiApiKey
      notes
      settings
      opportunityType {
        id
        name
      }
      departments {
        id
        name
      }
    }
  }
`;
export const GET_SALESFORCE_STATUS = gql`
  {
    getSfLeadStatus {
      id
      sfLeadStatusId
      sfLeadStatus
      leadStatusTypeId
    }
  }
`;

export const GET_PAGINATED_REVIEW_MESSAGE_TEMPLATE = gql`
  query GetPaginatedReviewMessageTemplate {
    getPaginatedReviewMessageTemplate(companyId: 1, userId: 2) {
      data {
        fileName
        fileLocation
        fullFilePath
      }
      count
    }
  }
`;

export const GET_REVIEW_DATA = gql`
  query GetReviewData {
    getReviewData {
      data
    }
  }
`;

export const GET_REVIEW_INFO = gql`
  query GetReviewInfo($companyId: Int!, $locationId: Int) {
    getReviewInfo(companyId: $companyId, locationId: $locationId) {
      id
      companyId
      locationId
      facebookLink
      googleLink
      yelpLink
      dealerRaterAccessToken
      dealerRaterDealerId
      dealerRaterReviewFormLink
      isActive
    }
  }
`;

export const GET_SOCIAL_REVIEW_SETTINGS = gql`
  query getSocialReviewSettings(
    $companyId: Int!
    $locationIds: [Int]
    $platform: String
    $search: String
    $opportunityTypeId: Int
    $departmentId: Int
  ) {
    getSocialReviewSettings(
      companyId: $companyId
      locationIds: $locationIds
      platform: $platform
      search: $search
      opportunityTypeId: $opportunityTypeId
      departmentId: $departmentId
    ) {
      id
      companyId
      locationId
      departmentId
      opportunityTypeId
      platform
      platformUrl
      reviewPostUrl
      state
      accountId
      accountLocationId
      isActive
      lastFetchTs
      siteName
      isPrimary
      isOauthConnected
      businessName
      pageName
      location {
        id
        title
        city
        state
        country
        postalCode
        locationType
        isActive
      }
      department {
        id
        name
      }
      opportunityType {
        id
        name
      }
    }
  }
`;

export const GET_SOCIAL_REVIEW = gql`
  query GetSocialReview {
    getSocialReview {
      data
      count
    }
  }
`;

export const GET_PAGINATED_SOCIAL_REVIEW = gql`
  query GetPaginatedSocialReview(
    $companyId: Int!
    $locationIds: [Int]!
    $rating: [Int]
    $timestamp: [DateTime]
    $platform: [String]
    $status: [String]
    $timeline: DateTime
    $older: DateTime
    $userIds: [Int]
    $page: Int
    $pageSize: Int
    $search: String
    $isAiGenerated: Boolean
    $isDeleted: Boolean
    $reviewId: Int
    $filterType: String
    $orderBy: String
    $orderDirection: String
    $isLeadReviews: Boolean
    $opportunityTypeIds: [Int]
    $teamIds: [Int]
  ) {
    getPaginatedSocialReview(
      companyId: $companyId
      locationIds: $locationIds
      rating: $rating
      timestamp: $timestamp
      platform: $platform
      status: $status
      timeline: $timeline
      older: $older
      userIds: $userIds
      page: $page
      pageSize: $pageSize
      search: $search
      isAiGenerated: $isAiGenerated
      isDeleted: $isDeleted
      reviewId: $reviewId
      filterType: $filterType
      orderBy: $orderBy
      orderDirection: $orderDirection
      isLeadReviews: $isLeadReviews
      opportunityTypeIds: $opportunityTypeIds
      teamIds: $teamIds
    ) {
      data {
        id
        companyId
        locationId
        url
        authorName
        rating
        commentTs
        updateTs
        comment
        respondentName
        respondentImageUrl
        respondentCommentTs
        respondentComment
        status
        authorImageUrl
        leadId
        isAiGenerated
        isDeleted
        socialReviewSettings {
          platform
          platformUrl
          reviewPostUrl
          opportunityType {
            id
            name
            parentType {
              id
              name
              parentType {
                id
                name
              }
            }
          }
        }
        reviewUser {
          id
          socialReviewId
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
        }
        location {
          id
          title
        }
        lead {
          id
          fullName
          phoneNumbers {
            id
            phone
          }
          leadOpportunities {
            id
            dsOpportunityEvents {
              id
              dsEventId
            }
          }
        }
        reviewResponses {
          id
          authorName
          authorImageUrl
          comment
          commentTs
          updateTs
          reviewResponses {
            id
            authorName
            authorImageUrl
            comment
            commentTs
            updateTs
            reviewResponses {
              id
              authorName
              authorImageUrl
              comment
              commentTs
              updateTs
            }
          }
        }
      }
      count
    }
  }
`;

export const GET_VEHICLE_INVENTORY = gql`
  query getDsVehicleInventory($page: Int, $pageSize: Int, $search: String) {
    getDsVehicleInventory(page: $page, pageSize: $pageSize, search: $search) {
      data {
        id
        crmIntegrationId
        vehicleOfInterestId
        dsDealerId
        stockNumber
        isNew
        modelNumber
        vin
        stock
        vehicleOfInterest {
          id
          year
          make
          model
        }
      }
      count
    }
  }
`;

export const GET_CRM_INTEGRATION_TYPES = gql`
  query GetCrmIntegrationTypes {
    getCrmIntegrationTypes {
      key
      value
    }
  }
`;

export const GET_CRM_LEAD_STATUS_MAPPING = gql`
  query GetCrmLeadStatusMapping($crmIntegrationType: String) {
    getCrmLeadStatusMapping(crmIntegrationType: $crmIntegrationType) {
      data {
        mappingId
        smaiType
        smaiStatus
        crmStatus
        parentCrmStatus
        crmType
      }
    }
  }
`;

export const GET_CRM_LEAD_STATUS = gql`
  query GetCrmLeadStatus {
    getCrmLeadStatus {
      data {
        id
        statusTypeId
        type
        status
        subStatus {
          id
          statusTypeId
          type
          status
        }
      }
      crmIntegrationType
    }
  }
`;

export const GET_OPPORTUNITY_STATUS = gql`
  query getOpportunityStatus(
    $companyId: Int
    $locationIds: [Int]
    $opportunityTypeId: Int
    $fetchAll: Boolean
  ) {
    getOpportunityStatus(
      companyId: $companyId
      locationIds: $locationIds
      opportunityTypeId: $opportunityTypeId
      fetchAll: $fetchAll
    ) {
      id
      name
      parentStatusId
      isDefault
      opportunityType {
        id
        name
        parentType {
          id
          name
        }
      }
      parentStatus {
        id
        name
        isDefault
      }
      companyId
      locationId
    }
  }
`;

export const GET_CRM_INTEGRATION_TYPE = gql`
  query GetCrmLeadStatus {
    getCrmLeadStatus {
      crmIntegrationType
    }
  }
`;

export const GET_LEADS_BY_CAMPAIGN = gql`
  query getCampaignLeads($campaignId: Int, $isCheckNewLead: Boolean) {
    getCampaignLeads(campaignId: $campaignId, isCheckNewLead: $isCheckNewLead) {
      data {
        id
        fullName
        firstName
        lastName
        leadStatusTypeId
        status
        phoneNumbers {
          id
          phone
          phoneType
          isPrimary
        }
        emails {
          id
          email
          emailType
          isPrimary
        }
        campaignObj {
          campaigns {
            id
            name
            activeInd
          }
          activelyCampaign
        }
      }
      count
    }
  }
`;
export const GET_COMPANY_APPOINTMENT_SETTING_EVENTS = gql`
  query getCompanyAppointmentSettingEvent($companyId: Int, $locationId: Int) {
    getCompanyAppointmentSettingEvent(companyId: $companyId, locationId: $locationId) {
      appointmentSettingEvent {
        id
        code
        title
        isActive
      }
      companyAppointmentSettingEvent {
        id
        appointmentSettingEventId
        companyId
        templateText
        isSms
        isEmail
        isActive
        startDelay
        startDelayType
        tentativeTemplateText
      }
    }
  }
`;

export const GET_COMPANY_ROLES = gql`
  query getCompanyRole($companyId: Int!, $locationIds: [Int], $search: String) {
    getCompanyRole(companyId: $companyId, locationIds: $locationIds, search: $search) {
      id
      name
      isSmaiRole
      isOpenCrmWarningPopup
      isActive
      parentRoleId
      location {
        id
        title
      }
      locations {
        location {
          id
          title
        }
      }
      parentRole {
        id
        name
      }
      createdBy {
        id
        fullName
      }
      updatedBy {
        id
        fullName
      }
      users {
        id
        fullName
      }
      location {
        title
      }
      createTs
      updateTs
    }
  }
`;

export const GET_COMPANY_CONSENT_SETTING_EVENTS = gql`
  query getCompanyConsentTemplateEvent($companyId: Int, $locationId: Int) {
    getCompanyConsentTemplateEvent(companyId: $companyId, locationId: $locationId) {
      consentTemplateEvent {
        id
        code
        title
        isActive
      }
      companyConsentTemplateEvent {
        id
        consentTemplateEventId
        companyId
        templateText
        afterTextMode
        isActive
        onlyFirstMessage
      }
    }
  }
`;

export const GET_COMPANY_CONSENT_TEMPLATES = gql`
  query getConsentTemplateMessage {
    getConsentTemplateMessage {
      content
      statusCode
      message
    }
  }
`;

export const GET_COMPANY_AFTER_MESSAGE_CONSENT_TEMPLATE = gql`
  query getAfterMessageText {
    getAfterMessageText {
      content
      onlyFirstMessage
      statusCode
      message
      isActive
    }
  }
`;
export const GET_LEADS_BY_PHONE = gql`
  query getLeadsSearch(
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $locationId: Int
    $search: String
    $firstName: String
    $lastName: String
    $phone: String
    $email: String
    $crmIntegrationType: String
    $crmDealerId: String
    $crmSiteId: String
    $crmLeadId: String
    $crmOpportunityId: String
  ) {
    getLeadsSearch(
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      locationId: $locationId
      search: $search
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      email: $email
      crmIntegrationType: $crmIntegrationType
      crmDealerId: $crmDealerId
      crmSiteId: $crmSiteId
      crmLeadId: $crmLeadId
      crmOpportunityId: $crmOpportunityId
    ) {
      data {
        id
        fullName
        firstName
        lastName
        otherSource
        unreadCount
        campaignAutoResponse
        leadCreatedDate
        leadSourceOriginalId
        leadSourceType
        textConsentStatus
        textConsent
        textConsentDate
        preferredLanguageCode
        status
        leadUsers {
          id
          userTypeId
          userType {
            name
          }
          userId
          user {
            id
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            name
            opportunityTypeId
            opportunityType {
              id
              name
              parentTypeId
              parentType {
                id
                name
                parentTypeId
                parentType {
                  id
                  name
                }
              }
            }
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
        }
        potentialLeads
        mergeHistory
        activeAppointment {
          id
          appointmentStatus
          dateCreated
          dateUpdated
          endDatetime
          isConfirmed
          startDatetime
          timezone
          summary
          description
          leadOpportunityId
          userId
          leadOpportunity {
            id
            name
          }
          createdBy {
            id
            fullName
          }
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          isActive
          location {
            id
            title
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
        }
        messageStatusType {
          status
        }
        messages {
          content
          id
          leadId
          userId
          direction
          dateSent
          dateReceived
          translatedContent
          messageStatus
          contentType
          messageType
          user {
            fullName
          }
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
        }
        emails {
          id
          email
          emailType
          isPrimary
        }
        location {
          id
          title
          locationType
          timezone
          settings
        }
        leadCreatedDate
      }
      count
    }
  }
`;
export const GET_ENGAGEMENT_TEMPLATE_TEXT = gql`
  query getEngagementTemplateText(
    $leadId: Int!
    $content: String!
    $leadOpportunityId: Int
    $oppTypeId: Int
  ) {
    getEngagementTemplateText(
      leadId: $leadId
      content: $content
      leadOpportunityId: $leadOpportunityId
      oppTypeId: $oppTypeId
    ) {
      content
      unknownVariables
      statusCode
      message
    }
  }
`;
export const GET_REVIEW_TEMPLATE_EVENTS = gql`
  query getCompanyReviewTemplateEvent(
    $companyId: Int
    $locationId: Int
    $departmentId: Int
    $opportunityTypeId: Int
  ) {
    getCompanyReviewTemplateEvent(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      opportunityTypeId: $opportunityTypeId
    ) {
      reviewTemplateEvent {
        id
        code
        title
        isActive
      }
      companyReviewTemplateEvent {
        id
        reviewTemplateEventId
        companyId
        locationId
        departmentId
        opportunityTypeId
        templateText
        isActive
        department {
          id
          name
        }
        opportunityType {
          id
          name
        }
      }
    }
  }
`;

export const GET_LEAD_REVIEW_DETAILS = gql`
  query getLeadReviewDetail($token: String!) {
    getLeadReviewDetail(token: $token) {
      headerContent
      companyId
      locationId
      authToken
      userId
      leadId
      lead {
        id
        fullName
        preferredLanguageCode
      }
      reviewLink
      company {
        profilePic
        name
      }
      location {
        title
      }
      socialReviewSettings {
        platform
        platformUrl
        reviewPostUrl
        isActive
        isPrimary
        siteName
      }
    }
  }
`;

export const GET_INITIAL_REVIEW_MESSAGE = gql`
  query getInitialReviewMessage($leadId: Int!, $leadOpportunityId: Int) {
    getInitialReviewMessage(leadId: $leadId, leadOpportunityId: $leadOpportunityId) {
      content
      statusCode
      message
    }
  }
`;
export const GET_REVIEW_LINK = gql`
  query getReviewLink($leadId: Int!, $templateText: String!) {
    getReviewLink(leadId: $leadId, templateText: $templateText) {
      content
      reviewLink
      statusCode
      message
    }
  }
`;
export const GET_SHORTEN_URL = gql`
  query getShortenUrlValue($code: String!) {
    getShortenUrlValue(code: $code) {
      value
      statusCode
      message
    }
  }
`;
export const GET_PERMISSION_ACTION_GROUP = gql`
  query getPermissionActionGroup($companyRoleId: Int, $userId: Int) {
    getPermissionActionGroup(companyRoleId: $companyRoleId, userId: $userId) {
      permissionObj {
        permissionId
        permissionTitle
        permissionCode
        permissionActions {
          permissionActionId
          actionId
          actionTitle
          actionCode
          isCheck
          extraData
        }
      }
    }
  }
`;
export const GET_GENERAL_TEMPLATE_EVENTS = gql`
  query getGeneralSettings($companyId: Int, $locationId: Int) {
    getGeneralSettings(companyId: $companyId, locationId: $locationId) {
      companyGeneralTemplateSettingEvents {
        generalTemplateSettingEvent {
          id
          code
          title
          isActive
        }
        companyGeneralTemplateSetting {
          id
          generalTemplateSettingEventId
          templateText
          isNudge
          isAppointment
          isConsent
          isReview
          isOtto
          isActive
          minutesAfterClose
          minutesBeforeOpen
          snoozeStart
          snoozeEnd
          isNonWorkDaySnooze
        }
      }
      crmIntegrationSetting {
        id
        crmIntegrationId
        isSendSmsAppointment
        isSendSmsSoldLead
        isSendSmsNewLead
        isSendEmailAppointment
        isSendEmailSoldLead
        isSendEmailNewLead
      }
    }
  }
`;
export const GET_USER_ACCESS_PERMISSIONS = gql`
  query getUserPermissionActions {
    getUserPermissionActions
  }
`;

export const GET_CUSTOMER_TYPES = gql`
  query getCustomerType {
    getCustomerType {
      customerType {
        id
        type
        isActive
      }
      customerSubTypes {
        id
        type
      }
    }
  }
`;

export const GET_LEAD_PHONE_LOCATION = gql`
  query getLeadPhoneLocation($phone: String!) {
    getLeadPhoneLocation(phone: $phone) {
      id
      title
      company {
        id
        name
      }
    }
  }
`;

export const GET_INDUSTRIES = gql`
  query getIndustries {
    getIndustries {
      id
      name
      isActive
    }
  }
`;
export const GET_OPPORTUNITTIES_TYPES = gql`
  query getOpportunityTypes($industryId: Int) {
    getOpportunityTypes(industryId: $industryId) {
      id
      name
      isActive
      parentType {
        id
        name
        isActive
      }
      industry {
        id
        name
        isActive
      }
    }
  }
`;

export const GET_OPPORTUNITY_USER_TYPE = gql`
  query getOpportunityUserTypes($locationId: Int!, $companyId: Int, $opportunityTypeId: Int) {
    getOpportunityUserTypes(
      locationId: $locationId
      companyId: $companyId
      opportunityTypeId: $opportunityTypeId
    ) {
      id
      companyId
      locationId
      opportunityTypeId
      opportunityType {
        name
      }
      name
      isActive
      isRequired
    }
  }
`;

// Reply-As saved preferences (EAI-1530). Returns a JSON scalar:
// { default_rules: [{ opportunity_type_id, rule_type, opportunity_user_type_id? }], lead_overrides: [] }
export const REPLY_AS_PREFERENCE = gql`
  query replyAsPreference($locationId: Int) {
    replyAsPreference(locationId: $locationId)
  }
`;

export const GET_LEAD_LIST_ACTIVITY_CENTER = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $excludeDuplicate: Boolean
    $dsEventId: String
    $dsEntityId: String
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      excludeDuplicate: $excludeDuplicate
      dsEventId: $dsEventId
      dsEntityId: $dsEntityId
    ) {
      data {
        id
        fullName
        otherSource
        unreadCount
        leadCreatedDate
        leadSourceOriginalId
        textConsentStatus
        status
        location {
          id
        }
        messages {
          id
          dateReceived
          dateSent
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
        }
        leadVehicleInventory {
          id
          make
          model
          year
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }

        activeAppointment {
          id
          startDatetime
          timezone
          isConfirmed
          appointmentStatus
          extraData
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
        }
        leadStatusType {
          id
          type
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          leadOpportunityUsers {
            id
            leadOpportunity {
              name
              opportunityStatus {
                id
                name
                parentStatus {
                  id
                  name
                }
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          opportunityTypeId
          opportunityStatusId
          opportunitySourceId
          opportunityType {
            id
            name
            parentTypeId
            parentType {
              id
              name
              parentTypeId
              parentType {
                id
                name
              }
            }
          }
          serviceRosCount
          serviceRos {
            id
            roNumber
            roStatus
            roStatusDesc
            totalAmt
            closedRoDate
            updateDate
            year
            make
            model
            vin
          }
          opportunityStatus {
            id
            name
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
        }
      }
      count
    }
  }
`;

export const GET_LEAD_LIST_ACTIVITY_CENTER_V2 = gql`
  query getLeadsV2(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $excludeDuplicate: Boolean
    $dsEventId: String
    $dsEntityId: String
  ) {
    getLeadsV2(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      excludeDuplicate: $excludeDuplicate
      dsEventId: $dsEventId
      dsEntityId: $dsEntityId
    ) {
      data {
        id
        fullName
        otherSource
        unreadCount
        leadCreatedDate
        leadSourceOriginalId
        textConsentStatus
        status
        location {
          id
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
        }
        leadVehicleInventory {
          id
          make
          model
          year
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        activeAppointment {
          id
          startDatetime
          timezone
          isConfirmed
          appointmentStatus
          extraData
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            name
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
            dsOpportunityEvents {
              dsLeadId
              dsEventId
            }
            sfLeadOpportunities {
              sfLeadId
              sfOpportunityId
            }
            vsLeadOpportunities {
              vsContactId
              vsLeadId
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
          }
        }
      }
      count
    }
  }
`;

export const GET_EXTENSION_LIST_ACTIVITY_CENTER = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $excludeDuplicate: Boolean
    $dsEventId: String
    $dsEntityId: String
    $userTypesAnd: [UserTypeFilterAnd]
    $userTypesOr: [UserTypeFilterOr]
    $userIds: [Int]
    $prioritySortOrder: String
    $skipFilter: Boolean
    $leadId: Int
    $locationIds: [Int]
    $opportunityTypeIds: [Int]
    $opportunitySourceIds: [Int]
    $opportunityStatusIds: [Int]
    $crmIntegrationType: String
    $crmDealerId: String
    $crmSiteId: String
    $crmLeadId: String
    $crmOpportunityId: String
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $dateType: String
    # EAI-1765 tri-state: omitted = no pin filtering, true = pinned only,
    # false = unpinned only. The Pinned tab sends true; every other tab omits
    # it. Never send false here — it would hide pinned leads from "All".
    $isPinned: Boolean
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      excludeDuplicate: $excludeDuplicate
      dsEventId: $dsEventId
      dsEntityId: $dsEntityId
      userTypesAnd: $userTypesAnd
      userIds: $userIds
      userTypesOr: $userTypesOr
      prioritySortOrder: $prioritySortOrder
      skipFilter: $skipFilter
      leadId: $leadId
      locationIds: $locationIds
      opportunityTypeIds: $opportunityTypeIds
      opportunitySourceIds: $opportunitySourceIds
      opportunityStatusIds: $opportunityStatusIds
      crmIntegrationType: $crmIntegrationType
      crmDealerId: $crmDealerId
      crmSiteId: $crmSiteId
      crmLeadId: $crmLeadId
      crmOpportunityId: $crmOpportunityId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
      dateType: $dateType
      isPinned: $isPinned
    ) {
      data {
        id
        fullName
        firstName
        lastName
        otherSource
        unreadCount
        # EAI-1765: only resolve_get_leads populates this; other queries
        # returning Leads leave it null. Pins no longer affect ordering, so
        # this is the ONLY per-row signal that a lead is pinned.
        isPinned
        campaignAutoResponse
        leadCreatedDate
        leadSourceOriginalId
        leadSourceType
        textConsentStatus
        textConsent
        textConsentDate
        preferredLanguageCode
        status
        leadMessageSummary {
          engagementStatus
          replyState
        }
        leadUsers {
          id
          userTypeId
          userType {
            name
          }
          userId
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            name
            opportunityTypeId
            opportunityType {
              id
              name
              parentTypeId
              parentType {
                id
                name
                parentTypeId
                parentType {
                  id
                  name
                }
              }
            }
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
        }
        potentialLeads
        mergeHistory
        activeAppointment {
          id
          extraData
          appointmentStatus
          dateCreated
          dateUpdated
          endDatetime
          isConfirmed
          startDatetime
          timezone
          summary
          description
          leadOpportunityId
          userId
          leadOpportunity {
            id
            name
          }
          createdBy {
            id
            fullName
          }
        }
        activeAppointmentsByRootOppType {
          rootOppTypeId
          appointment {
            id
            extraData
            appointmentStatus
            dateCreated
            dateUpdated
            endDatetime
            isConfirmed
            startDatetime
            timezone
            summary
            description
            leadOpportunityId
            userId
            leadOpportunity {
              id
              name
            }
            createdBy {
              id
              fullName
            }
          }
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          isActive
          departmentId
          opportunityTypeId
          opportunityType {
            id
            name
            parentTypeId
            parentType {
              id
              name
              parentTypeId
              parentType {
                id
                name
              }
            }
          }
          location {
            id
            title
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            # The lead card owners row renders active owners only; without this
            # the field is undefined here and every owner gets filtered out.
            isActive
            # Readable owner type ("Primary Assigned", "BDC", …). Returned here
            # so the lead card reads it directly instead of joining against the
            # lead-level leadUsers array by userTypeId.
            userType {
              id
              name
            }
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
        }
        messageStatusType {
          status
        }
        messages {
          content
          id
          leadId
          userId
          direction
          dateSent
          dateReceived
          translatedContent
          messageStatus
          contentType
          messageType
          user {
            fullName
          }
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
        }
        emails {
          id
          email
          emailType
          isPrimary
        }
        location {
          id
          title
          locationType
          timezone
          settings
        }
        leadCreatedDate
      }
      count
      hasNotPermitted
      # EAI-1765: leads carrying unread messages across the WHOLE filtered
      # set, not this page — and a count of leads, not a sum of their
      # unreadCount values. Scoped by every argument above, isPinned included,
      # so the Pinned tab's request returns the pinned unread total.
      unreadLeadsCount
    }
  }
`;

export const GET_EXTENSION_LIST_ACTIVITY_CENTER_V2 = gql`
  query getLeadsV2(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $excludeDuplicate: Boolean
    $dsEventId: String
    $dsEntityId: String
    $userTypesAnd: [UserTypeFilterAnd]
    $userTypesOr: [UserTypeFilterOr]
    $userIds: [Int]
    $prioritySortOrder: String
    $skipFilter: Boolean
    $leadId: Int
  ) {
    getLeadsV2(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      excludeDuplicate: $excludeDuplicate
      dsEventId: $dsEventId
      dsEntityId: $dsEntityId
      userTypesAnd: $userTypesAnd
      userIds: $userIds
      userTypesOr: $userTypesOr
      prioritySortOrder: $prioritySortOrder
      skipFilter: $skipFilter
      leadId: $leadId
    ) {
      data {
        id
        fullName
        firstName
        lastName
        otherSource
        unreadCount
        leadCreatedDate
        leadSourceOriginalId
        textConsentStatus
        preferredLanguageCode
        status
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            name
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
        }
        activeAppointment {
          id
          appointmentStatus
          dateCreated
          dateUpdated
          endDatetime
          isConfirmed
          startDatetime
          timezone
          summary
          description
          leadOpportunityId
          userId
          leadOpportunity {
            id
            name
          }
        }
        leadOpportunities {
          id
          location {
            id
            title
          }
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
        }
        messageStatusType {
          status
        }
        messages {
          content
          id
          direction
          dateSent
          dateReceived
          # translatedContent
          user {
            fullName
          }
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        emails {
          id
          email
          emailType
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        location {
          id
        }
        leadCreatedDate
      }
      count
      hasNotPermitted
    }
  }
`;

export const GET_LEAD_DETAIL_ACTIVITY_CENTER = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      companyId
      leadStatusTypeId
      consentExpireDay
      textConsentDate
      emailConsent
      emailConsentDate
      preferredLanguageCode
      textConsentStatus
      addresses {
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      crmLeadObj {
        crmStatus
        parentCrmStatus
        activeLeadOpportunity {
          id
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
        }
        dsExtractedLead {
          id
          dsLeadId
          dsSource
        }
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
        dtExtractedLead {
          id
          dtLeadId
        }
      }
      leadStatusType {
        id
        type
      }

      leadSource {
        name
        id
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }
      location {
        id
        title
        locationType
        timezone
      }
      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
          firstName
          lastName
          companyRole {
            id
            name
          }
        }
      }

      addresses {
        id
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      leadVehicleInventory {
        id
        make
        model
        year
        trim
        stockNumber
        vin
      }
      conversationStatus {
        id
        disableConversation
        createdOn
      }
      leadOpportunities {
        id
        name
        isActive
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        location {
          id
          title
        }
        lead {
          id
          location {
            id
            title
          }
        }
        dtLeadOpportunities {
          id
          dtLeadSource {
            dtLeadSourceName
            leadSource {
              id
              name
            }
          }
          dtLeadStatusMapping {
            leadStatusType {
              id
              type
              status
            }
            dtLeadStatus
          }
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsLeadId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
          leadSource {
            name
          }
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          id
          dtOpportunityId
          dtOpportunityStage
        }
        tkLeadOpportunities {
          id
          tkLeadId
          tkContactId
          tkCustomerId
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
      }
    }
  }
`;
export const GET_LEAD_DETAIL_ACTIVITY_CENTER_V2 = gql`
  query lead($leadId: Int!) {
    leadNew(leadId: $leadId) {
      id
      fullName
      companyId
      leadStatusTypeId
      campaignAutoResponse
      consentExpireDay
      textConsentDate
      preferredLanguageCode
      textConsentStatus
      emailConsent
      emailConsentDate
      crmLeadObj {
        crmStatus
        parentCrmStatus
        activeLeadOpportunity {
          id
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
            bodyStyle
            condition
            mileage
            interiorColor
            exteriorColor
            extraData
          }
        }
        dsExtractedLead {
          id
          dsLeadId
          dsSource
        }
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
        dtExtractedLead {
          id
          dtLeadId
        }
        tkExtractedLead {
          id
          tkLeadId
        }
      }
      leadStatusType {
        id
        type
      }

      leadSource {
        name
        id
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }
      location {
        id
        title
        locationType
        timezone
        settings
        # Distinct root opportunity_type ids backing the location's
        # active Department rows. Drives the dynamic opp-type tab
        # strip in the activity center — empty/missing falls back to
        # the FE's built-in ROOT_OPP_TYPES list.
        activeRootOppTypeIds
        # Richer companion with the real opp-type names so unknown
        # roots (e.g. "AutoSavvy Customer Service") render with the
        # BE label instead of the FE's fallback "Other".
        activeRootOppTypes {
          id
          name
        }
      }
      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
          firstName
          lastName
          companyRole {
            id
            name
          }
        }
      }
      emails {
        id
        email
        emailType
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      phoneNumbers {
        id
        phone
        phoneType
        lookupType
        potentialLeads
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      addresses {
        id
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      leadVehicleInventory {
        id
        make
        model
        year
        trim
        stockNumber
        vin
        customerInterest
      }
      conversationStatus {
        id
        disableConversation
        createdOn
      }
      leadOpportunities {
        id
        name
        # BE-resolved CRM deep-link. Covers all supported CRMs
        # (DS/SF/DT/VIN/EL/TK) via api/utils/crm_links.py - the FE
        # prefers this when present and falls back to its own
        # crmLinkGeneration helper only when empty (e.g. Momentum,
        # which has no URL template). Selected only on the leadNew
        # path; getLeads stays cheap and does NOT select it.
        crmUrl
        # Unified URL + label payload. Same id drives both. Prefer
        # this over crmUrl when rendering the card so the label
        # can't drift out of sync with the URL (e.g. Tekion RO opps
        # where tkLeadId is NULL but tkRepairOrderId is set).
        crmLink {
          url
          id
          prefix
          kind
        }
        createdDate
        updatedDate
        departmentId
        potentialOpportunity
        opportunityMergeHistory
        isActive
        location {
          id
          title
        }
        leadOpportunityContacts {
          leadId
          lead {
            firstName
            lastName
            phoneNumbers {
              phone
              isPrimary
            }
            emails {
              email
              isPrimary
            }
          }
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            id
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
          bodyStyle
          condition
          exteriorColor
          interiorColor
          condition
          mileage
          extraData
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        location {
          id
          title
        }
        lead {
          id
          location {
            id
            title
          }
        }
        dtLeadOpportunities {
          id
          dtLeadSource {
            dtLeadSourceName
            leadSource {
              id
              name
            }
          }
          dtLeadStatusMapping {
            leadStatusType {
              id
              type
              status
            }
            dtLeadStatus
          }
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsLeadId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
          leadSource {
            name
          }
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          id
          dtOpportunityId
          dtOpportunityStage
        }
        tkLeadOpportunities {
          id
          tkLeadId
          tkContactId
          tkCustomerId
          # Synthetic-opp linkages: service appointments and repair
          # orders don't have a real tk_lead_id, but the FE needs
          # one of these to label the card title "TK <id>" and to
          # treat the row as CRM-mapped instead of EAI-only.
          tkAppointmentId
          tkRepairOrderId
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
        statusHistory {
          id
          newStatus {
            id
            name
            parentStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
          }
          oldStatus {
            id
            name
          }
          isTransferred
          createTs
          statusChangedTs
          statusChangedBy {
            id
            firstName
            lastName
          }
        }
        ziMajorUnitInvoices {
          id
          invoiceStatus {
            id
            name
          }
          ziDealerId
          ziDealId
          ziDealNo
          ziDealStatus
          ziCustomerId
          ziCoBuyerId
          ziSalesmanId
          ziSalespersonName
          invoiceTotal
          invoiceFees
          invoiceTaxes
          totalPartsAmount
          totalPartsCost
          ziOriginatingDate
          ziFinalDate
          ziCreatedDate
          ziModifiedDate
          isActive
          createdAt
          updatedAt
          extraData
          ziMajorUnitInvoiceItems {
            id
            itemType
            ziDealUnitId
            ziInventoryId
            ziDealerSaleMuId
            vin
            year
            make
            model
            stockNumber
            newUsed
            msrp
            dsp
            unitSoldPrice
            unitSoldCost
            tax
            fee
            tradeAllowance
            tradeAcv
            tradePayoff
            amtFinanced
            payment
            isActive
            createdAt
            updatedAt
            extraData
            leadVehicleOfInterest {
              id
              leadId
              make
              model
              year
              trim
              stockNumber
              vin
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
            }
          }
        }
      }
      # Per-section counts grouped by ROOT opp_type. rootOppTypeId is
      # null for opp-less rows (notes/tasks not tied to a specific
      # opportunity); FE sums the opp-less row + the active-tab row
      # for the section header count.
      notesCountByOppType {
        rootOppTypeId
        count
      }
      tasksCountByOppType {
        rootOppTypeId
        count
      }
      appointmentsCountByOppType {
        rootOppTypeId
        count
      }
    }
  }
`;

export const GET_LEAD_SOURCES_DS = gql`
  query getLeadSources($companyId: Int!, $locationIds: [Int], $search: String) {
    getLeadSources(companyId: $companyId, locationIds: $locationIds, search: $search) {
      key
      name
      companyLeadSourceId
      consentOption
      parents {
        key
        name
        consentOption
        companyLeadSourceId
        childs {
          key
          name
          companyLeadSourceId
          consentOption
        }
      }
    }
  }
`;

export const GET_LEAD_SOURCES_NEW = gql`
  query getLeadSourcesNew($companyId: Int!) {
    getLeadSourcesNew(companyId: $companyId) {
      key
      name
      childs {
        key
        name
        childs {
          key
          name
        }
      }
    }
  }
`;
export const GET_LEAD_ACTIVE_APPOINTMENT = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      activeAppointment {
        id
        userId
        locationId
        description
        summary
        discussedVoiId
        isLastActionByLead
        appointmentStatus
        isConfirmed
        leadOpportunityId
        startDatetime
        endDatetime
        timezone
        dateUpdated
        user {
          id
          fullName
          companyRoleId
          locationId
          companyRole {
            id
            name
          }
        }
        leadOpportunity {
          dsOpportunityEvents {
            id
            dsEventId
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          id
          leadId
          name
        }
        createdBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        lead {
          id
          fullName
          vehicleOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          leadVehicleInventory {
            id
            make
            model
            year
            trim
            stockNumber
            vin
          }
        }
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
          parentStatus {
            id
            name
          }
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
      }
    }
  }
`;

export const GET_DS_SOURCES = gql`
  query getDsSources {
    getDsSources {
      sourceName
      key
      marketingChannels {
        marketingChannelName
        key
        parentId
        trackingCodes {
          trackingCodeName
          parentId
        }
      }
    }
  }
`;

export const GET_ALL_USERS_ACTIVITY_CENTER = gql`
  query getUsers(
    $page: Int
    $pageSize: Int
    $search: String
    $companyId: Int!
    $isGlobalLeadOwner: Boolean
    $isLocationFilter: Boolean
    $locationIds: [Int]
    $allUser: Boolean
    $status: [String]
  ) {
    getUsers(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      isGlobalLeadOwner: $isGlobalLeadOwner
      isLocationFilter: $isLocationFilter
      locationIds: $locationIds
      allUser: $allUser
      status: $status
    ) {
      data {
        fullName
        id
        isDisabled
        companyId
        companyRole {
          id
          name
        }
      }
      count
    }
  }
`;

export const GET_ALL_USERS_APPOINTMENT_FORM = gql`
  query getUsers(
    $page: Int
    $pageSize: Int
    $search: String
    $companyId: Int!
    $isGlobalLeadOwner: Boolean
    $isLocationFilter: Boolean
    $locationIds: [Int]
    $allUser: Boolean
    $status: [String]
  ) {
    getUsers(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      isGlobalLeadOwner: $isGlobalLeadOwner
      isLocationFilter: $isLocationFilter
      locationIds: $locationIds
      allUser: $allUser
      status: $status
    ) {
      data {
        fullName
        id
        isDisabled
        companyRole {
          id
          name
        }
      }
      count
    }
  }
`;
export const EDIT_LEAD = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      firstName
      lastName
      fullName
      phoneNumbers {
        id
        phone
        phoneType
        isPrimary
      }
      emails {
        id
        email
      }
      addresses {
        id
        addressLine1
        city
        state
        country
        postalCode
      }
      leadUsers {
        id
        userId
        user {
          firstName
          lastName
        }
      }
      crmLeadObj {
        activeLeadOpportunity {
          id
        }
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
        }
        opportunityStatus {
          id
          name
          parentStatus {
            id
            name
          }
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        dsOpportunityEvents {
          dsEventId
        }
        sfLeadOpportunities {
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
      }
      leadStatusTypeId
      leadSourceOriginalId
      otherSource

      vehicleOfInterest {
        id
        leadId
        year
        make
        model
        trim
        description
        budget
        customerInterest
        inputType
        isCurrent
        isPrimary
        stockNumber
        vin
      }
      leadVehicleInventory {
        id
        year
        make
        model
        trim
        stockNumber
        vin
      }
      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
        }
      }
    }
  }
`;
// Appointment Queries Start
export const APPOINTMENT_LIST = gql`
  query getUserAppointment(
    $userIds: [Int]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $startDate: Date
    $endDate: Date
    $companyId: Int
    $locationId: Int
    $appointmentStatus: [String]
    $leadId: Int
    $createdByUserIds: [Int]
    $isOttoAppointments: Boolean
    $isAllLocationUsers: Boolean
    $isEmployeeAppointments: Boolean
    $opportunityTypeId: Int
    $opportunitySourceIds: [Int]
    $teamIds: [Int]
    $viewMode: String
    $filterType: String
    $filterDateType: FilterDateType
  ) {
    getUserAppointment(
      userIds: $userIds
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      startDate: $startDate
      endDate: $endDate
      companyId: $companyId
      locationId: $locationId
      appointmentStatus: $appointmentStatus
      leadId: $leadId
      createdByUserIds: $createdByUserIds
      isOttoAppointments: $isOttoAppointments
      isAllLocationUsers: $isAllLocationUsers
      isEmployeeAppointments: $isEmployeeAppointments
      opportunityTypeId: $opportunityTypeId
      opportunitySourceIds: $opportunitySourceIds
      teamIds: $teamIds
      viewMode: $viewMode
      filterType: $filterType
      filterDateType: $filterDateType
    ) {
      data {
        id
        startDatetime
        timezone
        description
        summary
        isConfirmed
        extraData
        discussedVoiId
        discussedVoi {
          id
          make
          model
          year
          customerInterest
        }
        userId
        appointmentStatus
        lead {
          id
          fullName
          vehicleOfInterest {
            id
            make
            model
            year
            customerInterest
            isCurrent
          }
          leadVehicleInventory {
            id
            make
            model
            year
            customerInterest
            isCurrent
          }
          phoneNumbers {
            phone
          }
          emails {
            email
          }
          leadSource {
            name
            id
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          leadOpportunities {
            id
            name
            createdDate
            updatedDate
            location {
              id
              title
            }
            leadOpportunityUsers {
              id
              userTypeId
              userId
              isActive
              user {
                id
                fullName
                companyRole {
                  id
                  name
                }
              }
              userType {
                name
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
            opportunityTypeId
            opportunityStatusId
            opportunitySourceId
            opportunityType {
              id
              name
            }
            opportunityStatus {
              id
              name
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            sfLeadOpportunities {
              id
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            dsOpportunityEvents {
              id
              dsEventId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
            }
            dtLeadOpportunities {
              dtOpportunityId
              dtOpportunityStage
              dtLeadSource {
                leadSource {
                  name
                }
              }
            }
            tkLeadOpportunities {
              id
              tkLeadId
              tkContactId
              tkCustomerId
            }
            opportunityStatus {
              id
              name
              parentStatus {
                name
                id
              }
            }
          }
        }
        leadOpportunityId
        leadOpportunity {
          id
          name
          leadId
          dsOpportunityEvents {
            id
            dsEventId
            dsEntitySource
            dsMarketingChannelName
            dsTrackingCode
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityType {
            id
            name
            parentType {
              id
              name
              parentType {
                id
                name
                parentType {
                  id
                  name
                }
              }
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
        }
        dateUpdated
        dateCreated
        createdBy {
          id
          fullName
          dateCreated
        }
        updatedBy {
          id
          fullName
          dateCreated
        }
        user {
          id
          fullName
          companyRole {
            name
          }
        }
      }
      count
    }
  }
`;
export const APPOINTMENT_CALENDAR = gql`
  query getUserAppointment(
    $userIds: [Int]
    $companyId: Int
    $locationId: Int
    $leadId: Int
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $startDate: Date
    $endDate: Date
    $appointmentStatus: [String]
    $createdByUserIds: [Int]
    $filterDateType: FilterDateType
    $filterType: String
    $isOttoAppointments: Boolean
    $isAllLocationUsers: Boolean
    $isEmployeeAppointments: Boolean
    $opportunityTypeId: Int
    $opportunitySourceIds: [Int]
    $teamIds: [Int]
    $viewMode: String
  ) {
    getUserAppointment(
      userIds: $userIds
      companyId: $companyId
      locationId: $locationId
      leadId: $leadId
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      startDate: $startDate
      endDate: $endDate
      appointmentStatus: $appointmentStatus
      createdByUserIds: $createdByUserIds
      filterDateType: $filterDateType
      filterType: $filterType
      isOttoAppointments: $isOttoAppointments
      isAllLocationUsers: $isAllLocationUsers
      isEmployeeAppointments: $isEmployeeAppointments
      opportunityTypeId: $opportunityTypeId
      opportunitySourceIds: $opportunitySourceIds
      teamIds: $teamIds
      viewMode: $viewMode
    ) {
      data {
        id
        summary
        startDatetime
        timezone
        appointmentStatus
        isConfirmed
        extraData
        leadOpportunity {
          id
          opportunityType {
            id
            name
            parentType {
              id
              name
              parentType {
                id
                name
                parentType {
                  id
                  name
                }
              }
            }
          }
        }
      }
      count
    }
  }
`;
export const GET_APPOINTMENT_POPUP_DETAILS = gql`
  query getAppointmentDetails($appointmentId: Int!) {
    getAppointmentDetails(appointmentId: $appointmentId) {
      id
      dateCreated
      dateUpdated
      timezone
      lead {
        id
        fullName
        phoneNumbers {
          id
          phone
        }
        emails {
          id
          email
        }
        leadSource {
          name
          id
        }
      }
      user {
        id
        fullName
        companyRole {
          name
        }
      }
      extraData
      leadOpportunity {
        name
        opportunityType {
          id
          name
          parentType {
            id
            name
            parentType {
              id
              name
              parentType {
                id
                name
              }
            }
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
      }
      locationId
    }
  }
`;
export const GET_REMAINING_APPOINTMENT_FORM_DETAILS = gql`
  query getAppointmentDetails($appointmentId: Int!) {
    getAppointmentDetails(appointmentId: $appointmentId) {
      id
      dateCreated
      dateUpdated
      summary
      startDatetime
      timezone
      appointmentStatus
      isConfirmed
      extraData
      description
      discussedVoiId
      discussedVoi {
        id
        make
        model
        year
        customerInterest
      }
      user {
        id
        fullName
        companyRole {
          name
        }
      }
      lead {
        id
        fullName
        phoneNumbers {
          id
          phone
        }
        emails {
          id
          email
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          location {
            id
            title
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            isActive
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          opportunityTypeId
          opportunityStatusId
          opportunitySourceId
          opportunityType {
            id
            name
          }
          opportunityStatus {
            id
            name
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          dsOpportunityEvents {
            id
            dsEventId
            dsEntitySource
            dsMarketingChannelName
            dsTrackingCode
          }
          dtLeadOpportunities {
            dtOpportunityId
            dtOpportunityStage
            dtLeadSource {
              leadSource {
                name
              }
            }
          }
          tkLeadOpportunities {
            id
            tkLeadId
            tkContactId
            tkCustomerId
          }
          opportunityStatus {
            id
            name
            parentStatus {
              name
              id
            }
          }
        }
      }
      leadOpportunity {
        id
        name
        leadId
        dsOpportunityEvents {
          id
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          id
          dtOpportunityId
          dtOpportunityStage
        }
        tkLeadOpportunities {
          id
          tkLeadId
          tkContactId
          tkCustomerId
        }
        opportunityType {
          id
          name
          parentType {
            id
            name
          }
        }
        opportunityStatus {
          id
          name
          parentStatus {
            id
            name
          }
        }
      }
      createdBy {
        id
        fullName
        dateCreated
      }
      updatedBy {
        id
        fullName
        dateCreated
      }
    }
  }
`;
// Appointment Queries end
export const LEAD_LISTING = gql`
  query getLeads(
    $source: [String]
    $sourceOriginal: [String]
    $combinedSource: [String]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $voi: [VehicleOfInterestInputObject]
    $campaignIds: [Int]
    $status: [String]
    $leadStatusTypes: [Int]
    $crmLeadStatus: [Int]
    $isSameGroup: Boolean
    $stageNames: [String]
    $userTypesAnd: [UserTypeFilterAnd]
    $userTypesOr: [UserTypeFilterOr]
    $dsSources: [String]
    $skipFilter: Boolean
  ) {
    getLeads(
      source: $source
      sourceOriginal: $sourceOriginal
      combinedSource: $combinedSource
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      voi: $voi
      campaignIds: $campaignIds
      status: $status
      leadStatusTypes: $leadStatusTypes
      crmLeadStatus: $crmLeadStatus
      isSameGroup: $isSameGroup
      stageNames: $stageNames
      userTypesAnd: $userTypesAnd
      userTypesOr: $userTypesOr
      dsSources: $dsSources
      skipFilter: $skipFilter
    ) {
      data {
        id
        firstName
        lastName
        fullName
        # Selected rows are handed to the Activity Center by "Apply to Activity
        # Center", where they become the "Pinned from LC" tab and its unread
        # badge — without this they arrive with no unread and the badge reads 0.
        unreadCount
        phoneNumbers {
          id
          phone
          phoneType
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        addresses {
          id
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        textConsentStatus
        location {
          id
          title
        }
        leadUsers {
          userType {
            id
            useCase
            name
          }
          user {
            id
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
        emails {
          id
          email
          emailType
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
          status
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
            dsOpportunityEvents {
              dsLeadId
              dsEventId
            }
            sfLeadOpportunities {
              sfLeadId
              sfOpportunityId
            }
            vsLeadOpportunities {
              vsContactId
              vsLeadId
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
          }
          dsExtractedLead {
            dsLeadId
          }
          activeDsOpportunityEvent {
            dsMarketingChannelName
          }
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        leadOpportunities {
          # Selected rows are handed straight to the Activity Center by "Apply
          # to Activity Center" (no re-fetch), so the lead card reads its
          # source/status/opp-type scoping off these objects. Without them
          # oppMatchesTab matches nothing and the card falls back to "N/A".
          id
          name
          createdDate
          updatedDate
          isActive
          departmentId
          opportunityTypeId
          opportunityType {
            id
            name
            parentTypeId
            parentType {
              id
              name
              parentTypeId
              parentType {
                id
                name
              }
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
        }
        messages {
          content
          id
          direction
          dateSent
          dateReceived
          # translatedContent
          user {
            fullName
          }
        }
      }
      count
    }
  }
`;
export const GET_REMAINING_LEAD_DETAILS = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        location {
          id
          title
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        dsOpportunityEvents {
          dsEventId
        }
        sfLeadOpportunities {
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
      }
    }
  }
`;
export const GET_COMPANY_LEAD_SOURCES = gql`
  query getCompanyLeadSources($companyId: Int!) {
    getCompanyLeadSources(companyId: $companyId) {
      id
      consentOption
      leadSourceOriginal {
        id
        name
        parentSource {
          id
          name
        }
      }
    }
  }
`;

export const GET_COMPANY_CONTACTS = gql`
  query getCompanyContacts($companyId: Int!) {
    getCompanyContacts(companyId: $companyId) {
      id
      contactEmail
      contactType
    }
  }
`;

export const GET_LEADS_PHONE_FROM_CRM = gql`
  query getLeadsByPhoneFromCrm(
    $phone: String!
    $crmIntegrationType: String
    $crmDealerId: String
    $crmSiteId: String
    $crmLeadId: String
    $crmOpportunityId: String
    $crmCustomerId: String
    $crmAppointmentId: String
    $oppType: String
  ) {
    getLeadsByPhoneFromCrm(
      phone: $phone
      crmIntegrationType: $crmIntegrationType
      crmDealerId: $crmDealerId
      crmSiteId: $crmSiteId
      crmLeadId: $crmLeadId
      crmOpportunityId: $crmOpportunityId
      crmCustomerId: $crmCustomerId
      crmAppointmentId: $crmAppointmentId
      oppType: $oppType
    ) {
      leadId
      crmIntegrationId
      firstName
      lastName
      name
      mobile
      email
      location
      locationId
      status
      owner
      source
      customerId
      appointmentId
      appointmentType
      appointmentDatetime
      appointmentStatus
      appointmentNumber
      vehicleVin
      vehicleYear
      vehicleMake
      vehicleModel
    }
  }
`;

export const GET_LEADS_PHONE_FROM_DMS = gql`
  query getLeadsByPhoneFromDms($phone: String!, $locationId: Int) {
    getLeadsByPhoneFromDms(phone: $phone, locationId: $locationId) {
      leadId
      firstName
      lastName
      mobile
      email
      locationId
    }
  }
`;

export const GET_POTENTIAL_LEADS_BY_ID = gql`
  query getLeadsById($leadIds: [Int]!) {
    getLeadsById(leadIds: $leadIds) {
      id
      fullName
      firstName
      lastName
      companyId
      leadCreatedDate
      leadSourceType
      leadSourceOriginalId
      status
      leadStatusTypeId
      isDeleted
      activeAppointment {
        id
        appointmentStatus
        dateCreated
        dateUpdated
        endDatetime
        isConfirmed
        startDatetime
        timezone
        summary
        description
        leadOpportunityId
        userId
        leadOpportunity {
          id
          name
        }
      }
      addresses {
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      leadStatusType {
        id
        type
        status
      }
      emails {
        id
        email
        emailType
      }
      messages {
        content
        id
        direction
        dateSent
        dateReceived
        # translatedContent
        user {
          fullName
        }
      }
      phoneNumbers {
        id
        phone
        phoneType
        lookupType
        isPrimary
      }
      vehicleOfInterest {
        id
        leadId
        year
        make
        model
        trim
        description
        budget
        customerInterest
        inputType
        isCurrent
        isPrimary
        stockNumber
        vin
      }
      leadVehicleInventory {
        id
        make
        model
        year
        trim
        stockNumber
        vin
      }
      leadSource {
        name
        id
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }
      location {
        id
        title
        locationType
      }
      leadUsers {
        id
        userTypeId
        userType {
          id
          useCase
          name
        }
        userId
        user {
          id
          firstName
          lastName
          companyRole {
            id
            name
          }
        }
      }
      crmLeadObj {
        crmStatus
        parentCrmStatus
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        lead {
          id
          location {
            id
            title
          }
        }
        sfLeadOpportunities {
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
      }
    }
  }
`;
export const GET_LEAD_BY_PHONE = gql`
  query leadByPhone($phone: String!) {
    leadByPhone(phone: $phone) {
      id
      fullName
      firstName
      lastName
      dateOfBirth
      leadSourceType
      leadSourceOriginalId
      companyId
      leadFileId
      crmIntegrationId
      status
      emailConsent
      emailConsentDate
      textConsent
      textConsentDate
      textConsentStatus
      otherSource
      disableConversation
      leadStatusTypeId
      locationId
      emails {
        id
        leadId
        email
        emailType
        isPrimary
      }
      phoneNumbers {
        id
        leadId
        phone
        phoneType
        lookupType
        isPrimary
      }
      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
          firstName
          lastName
        }
      }
      location {
        id
        title
      }
    }
  }
`;
export const GET_COMPANY_CONSENT = gql`
  query getCompanyConsentTemplateEvent($companyId: Int) {
    getCompanyConsentTemplateEvent(companyId: $companyId) {
      consentTemplateEvent {
        code
        isActive
      }
      companyConsentTemplateEvent {
        templateText
        afterTextMode
        onlyFirstMessage
        isActive
      }
    }
  }
`;

export const GET_CONSENT_TEMPLATE = gql`
  query getEngagementTemplateText($leadId: Int!, $content: String!) {
    getEngagementTemplateText(leadId: $leadId, content: $content) {
      unknownVariables
      content
      statusCode
      message
    }
  }
`;
export const GET_CRM_OWNER_DROPDOWN = gql`
  query getUserTypes($companyId: Int!) {
    getUserTypes(companyId: $companyId) {
      id
      name
      useCase
      opportunityType {
        id
        name
      }
    }
  }
`;

export const GET_CRM_OWNER_USER = gql`
  query getUserTypes($companyId: Int!, $locationId: Int) {
    getUserTypes(companyId: $companyId, locationId: $locationId) {
      id
      opportunityTypeId
      name
      users {
        id
        fullName
        status
        companyRole {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_USERS_TEAMS = gql`
  query getUsers(
    $page: Int
    $pageSize: Int
    $search: String
    $companyId: Int!
    $isGlobalLeadOwner: Boolean
    $isLocationFilter: Boolean
    $locationIds: [Int]
    $allUser: Boolean
    $companyRoles: [Int]
  ) {
    getUsers(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      isGlobalLeadOwner: $isGlobalLeadOwner
      isLocationFilter: $isLocationFilter
      locationIds: $locationIds
      allUser: $allUser
      companyRoles: $companyRoles
    ) {
      data {
        id
        fullName
        location {
          id
          title
        }
        companyRole {
          id
          name
          locations {
            locationId
          }
        }
      }
      count
    }
  }
`;

export const GET_LEAD_OPPORTUNITY = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      crmLeadObj {
        crmStatus
        parentCrmStatus
        dsExtractedLead {
          id
          dsLeadId
          dsSource
        }
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
        dtExtractedLead {
          id
          dtLeadId
        }
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        lead {
          id
          fullName
          location {
            id
            title
          }
        }
        opportunityTypeId
        opportunityStatusId
        description
        createdDate
        isActive
        opportunityType {
          id
          name
        }
        dsOpportunityEvents {
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
          leadSource {
            name
          }
        }
        sfLeadOpportunities {
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          dtOpportunityId
          dtOpportunityStage
          dtLeadSource {
            leadSource {
              name
            }
          }
        }
        tkLeadOpportunities {
          id
          tkLeadId
          tkContactId
          tkCustomerId
        }
        leadOpportunityUsers {
          isActive
          user {
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
      }
    }
  }
`;
export const GET_CRM_LEAD_STATUS_TYPE = gql`
  query GetCrmLeadStatus {
    getCrmLeadStatus {
      crmIntegrationType
    }
  }
`;

export const GET_LEAD_INFO_APPOINTMENT = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      fullName
      location {
        id
      }
      crmLeadObj {
        crmIntegrationType
        crmStatus
        parentCrmStatus
        customerType {
          id
          type
        }
        customerSubType {
          id
          type
        }
        dsExtractedLead {
          id
          dsLeadId
          dsSource
        }
        activeDsOpportunityEvent {
          id
          dsEventId
          dsMarketingChannelName
        }
        sfExtractedLead {
          id
          sfLeadId
        }
        mfExtractedLead {
          id
          mfProspectId
          mfCustomerId
        }
        activeSfOpportunityEvent {
          id
          sfOpportunityId
        }
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        lead {
          id
          location {
            id
            title
          }
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
      }
    }
  }
`;

export const GET_PROSPECT_FILTERS = gql`
  {
    getAutoAttributes {
      id
      key
      label
      relatedKeys
      filterType
      isCustomValues
      isView
      isActive
      autoAttributeValues {
        id
        value
        mappingKey
      }
    }
  }
`;
export const GET_LEAD_OPPORTUNITIES_BY_ID = gql`
  query getLeadOpportunities($leadId: Int!) {
    getLeadOpportunities(leadId: $leadId) {
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        lead {
          id
          location {
            id
            title
          }
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
      }
    }
  }
`;
export const GET_LEAD_DETAIL_CLICK = gql`
  query lead($leadId: Int!) {
    lead(leadId: $leadId) {
      id
      fullName
      firstName
      lastName
      otherSource
      unreadCount
      leadCreatedDate
      status
      companyId
      leadSourceOriginalId
      leadStatusTypeId
      textConsentStatus
      consentExpireDay
      textConsentDate
      activeAppointment {
        id
        startDatetime
        isConfirmed
        appointmentStatus
      }

      messages {
        id
        dateReceived
        dateSent
        content
      }
      crmLeadObj {
        crmStatus
        parentCrmStatus
        activeLeadOpportunity {
          id
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          dsOpportunityEvents {
            dsLeadId
            dsEventId
          }
          sfLeadOpportunities {
            sfLeadId
            sfOpportunityId
          }
          vsLeadOpportunities {
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          dtLeadOpportunities {
            id
            dtOpportunityId
          }
          tkLeadOpportunities {
            id
            tkLeadId
          }
        }
        dsExtractedLead {
          dsLeadId
        }
        activeDsOpportunityEvent {
          dsMarketingChannelName
        }
      }
      leadStatusType {
        id
        type
      }
      leadSource {
        name
        id
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }
      location {
        id
        title
        locationType
      }
      leadUsers {
        userType {
          id
          useCase
          name
        }
        user {
          id
          firstName
          lastName
          companyRole {
            id
            name
          }
        }
      }
      vehicleOfInterest {
        id
        leadId
        year
        make
        model
        trim
        description
        budget
        customerInterest
        inputType
        isCurrent
        isPrimary
        stockNumber
        vin
      }
      emails {
        id
        email
        emailType
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      phoneNumbers {
        id
        phone
        phoneType
        lookupType
        isPrimary
        relationshipType
        firstName
        lastName
        note
      }
      addresses {
        id
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      leadVehicleInventory {
        id
        make
        model
        year
        trim
        stockNumber
        vin
      }
      conversationStatus {
        id
        disableConversation
        createdOn
      }
      leadOpportunities {
        id
        name
        createdDate
        updatedDate
        location {
          id
          title
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            companyRole {
              id
              name
            }
          }
          userType {
            name
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        opportunityType {
          id
          name
          parentTypeId
          parentType {
            id
            name
            parentTypeId
            parentType {
              id
              name
            }
          }
        }
        serviceRosCount
        serviceRos {
          id
          roNumber
          roStatus
          roStatusDesc
          totalAmt
          closedRoDate
          updateDate
          year
          make
          model
          vin
        }
        opportunityStatus {
          id
          name
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        lead {
          id
          location {
            id
            title
          }
        }
        dsOpportunityEvents {
          id
          dsEventId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        opportunityStatus {
          id
          name
          parentStatus {
            name
            id
          }
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        # users {
        #   id
        #   user {
        #     id
        #     firstName
        #     lastName
        #     companyRole {
        #       id
        #       name
        #     }
        #   }
        # }
      }
    }
  }
`;

export const GET_NOTIFICATION_CONFIG = gql`
  query GetNotificationConfig {
    me {
      id
      notificationConfig {
        id
        notificationsAllowed
        dndStart
        dndEnd
        timezone
        email
        app
        sms
        responses
        interval
        details {
          id
          setType
          filterSetId
          count
        }
      }
    }
  }
`;

export const GET_WEB_CHAT_WIDGET_CONNECTION = gql`
  query getWebSocketConnection($leadId: Int) {
    getWebSocketConnection(leadId: $leadId) {
      id
      connected
      sid
    }
  }
`;

export const GET_LEAD_CONTECTED_BY_SOURCE = gql`
  query getEngagementLeadAnalytics($range: Int, $filterType: String) {
    getEngagementLeadAnalytics(range: $range, filterType: $filterType) {
      count
      status
      date
      source
    }
  }
`;

export const GET_ONLY_ENGAGEMENT_LEADS_ANALYTICS = gql`
  query getCompleteLeadAnalysis($filterType: String) {
    getCompleteLeadAnalysis(filterType: $filterType) {
      engagementLeadAnalysis {
        count
        source
        status
        date
      }
      leadAnalysis {
        count
        source
      }
    }
  }
`;

export const ME = gql`
  query ME {
    me {
      id
      email
      firstName
      lastName
      fullName
      phone
      isTranslationEnabled
      isDisabled
      departmentIds
      locationId
      # BE-resolved permitted ROOT opp_type ids and unscoped flag.
      # Source of truth for FE tab visibility and dropdown filtering,
      # backed by the 4-layer fallback chain plus 1h Redis cache in
      # api/utils/db_user.py get_user_allowed_opp_types_for_location.
      # No client-side walking of userDepartments.
      allowedOppTypeIds
      isOppTypeUnscoped
      dsUsers {
        id
        dsUserId
        dsUserName
        active
      }
      userDepartments {
        id
        isPrimary
        department {
          name
          opportunityType {
            id
            name
            parentTypeId
            parentType {
              id
              name
              parentTypeId
              parentType {
                id
                name
              }
            }
          }
        }
      }
      location {
        id
        title
        crmIntegration {
          id
          crmDealerId
          crmSiteId
          integrationType
        }
        # EAI-1598 — per-location feature configs (e.g. ottovin_settings) used
        # to gate the OttoVin section in the user Notifications tab. Read off the
        # user's PRIMARY location, not the location dropdown.
        dataServiceConfigs {
          id
          isActive
          runParams
          dataService {
            serviceName
          }
        }
      }
      locations {
        id
        isOpenCrmWarningPopup
        location {
          id
          title
          timezone
          companyId
          locationType
          phone
          email
          city
          state
          settings
          # Distinct root opportunity_type ids backing the location's
          # active Department rows. Drives the dynamic opp-type tab
          # strip in the activity center keyed off the top-bar
          # location dropdown selection. Empty list means "no
          # Department config" — FE falls back to its built-in
          # ROOT_OPP_TYPES.
          activeRootOppTypeIds
          # Richer companion with opp-type names so unknown roots
          # render with the BE label instead of "Other".
          activeRootOppTypes {
            id
            name
          }
          crmIntegration {
            id
            crmDealerId
            crmSiteId
            crmFranchiseId
            integrationType
            active
          }
          opportunityType {
            id
            name
          }
          dmsIntegration {
            id
            dmsType
          }
        }
      }
      companyRoleId
      preferredLanguageCode
      companyRole {
        id
        name
        parentRoleId
        isOpenCrmWarningPopup
      }
      company {
        id
        name
        isDisabled
        aingineSourceId
        timezone
        locationLink
        isOptinConsentMethod
        isOpenCrmWarningPopup
        isGlobalCrm
        userRoles {
          id
          companyId
          userId
          role {
            id
            name
            canCreateUsers
            canCreateTeams
            canViewProspects
            isCompanyAdmin
            canViewAutoAnalytics
            canViewAdExport
            canViewClm
            canViewGle
            canViewEngagements
          }
        }
        crmIntegration {
          id
          integrationType
          active
          locationId
          location {
            id
            title
            locationType
          }
        }
      }
      userAccounts {
        id
        isDisabled
        company {
          id
          name
          isDisabled
          aingineSourceId
          isOptinConsentMethod
          isGlobalCrm
        }
      }
      profilePic
      role {
        id
        name
        canCreateUsers
        canCreateTeams
        canViewProspects
        isCompanyAdmin
        canViewAutoAnalytics
        canViewAdExport
        canViewClm
        canViewGle
        canViewEngagements
      }
      teamsLeader {
        id
      }
      settings
    }
  }
`;
export const GET_GENERIC_FILTER_TYPES = gql`
  query getGenericFilterTypes {
    getGenericFilterTypes {
      id
      code
      name
    }
  }
`;
export const GET_USER_LEAD_FILTER = gql`
  query getUserLeadFilters($filterName: String, $genericFilterTypeId: Int) {
    getUserLeadFilters(filterName: $filterName, genericFilterTypeId: $genericFilterTypeId) {
      id
      locationId
      userId
      filterName
      genericFilterJson {
        id
        filterJson
        isCurrent
        userLeadFilter {
          id
        }
      }
    }
  }
`;

export const GET_REVIEW_TRACKING_DETAILS = gql`
  query GetGroupedReviewTrackingDetails(
    $companyId: Int!
    $locationIds: [Int]!
    $leadName: String
    $userName: String
    $search: String
    $filterType: String
    $dateRange: [DateTime]
    $status: [String]
    $lastActivity: [String]
    $item: [String]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getGroupedReviewTrackingDetails(
      companyId: $companyId
      locationIds: $locationIds
      leadName: $leadName
      userName: $userName
      search: $search
      filterType: $filterType
      dateRange: $dateRange
      status: $status
      lastActivity: $lastActivity
      item: $item
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      count
      data {
        id
        companyId
        locationId
        leadId
        leadOpportunityId
        userId
        messageId
        shortenUrlId
        socialReviewId
        actionType
        actionValue
        requestId
        createTs
        updateTs
        invitedDate
        latestTrackingDate
        actions
        lead {
          id
          firstName
          lastName
          fullName
          crmLeadObj {
            dsExtractedLead {
              dsLeadId
            }
            sfExtractedLead {
              sfLeadId
            }
            dtExtractedLead {
              dtLeadId
            }
            vsExtractedLead {
              vsLeadId
            }
            elExtractedLead {
              elLeadId
            }
            mfExtractedLead {
              mfProspectId
              mfCustomerId
            }
          }
        }
        user {
          id
          firstName
          lastName
          email
          companyRole {
            name
          }
        }
        location {
          id
          title
        }
        leadOpportunity {
          id
          leadId
          name
          # BE-resolved CRM deep-link. crmUrl is the plain URL string;
          # crmLink is the unified url+label payload. Together they let
          # Service / Repair-Order opps (e.g. Tekion, where tkLeadId is NULL
          # but tkRepairOrderId is set) render a correct clickable CRM id
          # instead of falling back to a non-linked EAI id. Mirrors the
          # opportunity card: prefer crmUrl, fall back to the FE-resolved link.
          crmUrl
          crmLink {
            url
            id
            prefix
            kind
          }
          dsOpportunityEvents {
            dsLeadId
            dsEventId
          }
          dtLeadOpportunities {
            dtOpportunityId
          }
          tkLeadOpportunities {
            id
            tkLeadId
            tkContactId
            tkCustomerId
          }
          sfLeadOpportunities {
            sfLeadId
            sfOpportunityId
          }
          vsLeadOpportunities {
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            isActive
            user {
              id
              firstName
              lastName
              email
              companyRole {
                id
                name
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            customerInterest
            isCurrent
            isPrimary
          }
          opportunityType {
            parentType {
              name
            }
          }
        }
        trackings {
          id
          actionType
          actionValue
          createTs
          updateTs
        }
        # Lead's free-text feedback response. Shown as a tooltip on the
        # "feedback submitted" status icon and in the View Feedback drawer.
        # user/leadOpportunity are nested here (not the top-level user/
        # leadOpportunity fields above, which feed other table columns) —
        # BE contract for the review-response entity.
        reviewResponse {
          responseType
          comment
          commentTs
          user {
            id
            firstName
            lastName
            companyRole {
              name
            }
          }
          leadOpportunity {
            id
            leadId
            name
            crmUrl
            crmLink {
              url
              id
              prefix
              kind
            }
            leadOpportunityUsers {
              id
              userTypeId
              userId
              isActive
              user {
                id
                firstName
                lastName
                email
                companyRole {
                  id
                  name
                }
              }
              userType {
                name
              }
            }
            vehiclesOfInterest {
              year
              make
              model
              customerInterest
              isPrimary
            }
            opportunityType {
              parentType {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_REVIEW_TRACKING_SUMMARY = gql`
  query getReviewTrackingSummary(
    $companyId: Int!
    $locationIds: [Int]
    $year: Int
    $month: Int
    $week: Int
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getReviewTrackingSummary(
      companyId: $companyId
      locationIds: $locationIds
      year: $year
      month: $month
      week: $week
      filterType: $filterType
      dateRange: $dateRange
    ) {
      reviewStats {
        title
        name
        month
        frequency
        date
        total
        frequencyBreakdown {
          platform
          count
        }
      }
    }
  }
`;

export const GET_APPOINTMENT_DETAILS_WITH_TOKEN = gql`
  query getAppointmentDetailsWithToken($appointmentToken: String!) {
    getAppointmentDetailsWithToken(appointmentToken: $appointmentToken) {
      appointment {
        uid
        startDatetime
        appointmentStatus
        timezone
        lead {
          fullName
        }
        user {
          firstName
          lastName
        }
      }
      company {
        profilePic
        name
      }
      location {
        title
      }
      user {
        firstName
        lastName
      }
      lead {
        fullName
      }
      statusCode
      message
      operation
      operationData
    }
  }
`;

export const GET_CAMPAIGN_LIST_FILTERS = gql`
  query getCampaignsList($locationIds: [Int], $search: String, $activeInd: [String]) {
    getCampaignsList(locationIds: $locationIds, search: $search, activeInd: $activeInd) {
      id
      name
    }
  }
`;

export const GET_SCHEDULED_MESSAGES_FOR_LEAD = gql`
  query getScheduledMessagesForLead($leadId: Int!) {
    getScheduledMessagesForLead(leadId: $leadId) {
      id
      leadId
      user {
        fullName
      }
      isTaskExecuted
      taskSendDatetime
      timezone
      message
    }
  }
`;

export const GET_LOCATION_VEHICLE_INVENTORY = gql`
  query getVehicleInventoryV2(
    $currentLocationId: Int
    $locationIds: [Int]
    $isAllLocations: Boolean
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    getVehicleInventoryV2(
      currentLocationId: $currentLocationId
      locationIds: $locationIds
      isAllLocations: $isAllLocations
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      count
      data {
        id
        locationId
        make
        model
        year
        trim
        stockNumber
        modelNumber
        bodyStyle
        vin
        msrp
        sellingPrice
        currencyUnit
        isNew
        exteriorColor
        interiorColor
        vdpUrl
        isCertified
        driveType
        vehicleType
        engineCylinders
        doors
        seats
        driveTrain
        transmission
        transmissionDesc
        epaCombined
        epaHighway
        epaCity
        epaUnit
        range
        rangeUnit
        fuelType
        currencyUnit
        invoiceAmount
        mileage
        mileageUnit
        availability
        description
        comments
        extraData
        features
        vehicleInventoryMedias {
          mediaUrl
        }
        location {
          id
          inventoryUrlFormat
        }
      }
    }
  }
`;

export const GET_LOCATION_VEHICLE_INVENTORIES_V2 = gql`
  query getVehicleInventoriesV2($locationIds: [Int], $search: String, $page: Int, $pageSize: Int) {
    getVehicleInventoriesV2(
      locationIds: $locationIds
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      count
      page
      perPage
      statusCode
      message
      vehicleInventories
    }
  }
`;
export const GET_VEHICLE_INVENTORIES = gql`
  query getVehicleInventoryV2(
    $currentLocationId: Int
    $locationIds: [Int]
    $isAllLocations: Boolean
    $stockNumber: String
    $vin: String
    $year: [Int]
    $make: String
    $model: String
    $trim: String
    $exteriorColor: String
    $interiorColor: String
    $bodyStyle: String
    $isNew: Boolean
    $orderBy: String
    $orderDirection: String
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    getVehicleInventoryV2(
      currentLocationId: $currentLocationId
      locationIds: $locationIds
      isAllLocations: $isAllLocations
      stockNumber: $stockNumber
      vin: $vin
      year: $year
      make: $make
      model: $model
      trim: $trim
      exteriorColor: $exteriorColor
      interiorColor: $interiorColor
      bodyStyle: $bodyStyle
      isNew: $isNew
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      count
      data {
        id
        locationId
        make
        model
        year
        trim
        stockNumber
        modelNumber
        bodyStyle
        vin
        msrp
        sellingPrice
        currencyUnit
        isNew
        isCertified
        driveType
        vehicleType
        exteriorColor
        interiorColor
        engineCylinders
        doors
        seats
        driveTrain
        transmission
        transmissionDesc
        epaCombined
        epaHighway
        epaCity
        epaUnit
        range
        rangeUnit
        fuelType
        currencyUnit
        invoiceAmount
        mileage
        mileageUnit
        availability
        vdpUrl
        description
        comments
        vehicleInventoryMedias {
          mediaUrl
        }
        location {
          id
          inventoryUrlFormat
        }
        extraData
        features
      }
    }
  }
`;

export const GET_REVIEW_TRACKING_BY_PLATFORM = gql`
  query getReviewTrackingByPlatform(
    $companyId: Int!
    $locationIds: [Int]!
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getReviewTrackingByPlatform(
      companyId: $companyId
      locationIds: $locationIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      platform
      count
    }
  }
`;

export const GET_REVIEW_TRACKING_BY_USER = gql`
  query getReviewTrackingByUser(
    $companyId: Int!
    $locationIds: [Int]!
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getReviewTrackingByUser(
      companyId: $companyId
      locationIds: $locationIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      user {
        id
        fullName
      }
      count
    }
  }
`;

export const GET_RECENT_REVIEW_TRACKING_DETAIL = gql`
  query getRecentReviewTrackingDetail(
    $companyId: Int!
    $locationIds: [Int]!
    $pageSize: Int!
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getRecentReviewTrackingDetail(
      companyId: $companyId
      locationIds: $locationIds
      pageSize: $pageSize
      filterType: $filterType
      dateRange: $dateRange
    ) {
      selfWritten
      ottoSuggested
      recentReviewDetails {
        id
        authorName
        updateTs
        commentTs
        socialReviewSettings {
          id
          platform
        }
      }
    }
  }
`;

export const GET_LEAD_OPPORTUNITIES = gql`
  query getLeadOpportunity(
    $opportunitySourceId: [Int]
    $opportunityStatusId: [Int]
    $opportunityTypeId: [Int]
    $locationIds: [Int]
    $page: Int
    $pageSize: Int
    $search: String
    $searchVehicleObjects: [VehicleOfInterestInputObject]
    $userTypesAnd: [UserTypeFilterAnd]
    $userTypesOr: [UserTypeFilterOr]
    $assignedUserIds: [Int]
    $activeOpportunityStatusIds: [Int]
    $orderBy: String
    $orderDirection: String
    $filterType: String
    $dateRange: [DateTime]
    $dateType: String
    $viewMode: String
    $teamIds: [Int]
    $status: [String]
    $campaignIds: [Int]
  ) {
    getLeadOpportunity(
      opportunitySourceId: $opportunitySourceId
      opportunityStatusId: $opportunityStatusId
      opportunityTypeId: $opportunityTypeId
      locationIds: $locationIds
      page: $page
      pageSize: $pageSize
      search: $search
      searchVehicleObjects: $searchVehicleObjects
      userTypesAnd: $userTypesAnd
      userTypesOr: $userTypesOr
      assignedUserIds: $assignedUserIds
      activeOpportunityStatusIds: $activeOpportunityStatusIds
      orderBy: $orderBy
      orderDirection: $orderDirection
      filterType: $filterType
      dateRange: $dateRange
      dateType: $dateType
      viewMode: $viewMode
      teamIds: $teamIds
      status: $status
      campaignIds: $campaignIds
    ) {
      data {
        id
        name
        isActive
        opportunityTypeId
        opportunityStatusId
        opportunitySourceId
        createdDate
        updatedDate
        lead {
          id
          fullName
          location {
            id
            title
          }
          crmLeadObj {
            dsExtractedLead {
              id
              dsLeadId
            }
            activeDsOpportunityEvent {
              id
              dsEventId
              dsMarketingChannelName
            }
            sfExtractedLead {
              id
              sfLeadId
            }
            mfExtractedLead {
              id
              mfProspectId
              mfCustomerId
            }
            vsExtractedLead {
              id
              vsContactId
            }
            activeSfOpportunityEvent {
              id
              sfOpportunityId
            }
          }
        }
        location {
          id
          title
        }
        vehiclesOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
          bodyStyle
          condition
          mileage
          interiorColor
          exteriorColor
          extraData
        }
        leadOpportunityUsers {
          id
          userTypeId
          userId
          isActive
          user {
            id
            fullName
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
          userType {
            id
            name
          }
        }
        dsOpportunityEvents {
          dsEventId
          dsLeadId
          dsEntitySource
          dsMarketingChannelName
          dsTrackingCode
        }
        sfLeadOpportunities {
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          id
          dtOpportunityId
        }
        tkLeadOpportunities {
          id
          tkLeadId
        }
        opportunityType {
          id
          name
          parentType {
            id
            name
          }
        }
        opportunityStatus {
          id
          name
          parentStatus {
            id
            name
          }
        }
        opportunitySource {
          id
          name
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
      }
      count
    }
  }
`;

export const GET_OPPORTUNITY_SOURCES = gql`
  query getOpportunitySources($companyId: Int!, $locationIds: [Int]!) {
    getOpportunitySources(companyId: $companyId, locationIds: $locationIds) {
      id
      name
      parentId
      isDefault
      parentSource {
        id
        name
        isDefault
      }
    }
  }
`;

export const GET_OPPORTUNITY_VOI = gql`
  query getOpportunityVois($companyId: Int!, $locationIds: [Int]!) {
    getOpportunityVois(companyId: $companyId, locationIds: $locationIds) {
      id
      make
      model
      year
      text
    }
  }
`;

export const GET_APPLICATION_USE_CASES = gql`
  query getApplicationUseCases {
    getApplicationUseCases {
      id
      title
      code
    }
  }
`;
export const GET_APPLICATION_LEVELS = gql`
  query getApplicationLevels {
    getApplicationLevels {
      id
      title
      code
    }
  }
`;
export const GET_AI_SUGGESTION_QUICK_TIP = gql`
  query getAiSuggestionQuickTip(
    $companyId: Int
    $locationIds: [Int]
    $departmentIds: [Int]
    $applicationUseCaseId: Int
    $communicationChannel: String
    # Active opp-type tab id. When supplied (and "departmentIds" is
    # NOT explicitly passed), BE looks up the matching Department(s)
    # at the location and returns department-scoped tips. Falls
    # through to location- and company-tier tips when the department
    # tier has no rows.
    $rootOppTypeId: Int
  ) {
    getAiSuggestionQuickTip(
      companyId: $companyId
      locationIds: $locationIds
      departmentIds: $departmentIds
      applicationUseCaseId: $applicationUseCaseId
      communicationChannel: $communicationChannel
      rootOppTypeId: $rootOppTypeId
    ) {
      id
      companyId
      locationId
      applicationUseCaseId
      tip
      suggestionType
      isActive
      description
      communicationChannels
      opportunityTypeId
      order
      # Owner of a user-level custom tip/tone. NULL for admin
      # (company/location/department) items; the composer compares it to the
      # current user's id to show owner-only actions (edit/delete).
      userId
    }
  }
`;

// Per-user Quick Tips / Tones preference for a location (EAI-1497).
// `hidden` = ids the user chose to hide; `preserved` = the user's default selection.
export const GET_QUICK_TIPS_PREFERENCE = gql`
  # Preferences are scoped per location AND per application use case, so the
  # message composer and the review reply composer keep separate hidden /
  # preserved sets instead of overwriting each other's.
  query getQuickTipsPreference($locationId: Int, $applicationUseCaseId: Int!) {
    getQuickTipsPreference(locationId: $locationId, applicationUseCaseId: $applicationUseCaseId) {
      locationId
      applicationUseCaseId
      quickTips {
        hidden
        preserved
      }
      quickTones {
        hidden
        preserved
      }
    }
  }
`;
export const GET_COMPANY_ROLES_NAMES = gql`
  query getCompanyRole($companyId: Int!, $locationIds: [Int]) {
    getCompanyRole(companyId: $companyId, locationIds: $locationIds) {
      id
      name
    }
  }
`;

export const GET_LEVELS = gql`
  query getApplicationLevels {
    getApplicationLevels {
      id
      title
      code
      isActive
    }
  }
`;

export const GET_PROMPTS = gql`
  query getPrompts($companyId: Int!, $search: String, $isAllPrompts: Boolean, $locationIds: [Int]) {
    getPrompts(
      companyId: $companyId
      search: $search
      isAllPrompts: $isAllPrompts
      locationIds: $locationIds
    ) {
      id
      userId
      teamId
      companyRoleId
      locationId
      companyId
      applicationLevelId
      applicationUseCaseId
      promptText
      isActive
      promptSources {
        leadSourceOriginalId
        leadSourceOriginal {
          id
          name
        }
      }
      company {
        id
        name
      }
      user {
        id
        fullName
      }
      team {
        id
        name
      }
      companyRole {
        id
        name
      }
      location {
        id
        title
      }
      applicationLevel {
        id
        title
        code
      }
      applicationUseCase {
        id
        title
        code
      }
    }
  }
`;

export const GET_TEAM_NAMES = gql`
  query getTeams($page: Int, $pageSize: Int, $search: String, $companyId: Int!, $locationId: Int) {
    getTeams(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      locationId: $locationId
    ) {
      data {
        id
        name
      }
    }
  }
`;

export const GET_USE_CASES = gql`
  query getApplicationUseCases {
    getApplicationUseCases {
      id
      title
      code
      isActive
    }
  }
`;

export const GET_AI_RESPONSE = gql`
  query getAiResponse(
    $companyId: Int!
    $applicationUseCaseId: Int!
    $leadId: Int
    $socialReviewId: Int
    $postId: Int
    $regenerate: Boolean
    $generateTasks: Boolean
    $campaignInput: CampaignInput
    $aiSuggestionUserInput: AiSuggestionUserInput
    $leadOpportunityId: Int
  ) {
    getAiResponse(
      companyId: $companyId
      applicationUseCaseId: $applicationUseCaseId
      leadId: $leadId
      socialReviewId: $socialReviewId
      postId: $postId
      regenerate: $regenerate
      generateTasks: $generateTasks
      campaignInput: $campaignInput
      aiSuggestionUserInput: $aiSuggestionUserInput
      leadOpportunityId: $leadOpportunityId
    ) {
      content
      subject
      body
      bodyHtml
      statusCode
      statusMessage
      aiResponseHistoryId
      futureTasks {
        taskType
        taskChannel
        taskTarget
        taskTitle
        taskDescription
        assigneeType
        isDueImmediately
        dueDatetime
        dueTimezone
        priority
      }
    }
  }
`;

export const GET_AI_RESPONSE_FOR_USER_REVIEW = gql`
  query getAiResponse(
    $companyId: Int!
    $applicationUseCaseId: Int!
    $leadId: Int
    $socialReviewId: Int
    $postId: Int
    $token: String!
    $locationId: Int!
    $userId: Int!
    $regenerate: Boolean
    $generateTasks: Boolean
    $leadOpportunityId: Int
    $aiSuggestionUserInput: AiSuggestionUserInput
  ) {
    getAiResponse(
      companyId: $companyId
      applicationUseCaseId: $applicationUseCaseId
      leadId: $leadId
      socialReviewId: $socialReviewId
      postId: $postId
      token: $token
      locationId: $locationId
      userId: $userId
      regenerate: $regenerate
      generateTasks: $generateTasks
      leadOpportunityId: $leadOpportunityId
      aiSuggestionUserInput: $aiSuggestionUserInput
    ) {
      content
      statusCode
      statusMessage
      futureTasks {
        taskType
        taskChannel
        taskTarget
        taskTitle
        taskDescription
        assigneeType
        isDueImmediately
        dueDatetime
        dueTimezone
        priority
      }
    }
  }
`;

export const GET_SOCIAL_REVIEW_BY_USER = gql`
  query getSocialReviewByUser(
    $companyId: Int!
    $locationIds: [Int]!
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getSocialReviewByUser(
      companyId: $companyId
      locationIds: $locationIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      user {
        id
        fullName
      }
      count
    }
  }
`;

export const GET_SOCIAL_REVIEW_BY_PLATFORM = gql`
  query getSocialReviewByPlatform(
    $companyId: Int!
    $locationIds: [Int]!
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getSocialReviewByPlatform(
      companyId: $companyId
      locationIds: $locationIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      platform
      count
    }
  }
`;

export const GET_GENERIC_FILTERS = gql`
  query getGenericFilters($filterName: String, $genericFilterTypeId: Int) {
    getGenericFilters(filterName: $filterName, genericFilterTypeId: $genericFilterTypeId) {
      id
      filterName
      genericFilterTypeId
      userId
      genericFilterJson {
        id
        filterJson
        # Round-tripped by updateGenericFilter. Without selecting it here the
        # update mutation sent isCurrent: undefined and cleared the flag.
        isCurrent
      }
    }
  }
`;

// add calender queries
export const GET_USER_WORKING_HOURS = gql`
  query getUserWorkingHours($locationId: Int!) {
    getUserWorkingHours(locationId: $locationId) {
      id
      userId
      weekDay
      isWorkingDay
      startTime
      endTime
      createdOn
      isActive
      isDeleted
    }
  }
`;

export const GET_USER_SCHEDULE = gql`
  query getUserSchedule($locationId: Int!) {
    getUserSchedule(locationId: $locationId) {
      id
      name
      fromDatetime
      toDatetime
      isAvailable
      isDelete
      updatedOn
      isCompany
      isLocation
      isFullDay
    }
  }
`;

export const GET_LOCATION_SCHEDULE = gql`
  query getLocationSchedule($locationId: Int) {
    getLocationSchedule(locationId: $locationId) {
      id
      name
      fromDate
      toDate
      isAvailable
      isDelete
      updatedOn
      isCompany
      isLocation
    }
  }
`;

export const GET_COMPANY_SCHEDULE = gql`
  query getCompanySchedule($companyId: Int) {
    getCompanySchedule(companyId: $companyId) {
      id
      name
      companyId
      fromDatetime
      toDatetime
      isAvailable
      createdOn
      updatedOn
      isDelete
    }
  }
`;
// end add calender queries

export const GET_SUPPORTED_LANGUAGES = gql`
  query getSupportedLanguages {
    getSupportedLanguages {
      id
      languageName
      languageCode
      companyId
    }
  }
`;

export const GET_DETECTED_LANGUAGE = gql`
  query getLanguageCode($content: String!) {
    getLanguageCode(content: $content) {
      code
    }
  }
`;

export const GET_TRANSLATION_SETTINGS = gql`
  query getTranslationSettings($leadId: Int!) {
    getTranslationSettings(leadId: $leadId) {
      id
      customerLanguage
      userLanguage
      isAutomaticTranslation
      isIncludeOriginalMessage
      isTranslationPreview
    }
  }
`;

export const GET_WEB_CHAT_WIDGET = gql`
  query getWebChatWidget($locationIds: [Int], $companyId: Int!) {
    getWebChatWidget(locationIds: $locationIds, companyId: $companyId) {
      id
      widgetUid
      locationId
      initialText
      isPhoneRequired
      switchToSmsInd
      presetQuestionInd
      isActive
      updateTs
      location {
        id
        title
      }
      webChatWidgetInitiationMethod {
        id
        code
      }
      webChatWidgetQuestion {
        id
        question
        questionType
        isActive
        metaData
      }
      metaData
      webChatWidgetOrigin {
        id
        origin
      }
      owner {
        id
        fullName
        companyRole {
          id
          name
        }
      }
      webChatUser {
        id
        user {
          id
          fullName
        }
        team {
          id
          name
        }
      }
    }
  }
`;
export const GET_OPPORTUNITY_STATUS_NEW = gql`
  query getOpportunityStatusNew($locationIds: [Int], $opportunityTypeId: Int) {
    getOpportunityStatusNew(locationIds: $locationIds, opportunityTypeId: $opportunityTypeId) {
      key
      name
      isDefault
      order
      required
      childs {
        key
        name
        isDefault
        order
        required
        childs {
          key
          name
          isDefault
          order
          required
        }
      }
    }
  }
`;
export const GET_LEAD_NOTES = gql`
  query getLeadNotes($leadId: Int!, $selectedOppTypeId: Int) {
    getLeadNotes(leadId: $leadId, selectedOppTypeId: $selectedOppTypeId) {
      id
      note
      createTs
      updateTs
      createdBy {
        id
        fullName
      }
      updatedBy {
        id
        fullName
      }
      leadOpportunity {
        id
        name
        # Opp-type chain needed for the top-right root-opp-type chip on
        # each note card. Two hops up the parent chain is enough for the
        # production tree today; the FE walker handles missing parents.
        opportunityType {
          id
          parentTypeId
          parentType {
            id
            parentTypeId
            parentType {
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  query getDepartments($locationId: Int, $companyId: Int) {
    getDepartments(locationId: $locationId, companyId: $companyId) {
      id
      name
      locationId
      location {
        title
      }
      isDefault
      isActive
      opportunityType {
        id
        name
      }
      users {
        id
        fullName
        role {
          id
          name
        }
        companyRole {
          id
          name
        }
      }
    }
  }
`;
export const GET_COMPANY_DOCUMENTS = gql`
  query getCompanyDocuments(
    $companyId: Int
    $locationId: Int
    $page: Int
    $pageSize: Int
    $search: String
  ) {
    getCompanyDocuments(
      companyId: $companyId
      locationId: $locationId
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      count
      statusCode
      statusMessage
      companyDocuments {
        id
        name
        templateUrl
        description
        isActive
        isMasked
        createTs
        updateTs
        extraData
      }
    }
  }
`;
export const GET_LEAD_OPPORTUNITY_DOCUMENT_URL = gql`
  query getLeadOpportunityDocumentUrl(
    $companyDocumentId: Int!
    $leadId: Int
    $leadOpportunityId: Int
  ) {
    getLeadOpportunityDocumentUrl(
      companyDocumentId: $companyDocumentId
      leadId: $leadId
      leadOpportunityId: $leadOpportunityId
    ) {
      statusCode
      statusMessage
      documentUrl
    }
  }
`;

export const GET_LOCATION_HOLIDAY = gql`
  query getLocationHolidays($companyId: Int!, $locationId: Int!, $departmentId: Int) {
    getLocationHolidays(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
    ) {
      id
      name
      holidayDate
      holidayDay
      isCompany
    }
  }
`;

export const GET_DATA_BY_SOURCE = gql`
  query GetDataBySource(
    $dataType: String
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $dateRange: [DateTime]
    $dateType: String
    $viewMode: String
    $orderBy: String
    $orderDirection: String
    $opportunityTypeId: Int
    $columnStatusIds: [Int]
    $opportunitySourceIds: [Int]
  ) {
    getDataBySource(
      dataType: $dataType
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      dateRange: $dateRange
      dateType: $dateType
      viewMode: $viewMode
      orderBy: $orderBy
      orderDirection: $orderDirection
      opportunityTypeId: $opportunityTypeId
      columnStatusIds: $columnStatusIds
      opportunitySourceIds: $opportunitySourceIds
    ) {
      totals {
        name
        value
      }
      data {
        sourceId
        sourceName
        metrics {
          name
          value
        }
        children {
          sourceId
          sourceName
          metrics {
            name
            value
          }
          children {
            sourceId
            sourceName
            metrics {
              name
              value
            }
          }
        }
      }
    }
  }
`;

export const GET_LOCATION_WORKING_HOURS = gql`
  query getLocationWorkingHours($locationId: Int!, $departmentId: Int) {
    getLocationWorkingHours(locationId: $locationId, departmentId: $departmentId) {
      id
      weekDay
      isWorkingDay
      startTime
      endTime
      isDeleted
      isActive
    }
  }
`;

export const GET_DEPARTMENT_WORKING_HOURS = gql`
  query getDepartmentWorkingHours($locationId: Int!) {
    getDepartmentWorkingHours(locationId: $locationId) {
      departmentId
      departmentName
      isActive
      workingHours {
        id
        weekDay
        isWorkingDay
        startTime
        endTime
        isDeleted
        isActive
      }
    }
  }
`;

export const GET_HOLIDAYS = gql`
  query getHolidays($companyId: Int!) {
    getHolidays(companyId: $companyId) {
      companyId
      companyName
      locationId
      locationName
      departmentId
      departmentName
      isAllDepartments
      isActive
    }
  }
`;

export const GET_DASHBOARD_SETTINGS = gql`
  query getDashboardSetting($companyId: Int!, $locationIds: [Int]!, $sectionId: Int) {
    getDashboardSetting(companyId: $companyId, locationIds: $locationIds, sectionId: $sectionId) {
      id
      companyId
      extraData
      isActive
      sectionId
    }
  }
`;

export const GET_WORKING_HOURS = gql`
  query getWorkingHours($companyId: Int!) {
    getWorkingHours(companyId: $companyId) {
      companyId
      companyName
      locationId
      locationName
      departmentId
      departmentName
      isAllDepartments
      isActive
    }
  }
`;

export const GET_CUSTOME_WORKING_HOURS = gql`
  query getCustomWorkingHours($locationId: Int!, $departmentId: Int) {
    getCustomWorkingHours(locationId: $locationId, departmentId: $departmentId) {
      id
      name
      fromDate
      toDate
      startTime
      endTime
      isAvailable
    }
  }
`;

export const GET_DASHBOARD_SECTION = gql`
  query getDashboardSection {
    getDashboardSection {
      id
      isActive
      name
      description
    }
  }
`;

export const GET_LEAD_OPPORTUNITIES_BY_IDS = gql`
  query getLeadOpportunitiesById($leadOpportunityIds: [Int]!) {
    getLeadOpportunitiesById(leadOpportunityIds: $leadOpportunityIds) {
      opportunityTypeId
      opportunityStatusId
      opportunitySourceId
      createdDate
      isActive
      updatedDate
      location {
        id
        title
      }
      opportunityType {
        id
        name
        parentType {
          id
          name
          parentType {
            id
            name
          }
        }
      }
      opportunityStatus {
        id
        name
      }
      opportunitySource {
        id
        name
        parentSource {
          id
          name
          parentSource {
            id
            name
          }
        }
      }
      id
      name
      leadOpportunityUsers {
        id
        userTypeId
        userId
        isActive
        user {
          id
          fullName
          companyRole {
            id
            name
          }
        }
        userType {
          name
        }
      }
      vehiclesOfInterest {
        id
        leadId
        year
        make
        model
        trim
        description
        budget
        customerInterest
        inputType
        isCurrent
        isPrimary
        stockNumber
        vin
        bodyStyle
        condition
        mileage
        interiorColor
        exteriorColor
        extraData
      }
    }
  }
`;

export const GET_DASHBOARD_SETTING_FROM_LOCATION = gql`
  query getDashboardSettingFromLocation($locationId: Int!) {
    getDashboardSettingFromLocation(locationId: $locationId) {
      dashboardSettings {
        id
        isActive
        extraData
        section {
          id
          key
          isActive
          extraData
        }
      }
    }
  }
`;

export const GET_USER_MESSAGE_TYPE_ANALYSIS = gql`
  query getUserMessageTypeAnalysis(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $outputFormat: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getUserMessageTypeAnalysis(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      outputFormat: $outputFormat
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        user {
          id
          fullName
          profilePic
        }
        textMessages
        imageMessages
        videoMessages
        docMessages
        # audioMessages
      }
      distributedData {
        user {
          id
          fullName
        }
        name
        value
      }
      count
    }
  }
`;

export const GET_USER_MESSAGE_RESPONSE_TIME_ANALYSIS = gql`
  query getUserMessageResponseTimeAnalysis(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $outputFormat: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getUserMessageResponseTimeAnalysis(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      outputFormat: $outputFormat
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        user {
          id
          fullName
          profilePic
        }
        bestTime
        worstTime
        averageTime
        medianTime
      }
      count
      averageBestTime
      averageWorstTime
      averageMedianTime
      averageResponseTimeAfterNudge
      averageTime
      percentageChange
      trend
    }
  }
`;

export const GET_USER_REVIEW_ANALYSIS = gql`
  query getUserReviewAnalysis(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getUserReviewAnalysis(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        user {
          id
          fullName
        }
        name
        value
        averageRating
        totalReviewInvites
        overallRating
      }
      totalInviteSents
      totalReviewCompleted
      totalInviteNotSents
      count
    }
  }
`;

export const GET_DASHBOARD_ANALYTICS = gql`
  query getDashboardAnalytics(
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $opportunityTypeId: Int
    $teamIds: [Int]
  ) {
    getDashboardAnalytics(
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      opportunityTypeId: $opportunityTypeId
      teamIds: $teamIds
    ) {
      totalNewLeads
      totalActiveLeads
      totalEngagedLeads
      percentageConversion
    }
  }
`;

export const GET_REVIEW_STATUS_ANALYSIS = gql`
  query getReviewStatusAnalysis(
    $filterType: String
    $reviewStatus: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $outputFormat: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getReviewStatusAnalysis(
      filterType: $filterType
      reviewStatus: $reviewStatus
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      outputFormat: $outputFormat
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        lead {
          id
          fullName
          vehicleOfInterest {
            id
            year
            make
            model
          }
        }
        user {
          id
          fullName
          profilePic
        }
        soldDate
        status
      }
      count
    }
  }
`;

export const GET_LEAD_TASKS = gql`
  query getLeadTasks(
    $leadId: Int
    $userIds: [Int]
    $createdByIds: [Int]
    $taskTypes: [InputTaskType]
    $taskStatuses: [InputTaskStatus]
    $filterType: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $status: String
    $dateRange: [DateTime]
    $isOttoTasks: Boolean
    $search: String
    $isEmployeeTasks: Boolean
    $selectedOppTypeId: Int
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getLeadTasks(
      leadId: $leadId
      userIds: $userIds
      createdByIds: $createdByIds
      taskTypes: $taskTypes
      taskStatuses: $taskStatuses
      filterType: $filterType
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      status: $status
      dateRange: $dateRange
      isOttoTasks: $isOttoTasks
      search: $search
      isEmployeeTasks: $isEmployeeTasks
      selectedOppTypeId: $selectedOppTypeId
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      leadTasks {
        id
        taskType
        taskStatus
        title
        description
        createTs
        lead {
          id
          fullName
          locationId
          crmLeadObj {
            crmStatus
            parentCrmStatus
            activeLeadOpportunity {
              id
              opportunityStatus {
                id
                name
                parentStatus {
                  id
                  name
                }
              }
              opportunitySource {
                id
                name
                parentSource {
                  id
                  name
                  parentSource {
                    id
                    name
                  }
                }
              }
              vehiclesOfInterest {
                id
                leadId
                year
                make
                model
                trim
                description
                budget
                customerInterest
                inputType
                isCurrent
                isPrimary
                stockNumber
                vin
              }
            }
            dsExtractedLead {
              id
              dsLeadId
              dsSource
            }
            sfExtractedLead {
              id
              sfLeadId
            }
            mfExtractedLead {
              id
              mfProspectId
              mfCustomerId
            }
            dtExtractedLead {
              id
              dtLeadId
            }
          }
          leadOpportunities {
            id
            name
            isActive
            # Opp-type chain needed for the top-right root-opp-type chip
            # on each task card. Walks the parent_type chain to the root.
            opportunityType {
              id
              parentTypeId
              parentType {
                id
                parentTypeId
                parentType {
                  id
                }
              }
            }
            dtLeadOpportunities {
              id
              dtLeadSource {
                dtLeadSourceName
                leadSource {
                  id
                  name
                }
              }
              dtLeadStatusMapping {
                leadStatusType {
                  id
                  type
                  status
                }
                dtLeadStatus
              }
            }
            dsOpportunityEvents {
              id
              dsEventId
              dsLeadId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
              leadSource {
                name
              }
            }
            sfLeadOpportunities {
              id
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
              vsLeadStatusMapping {
                vsLeadStatusType
                vsLeadStatus
              }
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            dtLeadOpportunities {
              id
              dtOpportunityId
              dtOpportunityStage
            }
            tkLeadOpportunities {
              id
              tkLeadId
              tkContactId
              tkCustomerId
            }
          }
          location {
            title
          }
          phoneNumbers {
            id
            phone
            isPrimary
          }
          emails {
            email
            isPrimary
          }
        }
        createdBy {
          id
          fullName
        }
        assignedTo {
          id
          fullName
        }
        completedBy {
          id
          fullName
        }
        taskAssignments {
          id
          assignmentType
          assignedToId
          assignedTo {
            id
            firstName
            lastName
            fullName
          }
          abandonedCallTask {
            callbackStatus
            callbackResult
          }
        }
        dueDate
        completionDate
        completionNote
        leadOpportunityId
      }
      totalCount
      upcoming
      overdue
      completed
    }
  }
`;

export const GET_LEAD_ENGAGEMENT_ANALYSIS = gql`
  query getLeadEngagementAnalysis(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
    $dateType: String
  ) {
    getLeadEngagementAnalysis(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
      dateType: $dateType
    ) {
      data {
        user {
          id
          fullName
        }
        uncontacted
        notResponded
        responded
        notEngaged
        engaged
        waitingForLeadReply
        needsYourReply
        noResponseNeeded
      }
      count
      uncontacted
      notResponded
      responded
      notEngaged
      engaged
      waitingForLeadReply
      needsYourReply
      noResponseNeeded
    }
  }
`;

export const GET_MORE_APPOINTMENT_DETAILS_ACTIVITY_CENTER = gql`
  query getAppointmentDetails($appointmentId: Int!) {
    getAppointmentDetails(appointmentId: $appointmentId) {
      id
      extraData
      discussedVoiId
      dateCreated
      dateUpdated
      discussedVoi {
        id
        make
        model
        year
      }
      lead {
        leadVehicleInventory {
          id
          make
          model
          year
        }
        fullName
        vehicleOfInterest {
          id
          make
          model
          year
        }
      }
      leadOpportunity {
        id
        name
        opportunityType {
          id
          name
        }
        opportunityStatus {
          id
          name
        }
        dsOpportunityEvents {
          id
          dsEventId
        }
        sfLeadOpportunities {
          id
          sfOpportunityId
          sfOpportunityStage
        }
        vsLeadOpportunities {
          id
          vsContactId
          vsLeadId
          vsLeadStatusMapping {
            vsLeadStatusType
            vsLeadStatus
          }
        }
        elLeadOpportunities {
          id
          elOpportunityId
          elLeadId
        }
        mfLeadOpportunities {
          id
          mfProspectId
          mfCustomerId
          mfLeadId
        }
        dtLeadOpportunities {
          id
          dtOpportunityId
          dtOpportunityStage
        }
        tkLeadOpportunities {
          id
          tkLeadId
          tkContactId
          tkCustomerId
        }
      }
    }
  }
`;
export const GET_EMAILS = gql`
  query getEmails(
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $search: String
    $leadIds: [Int]
    $emailStatus: [String]
    $emailTypes: [String]
    $skipFilter: Boolean
    $isDeleted: Boolean
    $userIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $isOttoEmails: Boolean
  ) {
    getEmails(
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
      leadIds: $leadIds
      emailStatus: $emailStatus
      emailTypes: $emailTypes
      skipFilter: $skipFilter
      isDeleted: $isDeleted
      userIds: $userIds
      filterType: $filterType
      dateRange: $dateRange
      isOttoEmails: $isOttoEmails
    ) {
      data {
        id
        sesMessageId
        from_
        to
        subject
        bodyHtml
        createTs
        status
        type
        latestActivityTs
        lead {
          id
          fullName
        }
        message {
          id
          user {
            id
            fullName
          }
          mmsObjects {
            id
            mediaUrl
            mediaType
            size
          }
          direction
          leadOpportunityId
        }
      }
      count
    }
  }
`;

export const GET_EMAIL_THREAD = gql`
  query getEmailThread(
    $rootSesMessageId: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $search: String
  ) {
    getEmailThread(
      rootSesMessageId: $rootSesMessageId
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
    ) {
      data {
        id
        sesMessageId
        from_
        to
        subject
        bodyHtml
        createTs
        status
        type
        latestActivityTs
        lead {
          id
          fullName
        }
        message {
          id
          user {
            id
            fullName
          }
          mmsObjects {
            id
            mediaUrl
            mediaType
            size
          }
          direction
          leadOpportunityId
        }
      }
      count
    }
  }
`;

export const GET_COMPANY_EMAIL_TEMPLATE_EVENT = gql`
  query getCompanyEmailTemplateEvent($companyId: Int) {
    getCompanyEmailTemplateEvent(companyId: $companyId) {
      emailTemplateEvent {
        id
        code
        title
        isActive
      }
      companyEmailTemplateEvent {
        id
        user {
          id
          fullName
        }
        isCompanyShared
        subjectText
        title
        templateText
        isActive
      }
    }
  }
`;

export const GET_DRAFTS = gql`
  query getDrafts(
    $companyId: Int!
    $locationId: Int!
    $draftType: DraftTypeInput!
    $userId: Int
    $page: Int
    $pageSize: Int
  ) {
    getDrafts(
      companyId: $companyId
      locationId: $locationId
      draftType: $draftType
      userId: $userId
      page: $page
      pageSize: $pageSize
    ) {
      data {
        id
        userId
        subject
        body
        isDeleted
        createTs
        updateTs
        sender
        receiver
        lead {
          id
          fullName
        }
        email {
          from_
          to
        }
      }
      count
    }
  }
`;

export const GET_SCHEDULED_EMAILS_FOR_LEAD = gql`
  query getScheduledEmailsForLead($leadId: Int!) {
    getScheduledEmailsForLead(leadId: $leadId) {
      id
      leadId
      subject
      body
      taskCreateDatetime
      taskSendDatetime
      to
      lead {
        id
        fullName
      }
    }
  }
`;

export const GET_SCHEDULED_EMAILS_FOR_LOCATION = gql`
  query getScheduledEmailsForLocation($locationIds: [Int]!) {
    getScheduledEmailsForLocation(locationIds: $locationIds) {
      id
      leadId
      subject
      body
      taskCreateDatetime
      taskSendDatetime
      to
      lead {
        id
        fullName
      }
    }
  }
`;

export const GET_EMAIL_TEMPLATE_LISTING = gql`
  query getCompanyEmailTemplateEvent($companyId: Int!) {
    getCompanyEmailTemplateEvent(companyId: $companyId) {
      companyEmailTemplateEvent {
        id
        isActive
        title
        subjectText
        templateText
      }
    }
  }
`;

export const GET_DYNAMIC_SETTINGS = gql`
  query getDynamicSettings(
    $page: Int
    $pageSize: Int
    $settingsType: String
    $permissionType: String
    $companyRoleId: Int
    $userId: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getDynamicSettings(
      page: $page
      pageSize: $pageSize
      settingsType: $settingsType
      permissionType: $permissionType
      companyRoleId: $companyRoleId
      userId: $userId
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        companyRolePermissionAction {
          id
          companyRoleId
          isActive
          isCheck
          extraData
          permissionAction {
            permissionId
            actionId
          }
          companyRole {
            name
          }
        }
        userPermissionAction {
          id
          userId
          isActive
          isCheck
          user {
            firstName
            lastName
          }
        }
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_EMAIL_MESSAGE_DETAILS = gql`
  query getMessageEmailDetail($token: String!) {
    getMessageEmailDetail(token: $token) {
      data {
        id
        sesMessageId
        from_
        to
        subject
        bodyHtml
        createTs
        latestActivityTs
        lead {
          id
          fullName
          location {
            id
            title
          }
        }
        message {
          id
          content
          user {
            id
            fullName
          }
          direction
        }
      }
    }
  }
`;

export const GET_EMAIL_STATISTICS = gql`
  query getEmailStatistics($locationId: Int, $filterType: String, $dateRange: [DateTime]) {
    getEmailStatistics(locationId: $locationId, filterType: $filterType, dateRange: $dateRange) {
      emailsByType {
        manual
        campaign
        appointment
        other
      }
      emailGraphData {
        date
        graphData {
          status
          count
        }
      }
      emailRateByStatus {
        title
        current
        previous
        percentage
      }
      emailRateByType {
        emailType
        emailRateByStatus {
          title
          current
        }
      }
    }
  }
`;

export const GET_EMAIL_LOCATION_STATISTICS = gql`
  query getEmailLocationStatistics(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    getEmailLocationStatistics(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      count
      emailStatsByLocation {
        emailType
        locationName
        locationId
        emailRateByStatus {
          title
          current
        }
      }
    }
  }
`;

export const GET_EMAIL_TYPE_STATS_BY_LOCATION = gql`
  query getEmailTypeStatsByLocation($locationId: Int, $filterType: String, $dateRange: [DateTime]) {
    getEmailTypeStatsByLocation(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
    ) {
      emailType
      emailRateByStatus {
        title
        current
      }
    }
  }
`;

export const GET_EMAIL_TYPE_DETAILS_BY_LOCATION = gql`
  query getEmailTypeDetailsByLocation(
    $locationId: Int!
    $emailType: String!
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $campaignIds: [Int]
    $employeeIds: [Int]
    $status: [String]
    $sentAt: [DateTime]
    $statusUpdateAt: [DateTime]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getEmailTypeDetailsByLocation(
      locationId: $locationId
      emailType: $emailType
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      campaignIds: $campaignIds
      employeeIds: $employeeIds
      status: $status
      sentAt: $sentAt
      statusUpdateAt: $statusUpdateAt
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      count
      campaigns {
        campaignId
        name
      }
      employees {
        employeeId
        name
      }
      emailGraphData {
        date
        graphData {
          count
          status
        }
      }
      locationStatistics {
        locationId
        locationName
        emailRateByStatus {
          title
          current
        }
      }
      emailData {
        subject
        campaignName
        emailType
        customerName
        employeeName
        createTs
        updateTs
        emailStatus
      }
    }
  }
`;

export const GET_CALL_STATISTICS_SUMMARY = gql`
  query getCallStatisticSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $departmentTypes: [String]
    $groupBy: String
  ) {
    getCallStatisticSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      departmentTypes: $departmentTypes
      groupBy: $groupBy
    ) {
      statusCode
      message
      callSummary {
        key
        title
        current
        previous
        change
      }
      connectedRate {
        key
        title
        current
        previous
        change
      }
      avgCallDuration {
        key
        title
        current
        previous
        change
      }
      callVolumeTrend {
        name
        inboundCalls
        outboundCalls
      }
      peakCallingHour {
        name
        inboundCalls
        outboundCalls
      }
      callDistribution {
        name
        value
      }
    }
  }
`;

export const GET_CALL_DETAILS_SUMMARY = gql`
  query getCallDetailSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $groupBy: String
    $departmentTypes: [String]
    $inboundAverageCallDuration: String
    $outboundAverageCallDuration: String
    $orderBy: String
    $orderDirection: String
  ) {
    getCallDetailSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      groupBy: $groupBy
      departmentTypes: $departmentTypes
      inboundAverageCallDuration: $inboundAverageCallDuration
      outboundAverageCallDuration: $outboundAverageCallDuration
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      count
      data {
        location {
          id
          title
        }
        departmentType
        user {
          id
          firstName
          lastName
        }
        calls
        inboundCalls
        outboundCalls
        averageCallDuration
        inboundAverageCallDuration
        outboundAverageCallDuration
        uniqueCalls
        uniqueInboundCalls
        uniqueOutboundCalls
        inboundAnsweredCalls
        inboundAnsweredRate
        outboundAnsweredCalls
        uniqueInboundAnsweredCalls
        uniqueOutboundAnsweredCalls
        outboundAnsweredRate
        inboundVoicemailCount
        outboundVoicemailCount
        inboundVoicemailReturnedCount
        answeredCalls
        voicemailCount
        missedCalls
        inboundMissedCalls
        outboundMissedCalls
        uniqueMissedCalls
        uniqueInboundMissedCalls
        uniqueOutboundMissedCalls
        totalMinutes
        inboundTotalMinutes
        outboundTotalMinutes
        isSummaryRecord
      }
    }
  }
`;

export const GET_CALL_BY_USER = gql`
  query getCallsByUser(
    $userId: Int
    $departmentTypes: [String]
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $direction: String
    $callerOutcomes: [String]
    $fromName: String
    $toName: String
    $fromNumber: String
    $toNumber: String
    $duration: Int
    $leadName: String
    $leadPhone: String
    $wasAnswered: Boolean
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getCallsByUser(
      userId: $userId
      locationId: $locationId
      departmentTypes: $departmentTypes
      filterType: $filterType
      dateRange: $dateRange
      direction: $direction
      callerOutcomes: $callerOutcomes
      toName: $toName
      fromName: $fromName
      toNumber: $toNumber
      fromNumber: $fromNumber
      duration: $duration
      leadName: $leadName
      leadPhone: $leadPhone
      wasAnswered: $wasAnswered
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      count
      userCallsSummary {
        totalCalls
        inboundCalls
        outboundCalls
        totalMinutes
        avgCallDuration
      }
      data {
        id
        callSid
        startedAt
        durationSeconds
        direction
        fromNumber
        fromName
        toNumber
        toName
        departmentType
        lead {
          id
          firstName
          lastName
          phoneNumbers {
            phone
            isPrimary
          }
        }
        user {
          firstName
          lastName
          phone
        }
        location {
          id
          title
        }
        callRecordings {
          recordingUrl
        }
        callInitiationRequest {
          id
          callInitiationType
        }
        wasAnswered
        callerOutcome
        eaiCallerOutcome
        aiSentiment
        aiSummary
        aiTopics
        extraData
      }
    }
  }
`;

export const GET_CALL_BY_DATE = gql`
  query getCallsByDate(
    $userId: Int
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $departmentTypes: [String]
  ) {
    getCallsByDate(
      userId: $userId
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      departmentTypes: $departmentTypes
    ) {
      statusCode
      message
      data {
        name
        inboundCalls
        outboundCalls
        totalCalls
      }
    }
  }
`;

export const EXPORT_CALLS_DETAILS_SUMMARY = gql`
  query exportCallDetailSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $groupBy: String
    $departmentTypes: [String]
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    exportCallDetailSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      groupBy: $groupBy
      departmentTypes: $departmentTypes
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      exportRequest {
        id
        status
        fileName
        fileUrl
        exportCategory
      }
    }
  }
`;

export const EXPORT_CALLS_DETAILS_BY_USER = gql`
  query exportCallsByUser(
    $userId: Int
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $departmentTypes: [String]
    $search: String
    $direction: String
    $callerOutcomes: [String]
    $wasAnswered: Boolean
    $orderBy: String
    $orderDirection: String
  ) {
    exportCallsByUser(
      userId: $userId
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      departmentTypes: $departmentTypes
      search: $search
      direction: $direction
      callerOutcomes: $callerOutcomes
      wasAnswered: $wasAnswered
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      exportRequest {
        id
        status
        fileName
        fileUrl
        exportCategory
      }
    }
  }
`;

export const GET_CALL_DETAILS_BY_ID = gql`
  query getCall($callId: Int, $callSid: String) {
    getCall(callId: $callId, callSid: $callSid) {
      id
      callSid
      startedAt
      durationSeconds
      direction
      fromNumber
      fromName
      toNumber
      toName
      departmentType
      lead {
        firstName
        lastName
        phoneNumbers {
          phone
          isPrimary
        }
      }
      user {
        firstName
        lastName
        phone
      }
      location {
        title
      }
      wasAnswered
      callerOutcome
      eaiCallerOutcome
      aiSentiment
      aiSummary
      callParticipants {
        id
        name
        calleeName
        phoneNumber
        lead {
          firstName
          lastName
        }
        user {
          firstName
          lastName
        }
      }
      callRecordings {
        recordingSid
        recordingUrl
        transcriptUrl
        callParticipant {
          userId
          leadId
          name
          calleeName
        }
      }
      callInitiationRequest {
        id
        callInitiationType
      }
      extraData
    }
  }
`;

export const GET_CALL_NOTE_DETAIL = gql`
  query getCallNoteDetail($token: String!) {
    getCallNoteDetail(token: $token) {
      statusCode
      statusMessage
      call {
        id
        callSid
        startedAt
        durationSeconds
        direction
        fromNumber
        fromName
        toNumber
        toName
        departmentType
        company {
          id
          name
          profilePic
          crmIntegration {
            id
            integrationType
            locationId
          }
        }
        lead {
          id
          firstName
          lastName
          phoneNumbers {
            phone
            isPrimary
          }
        }
        user {
          firstName
          lastName
          phone
        }
        location {
          id
          title
        }
        wasAnswered
        callerOutcome
        eaiCallerOutcome
        aiSentiment
        aiSummary
        callParticipants {
          id
          name
          calleeName
          phoneNumber
        }
        callRecordings {
          recordingSid
          recordingUrl
          transcriptUrl
        }
        callInitiationRequest {
          id
          callInitiationType
        }
      }
      relativeCalls {
        id
        callSid
        startedAt
        durationSeconds
        direction
        fromNumber
        fromName
        toNumber
        toName
        departmentType
        lead {
          id
          firstName
          lastName
          phoneNumbers {
            phone
            isPrimary
          }
          crmLeadObj {
            activeLeadOpportunity {
              id
              dsOpportunityEvents {
                dsLeadId
                dsEventId
              }
              sfLeadOpportunities {
                sfLeadId
                sfOpportunityId
              }
              vsLeadOpportunities {
                vsContactId
                vsLeadId
              }
              elLeadOpportunities {
                id
                elOpportunityId
                elLeadId
              }
              mfLeadOpportunities {
                id
                mfProspectId
                mfCustomerId
                mfLeadId
              }
            }
            dsExtractedLead {
              dsLeadId
            }
            activeDsOpportunityEvent {
              dsMarketingChannelName
            }
          }
        }
        user {
          firstName
          lastName
          phone
        }
        location {
          id
          title
        }
        wasAnswered
        callerOutcome
        eaiCallerOutcome
        aiSentiment
        aiSummary
        callParticipants {
          id
          name
          calleeName
          phoneNumber
        }
        callRecordings {
          recordingSid
          recordingUrl
          transcriptUrl
        }
        callInitiationRequest {
          id
          callInitiationType
        }
      }
    }
  }
`;

export const EXPORT_EMAIL_DETAILS_SUMMARY = gql`
  query exportEmailLocationStatistics(
    $locationId: Int
    $fileName: String
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $exportType: String
    $emailId: String
    $orderDirection: String
  ) {
    exportEmailLocationStatistics(
      locationId: $locationId
      fileName: $fileName
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      exportType: $exportType
      emailId: $emailId
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      exportRequest {
        id
        status
        fileName
        fileUrl
      }
    }
  }
`;

export const EXPORT_EMAIL_TYPE_DETAILS = gql`
  query exportEmailTypeDetailsByLocation(
    $locationId: Int!
    $fileName: String
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $campaignIds: [Int]
    $employeeIds: [Int]
    $emailType: String!
    $status: [String]
    $sentAt: [DateTime]
    $statusUpdateAt: [DateTime]
    $exportType: String
    $emailId: String
    $orderBy: String
    $orderDirection: String
  ) {
    exportEmailTypeDetailsByLocation(
      locationId: $locationId
      fileName: $fileName
      dateRange: $dateRange
      filterType: $filterType
      search: $search
      campaignIds: $campaignIds
      employeeIds: $employeeIds
      emailType: $emailType
      status: $status
      sentAt: $sentAt
      statusUpdateAt: $statusUpdateAt
      exportType: $exportType
      emailId: $emailId
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      exportRequest {
        id
        status
        fileName
        fileUrl
        exportCategory
      }
    }
  }
`;

export const LISTING_WORKING_HOURS = gql`
  query listWorkingHours(
    $companyId: Int!
    $locationId: Int
    $departmentId: Int
    $responseBy: String!
  ) {
    listWorkingHours(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      responseBy: $responseBy
    ) {
      statusCode
      message
      workingHours {
        company {
          id
          name
        }
        location {
          id
          title
        }
        department {
          id
          name
        }
        workingHours {
          id
          weekDay
          isWorkingDay
          startTime
          endTime
          isActive
          isDeleted
          createdOn
        }
      }
    }
  }
`;

export const GET_DATA_SERVICE_LIST = gql`
  query getDataService($search: String) {
    getDataService(search: $search) {
      id
      serviceName
      createTs
      updateTs
    }
  }
`;

export const GET_DATA_SERVICE_CONFIG_LIST = gql`
  query getDataServiceConfig(
    $companyId: Int!
    $locationId: Int
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $search: String
  ) {
    getDataServiceConfig(
      companyId: $companyId
      locationId: $locationId
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
    ) {
      statusCode
      message
      count
      data {
        id
        companyId
        locationId
        dataService {
          id
          serviceName
        }
        runParams
        isActive
        createTs
        updateTs
      }
    }
  }
`;

export const GET_DATA_SERVICE_BY_ID = gql`
  query getDynamicConfig($id: Int, $code: String) {
    getDynamicConfig(id: $id, code: $code) {
      id
      code
      title
      isActive
      description
      data
      updateTs
      createTs
    }
  }
`;

export const GET_LOCATION_DETAILS = gql`
  query getSpecificLocation($locationId: Int!) {
    getSpecificLocation(locationId: $locationId) {
      id
      companyId
      regionId
      locationType
      title
      phone
      email
      addressLine1
      city
      state
      postalCode
      country
      geoLink
      website
      timezone
      isActive
      isDefault
      inventoryUrlFormat
      region {
        id
        name
      }
      workingHours {
        id
      }
      opportunityStatuses {
        id
      }
      opportunityType {
        id
        name
      }
      openaiApiKey
      notes
      settings
    }
  }
`;

export const GET_MESSAGE_FEEDBACK_OPTIONS = gql`
  query getMessageFeedbackOptions(
    $companyId: Int!
    $locationId: Int
    $departmentId: Int
    $messageId: Int
  ) {
    getMessageFeedbackOptions(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      messageId: $messageId
    ) {
      id
      companyId
      isEnableAdditionalComments
      name
      isActive
      emails
    }
  }
`;

export const GET_MESSAGE_FEEDBACK_OPTIONS_ACTIVITY_CENTER = gql`
  query getMessageFeedbackOptions(
    $companyId: Int!
    $locationId: Int
    $departmentId: Int
    $messageId: Int
  ) {
    getMessageFeedbackOptions(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      messageId: $messageId
    ) {
      id
      companyId
      isEnableAdditionalComments
      name
      isActive
    }
  }
`;

export const GET_OTTO_ANALYTICS_SUMMARY = gql`
  query getOttoAnalyticsSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoAnalyticsSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalOttoActions
      totalEmployeeActions
      leadsEngaged
      ottoActions {
        status
        ottoCount
        employeeCount
        aiAssistedCount
        leadCount
        totalCount
        ottoSuggested
      }
    }
  }
`;

export const GET_OTTO_MESSAGE_STATISTICS = gql`
  query getOttoMessageStatistics(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoMessageStatistics(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalOttoMessages
      totalEmployeeMessages
      messageGraph {
        name
        ottoCount
        employeeCount
        aiAssistedCount
      }
    }
  }
`;

export const GET_OTTO_APPOINTMENT_STATISTICS = gql`
  query getOttoAppointmentStatistics(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoAppointmentStatistics(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalOttoAppointments
      totalEmployeeAppointments
      appointmentGraph {
        name
        ottoCount
        employeeCount
      }
      countsByStatus {
        status
        ottoCounts
        employeeCounts
      }
    }
  }
`;

export const GET_VEHICLE_TRADE_OVERVIEW = gql`
  query getVehicleTradeOverview(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $page: Int
    $pageSize: Int
    $category: String
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getVehicleTradeOverview(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      page: $page
      pageSize: $pageSize
      category: $category
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      buyData {
        vehicleName
        totalInterestedLeads
        totalSoldVehicles
      }
      sellData {
        vehicleName
        totalInterestedLeads
        totalSoldVehicles
      }
      soldData {
        vehicleName
        totalInterestedLeads
        totalSoldVehicles
      }
      buyTotalCount
      sellTotalCount
      soldTotalCount
    }
  }
`;

export const GET_CAMPAIGN_STATISTICS = gql`
  query getCampaignStatistics(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getCampaignStatistics(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      campaignName
      messagesSent
      responsesReceived
      responseRatePercentage
      appointmentsBooked
      appointmentRatePercentage
      opportunitiesSold
      soldRatePercentage
    }
  }
`;

export const GET_OTTO_ACTIVITIES = gql`
  query getOttoActivities(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoActivities(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalActivities
      priceAlert
      lostLeadFollowUp
      inventoryLink
      creditLink
    }
  }
`;

export const GET_RESPONSE_TIME_ANALYSIS = gql`
  query getResponseTimeAnalysis(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getResponseTimeAnalysis(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      ottoSpeedToLead
      avgOttoResponseTime
      avgEmployeeResponseTime
    }
  }
`;

export const GET_LEAD_INTERACTION_BY_OTTO = gql`
  query getLeadInteractionByOtto(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getLeadInteractionByOtto(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      statusId
      status
      count
      totalCount
      messageCount
      totalMessageCount
      children {
        statusId
        status
        count
        totalCount
        messageCount
        totalMessageCount
        children {
          statusId
          status
          count
          totalCount
          messageCount
          totalMessageCount
        }
      }
    }
  }
`;

export const GET_OTTO_STATISTICS_SUMMARY = gql`
  query getOttoStatisticsSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $isOttoMessages: Boolean
    $isEmployeeMessages: Boolean
    $isAiAssistedMessages: Boolean
    $ottoAfterHourEngagement: Boolean
    $employeeAfterHourEngagement: Boolean
    $campaignMessages: Boolean
    $search: String
    $page: Int
    $pageSize: Int
    $userIds: [Int]
    $orderBy: String
    $orderDirection: String
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoStatisticsSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      isOttoMessages: $isOttoMessages
      isEmployeeMessages: $isEmployeeMessages
      isAiAssistedMessages: $isAiAssistedMessages
      ottoAfterHourEngagement: $ottoAfterHourEngagement
      employeeAfterHourEngagement: $employeeAfterHourEngagement
      campaignMessages: $campaignMessages
      search: $search
      page: $page
      pageSize: $pageSize
      userIds: $userIds
      orderBy: $orderBy
      orderDirection: $orderDirection

      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        id
        content
        lead {
          id
          fullName
          phoneNumbers {
            phone
            isPrimary
          }
          emails {
            email
            isPrimary
          }
          location {
            title
            id
          }
        }
        user {
          id
          firstName
          lastName
        }
        campaign {
          name
        }
        dateSent
      }
      totalCounts
    }
  }
`;

export const OTTO_APPOINTMENT_LIST = gql`
  query GetOttoAppointmentDetails(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $isOttoAppointments: Boolean
    $isEmployeeAppointments: Boolean
    $opportunityStatusIds: [Int]
    $activity: [String]
    $search: String
    $createdByIds: [Int]
    $updatedByIds: [Int]
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoAppointmentDetails(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      isOttoAppointments: $isOttoAppointments
      isEmployeeAppointments: $isEmployeeAppointments
      opportunityStatusIds: $opportunityStatusIds
      activity: $activity
      search: $search
      createdByIds: $createdByIds
      updatedByIds: $updatedByIds
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalCounts
      data {
        id
        uid
        leadId
        leadName
        leadOpportunityId
        opportunityStatusName
        assignedTo
        startDatetime
        endDatetime
        activity
        createdByUserType
        dateCreated
        dateUpdated
        createdByName
        updatedByName
        assignedToName
      }
    }
  }
`;

export const GET_OTTO_CALL_SUMMARY = gql`
  query getOttoCallSummary(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $direction: String
    $departmentTypes: [String]
    $fromName: String
    $toName: String
    $fromNumber: String
    $toNumber: String
    $duration: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoCallSummary(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      direction: $direction
      departmentTypes: $departmentTypes
      fromName: $fromName
      toName: $toName
      fromNumber: $fromNumber
      toNumber: $toNumber
      duration: $duration
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        id
        fromName
        fromNumber
        toName
        toNumber
        durationSeconds
        direction
        startedAt
        location {
          title
        }
        department {
          name
        }
        callRecordings {
          recordingUrl
        }
        lead {
          id
          fullName
          phoneNumbers {
            phone
            isPrimary
          }
          emails {
            email
            isPrimary
          }
          location {
            title
            id
          }
        }
      }
      count
    }
  }
`;

export const GET_MESSAGE_NOTES = gql`
  query getMessageNotes($messageId: Int!) {
    getMessageNotes(messageId: $messageId) {
      messageNoteObject {
        noteId
        content {
          id
          notes
          createTs
          updateTs
          messageId
          createdBy {
            fullName
          }
        }
        associatedUsers {
          id
          fullName
        }
        childNotes {
          noteId
          content {
            id
            messageId
            notes
            createTs
            updateTs
            createdBy {
              fullName
            }
          }
          associatedUsers {
            id
            fullName
          }
        }
      }
    }
  }
`;

export const GET_MESSAGE_FEEDBACKS = gql`
  query getMessageFeedback($messageId: Int!, $userId: Int!) {
    getMessageFeedback(messageId: $messageId, userId: $userId) {
      id
      rating
      additionalComments
      status
      messageFeedbackOptionSelection {
        messageFeedbackOption {
          id
          name
        }
      }
    }
  }
`;

// All feedback left on a message, across every user (for the feedback list drawer).
export const GET_MESSAGE_FEEDBACK_LIST = gql`
  query getMessageFeedbacks($messageId: Int!) {
    getMessageFeedbacks(messageId: $messageId) {
      id
      userId
      rating
      additionalComments
      status
      createTs
      updateTs
      user {
        id
        fullName
        companyRole {
          id
          name
        }
        location {
          id
          title
        }
      }
      updatedBy {
        id
        fullName
      }
      messageFeedbackOptionSelection {
        messageFeedbackOption {
          id
          name
        }
      }
    }
  }
`;

export const GET_MESSAGE_FORWARD_OPTIONS = gql`
  query getMessageForwardOptions($locationId: Int!, $companyId: Int!) {
    getMessageForwardOptions(locationId: $locationId, companyId: $companyId) {
      isForwardSms
      isForwardEmail
      isForwardNotification
    }
  }
`;

export const GET_LEAD_AI_OTTO_OVERVIEW = gql`
  query getAiOttoOverview(
    $companyId: Int!
    $locationId: Int!
    $leadId: Int!
    $applicationUseCaseId: Int!
  ) {
    getAiOttoOverview(
      leadId: $leadId
      companyId: $companyId
      locationId: $locationId
      applicationUseCaseId: $applicationUseCaseId
    ) {
      id
      leadId
      responseText
    }
  }
`;

export const GET_OTTO_EMAILS = gql`
  query getEmails(
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $search: String
    $leadIds: [Int]
    $emailStatus: [String]
    $emailTypes: [String]
    $skipFilter: Boolean
    $isDeleted: Boolean
    $userIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $isOttoEmails: Boolean
    $isEmployeeEmails: Boolean
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getEmails(
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
      leadIds: $leadIds
      emailStatus: $emailStatus
      emailTypes: $emailTypes
      skipFilter: $skipFilter
      isDeleted: $isDeleted
      userIds: $userIds
      filterType: $filterType
      dateRange: $dateRange
      isOttoEmails: $isOttoEmails
      isEmployeeEmails: $isEmployeeEmails
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      data {
        id
        sesMessageId
        from_
        to
        subject
        bodyHtml
        createTs
        status
        type
        latestActivityTs
        lead {
          id
          fullName
          location {
            title
          }
          phoneNumbers {
            id
            phone
            isPrimary
          }
          emails {
            email
            isPrimary
          }
        }
        message {
          id
          user {
            id
            firstName
            lastName
          }
          mmsObjects {
            id
            mediaUrl
            mediaType
            size
          }
          direction
        }
      }
      count
    }
  }
`;

export const GET_OTTO_NOTES_DETAILS = gql`
  query GetOttoNotesDetails(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $isOttoNotes: Boolean
    $isEmployeeNotes: Boolean
    $search: String
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
    $createdByIds: [Int]
    $updatedByIds: [Int]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
  ) {
    getOttoNotesDetails(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      isOttoNotes: $isOttoNotes
      isEmployeeNotes: $isEmployeeNotes
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
      createdByIds: $createdByIds
      updatedByIds: $updatedByIds
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
    ) {
      totalCounts
      data {
        id
        leadId
        leadName
        leadOpportunityId
        opportunityStatusId
        opportunityStatusName
        note
        createdById
        createdByName
        updatedById
        updatedByName
        createTs
        updateTs
      }
    }
  }
`;

export const GET_GOTO_CALL_EXTENSIONS = gql`
  query getCallExtensions(
    $locationId: Int!
    $departmentLevel: String
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $isActive: Boolean
    $unassignedUser: Boolean
    $originalLocationId: Int
  ) {
    getCallExtension(
      locationId: $locationId
      departmentLevel: $departmentLevel
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      isActive: $isActive
      unassignedUser: $unassignedUser
      originalLocationId: $originalLocationId
    ) {
      count
      data {
        id
        number
        name
        user {
          id
          fullName
          phone
        }
        omitFromDirectory
        type
        departmentLevel
        isActive
        originalLocation {
          id
          title
        }
      }
    }
  }
`;

export const GET_GOTO_PHONE_NUMBERS = gql`
  query getCallPhoneNumber(
    $locationId: Int!
    $departmentLevel: String
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $isActive: Boolean
    $unassignedUser: Boolean
    $originalLocationId: Int
  ) {
    getCallPhoneNumber(
      locationId: $locationId
      departmentLevel: $departmentLevel
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      isActive: $isActive
      unassignedUser: $unassignedUser
      originalLocationId: $originalLocationId
    ) {
      count
      data {
        id
        phoneNumber
        name
        user {
          id
          fullName
          phone
        }
        callExtension {
          id
          number
        }
        callerName
        routingType
        routingValue
        departmentLevel
        isActive
        originalLocation {
          id
          title
        }
      }
    }
  }
`;

export const GET_GOTO_USERS = gql`
  query getCallUser(
    $locationId: Int!
    $departmentLevel: String
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $isActive: Boolean
    $unassignedUser: Boolean
    $originalLocationId: Int
  ) {
    getCallUser(
      locationId: $locationId
      departmentLevel: $departmentLevel
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      isActive: $isActive
      unassignedUser: $unassignedUser
      originalLocationId: $originalLocationId
    ) {
      count
      data {
        id
        isActive
        callUserLines {
          name
          number
          callPhoneNumber {
            name
            phoneNumber
          }
          callExtension {
            number
          }
        }
        user {
          id
          fullName
          phone
        }
        departmentLevel
        originalLocation {
          id
          title
        }
      }
    }
  }
`;

export const GET_GOTO_DEVICES = gql`
  query getCallDevice(
    $locationId: Int!
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $isActive: Boolean
    $unassignedUser: Boolean
    $originalLocationId: Int
  ) {
    getCallDevice(
      locationId: $locationId
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      isActive: $isActive
      unassignedUser: $unassignedUser
      originalLocationId: $originalLocationId
    ) {
      count
      data {
        id
        name
        modelName
        department {
          name
        }
        user {
          id
          fullName
          phone
        }
        callUser {
          callUserLines {
            callExtension {
              name
              number
            }
          }
        }
        macAddress
        isActive
        originalLocation {
          id
          title
        }
      }
    }
  }
`;

export const GOTO_DASHBOARD_SUMMARY = gql`
  query getgotoDashboardSummary($locationId: Int!) {
    getGotoDashboardSummary(locationId: $locationId) {
      totalUsers
      unassignedUsers
      totalExtensions
      unassignedExtensions
      totalPhoneNumbers
      unassignedPhoneNumbers
      standardNumbers
      tollfreeNumbers
      totalDevices
      unassignedDevices
      statusCode
      message
    }
  }
`;

export const GET_SUPPORTED_LANGUAGES_BY_LOCATION = gql`
  query getSupportedLanguagesByLocation($locationId: Int) {
    getSupportedLanguages(locationId: $locationId) {
      id
      languageName
      languageCode
      companyId
      isActive
      isDefault
    }
  }
`;

// It is open query
export const GET_AWS_SUPPORTED_LANGUAGES = gql`
  query getSupportedLanguages {
    getSupportedLanguages {
      statusCode
      message
      data
    }
  }
`;

export const GET_ABANDONED_CALLS_STATISTICS = gql`
  query getAbandonedCallStatistics(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $callbackStatus: String
    $callbackResult: String
    $isAbandoned: Boolean
    $waitingTime: String
    $waitingTimeOperator: String
    $orderBy: String
    $orderDirection: String
    $departmentTypes: [String]
  ) {
    getAbandonedCallStatistics(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      callbackStatus: $callbackStatus
      callbackResult: $callbackResult
      isAbandoned: $isAbandoned
      waitingTime: $waitingTime
      orderBy: $orderBy
      orderDirection: $orderDirection
      waitingTimeOperator: $waitingTimeOperator
      departmentTypes: $departmentTypes
    ) {
      data {
        leadNumber
        missedCalls
        voiceMails
        taskAssignedTo {
          id
          firstName
          lastName
        }
        primaryAssignedTo {
          id
          firstName
          lastName
        }
        lead {
          id
          fullName
        }
        calledTo
        opportunityStatusName
        opportunityStatusId
        opportunityCreatedDate
        abandonedCallCreateDate
        callbackStatus
        callbackResult
        waitingTime
        calledAt
        isAbandoned
        leadTaskId
        departmentType
      }
      totalCount
      totalVoicemails
      totalMissedCalls
      totalAbandonedCalls
      totalConnectedCalls
    }
  }
`;

export const GET_ABANDONED_CALLS_TASKS = gql`
  query getCallbackTasks(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $userIds: [Int]
    $createdByIds: [Int]
    $taskTypes: [String]
    $taskStatuses: [String]
    $status: String
    $orderBy: String
    $orderDirection: String
    $search: String
  ) {
    getCallbackTasks(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      userIds: $userIds
      createdByIds: $createdByIds
      taskTypes: $taskTypes
      taskStatuses: $taskStatuses
      status: $status
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
    ) {
      data {
        leadTaskId
        callbackResult
        callbackStatus
        leadTask {
          id
          title
          taskType
          taskStatus
          leadOpportunityId
          lead {
            id
            firstName
            lastName
            fullName
            leadOpportunities {
              id
              name
              isActive
              dtLeadOpportunities {
                id
                dtLeadSource {
                  dtLeadSourceName
                  leadSource {
                    id
                    name
                  }
                }
                dtLeadStatusMapping {
                  leadStatusType {
                    id
                    type
                    status
                  }
                  dtLeadStatus
                }
              }
              dsOpportunityEvents {
                id
                dsEventId
                dsLeadId
                dsEntitySource
                dsMarketingChannelName
                dsTrackingCode
                leadSource {
                  name
                }
              }
              sfLeadOpportunities {
                id
                sfOpportunityId
                sfOpportunityStage
              }
              vsLeadOpportunities {
                id
                vsContactId
                vsLeadId
                vsLeadStatusMapping {
                  vsLeadStatusType
                  vsLeadStatus
                }
              }
              elLeadOpportunities {
                id
                elOpportunityId
                elLeadId
              }
              mfLeadOpportunities {
                id
                mfProspectId
                mfCustomerId
                mfLeadId
              }
              dtLeadOpportunities {
                id
                dtOpportunityId
                dtOpportunityStage
              }
              tkLeadOpportunities {
                id
                tkLeadId
                tkContactId
                tkCustomerId
              }
            }
          }
          createdBy {
            id
            firstName
            lastName
            fullName
          }
          createTs
          dueDate
          completionDate
          completionNote
        }
        taskAssignments {
          id
          assignedTo {
            id
            firstName
            lastName
            fullName
          }
          assignmentType
        }
      }
      totalCount
      overdueCount
      upcomingCount
      completedCount
    }
  }
`;

export const GET_ALL_TEAMS_WITH_MEMBERS_DETAILS = gql`
  query getTeams($page: Int, $pageSize: Int, $search: String, $companyId: Int!, $locationId: Int) {
    getTeams(
      page: $page
      pageSize: $pageSize
      search: $search
      companyId: $companyId
      locationId: $locationId
    ) {
      data {
        id
        name
        leaderId
        status
        locationId
        leader {
          id
          fullName
        }
        members {
          memberId
          member {
            id
            fullName
            profilePic
            companyRole {
              name
            }
          }
        }
      }
      count
    }
  }
`;

export const GET_OPPORTUNITTIES_INVOICE_STATUS = gql`
  query getInvoiceStatus($opportunityTypeId: Int, $locationIds: [Int]) {
    getInvoiceStatus(opportunityTypeId: $opportunityTypeId, locationIds: $locationIds) {
      key
      name
      order
      childs {
        key
        name
        order
        childs {
          key
          name
          order
        }
      }
    }
  }
`;

export const GET_DMS_INTEGRATIONS = gql`
  query getIntegrationAdminSettings(
    $companyId: Int!
    $locationId: Int
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getIntegrationAdminSettings(
      companyId: $companyId
      locationId: $locationId
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        companyId
        locationId
        departmentId
        dmsType
        organizationId
        dealershipId
        active
        credentials
        settings
        createdAt
        updatedAt
        location {
          id
          title
        }
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_AUTO_RESPONDER_FEEDBACK_LOGS = gql`
  query getAutoResponderFeedbackLogs(
    $userId: Int
    $companyId: Int
    $locationId: Int
    $search: String
    $rating: String
    $status: String
    $feedbackOptionIds: [Int]
    # AUTORESPONDER | CAMPAIGN | DRAFT — see MESSAGE_FEEDBACK_TYPE.
    $feedbackType: String
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
  ) {
    getAutoResponderFeedbackLogs(
      userId: $userId
      companyId: $companyId
      locationId: $locationId
      search: $search
      rating: $rating
      status: $status
      feedbackOptionIds: $feedbackOptionIds
      feedbackType: $feedbackType
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
    ) {
      count
      data {
        id
        userId
        messageId
        rating
        feedbackType
        additionalComments
        createTs
        updateTs
        status
        reviewComment
        updatedBy {
          id
          fullName
        }
        user {
          id
          fullName
          companyId
          locationId
          companyRole {
            id
            name
          }
          role {
            id
            isCompanyAdmin
          }
          company {
            id
            name
          }
          location {
            id
            title
          }
          department {
            id
            name
          }
        }
        messageFeedbackOptionSelection {
          id
          messageFeedbackOption {
            id
            name
          }
        }
        message {
          id
          userId
          leadId
          direction
          content
          messageStatus
          contentType
          leadOpportunityId
          lead {
            id
            fullName
          }
        }
        # DRAFT rows are rated before the message exists, so message is null
        # for them - the body and lead come off the AI generation instead.
        aiResponseHistory {
          id
          responseText
          lead {
            id
            fullName
          }
        }
      }
    }
  }
`;

export const GET_LEAD_ROUTING_ASSIGNEE = gql`
  query getLeadRoutingAssignee($locationId: Int!) {
    getLeadRoutingAssignee(locationId: $locationId) {
      teams {
        id
        name
        userCount
      }
      companyRoles {
        id
        name
        userCount
      }
      users {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_USERS_BY_ASSIGNEE_TYPE = gql`
  query getUsersByAssigneeType(
    $locationId: Int!
    $typeId: Int!
    $assigneeType: String!
    $search: String
  ) {
    getUsersByAssigneeType(
      locationId: $locationId
      typeId: $typeId
      assigneeType: $assigneeType
      search: $search
    ) {
      id
      firstName
      lastName
      companyRole {
        name
      }
    }
  }
`;

export const SEARCH_LEADS_FOR_CO_BUYER = gql`
  query getLeads($page: Int, $pageSize: Int, $search: String) {
    getLeads(page: $page, pageSize: $pageSize, search: $search) {
      data {
        id
        firstName
        lastName
        phoneNumbers {
          phone
          isPrimary
        }
        emails {
          email
          isPrimary
        }
      }
      count
    }
  }
`;

export const GET_CO_BUYER_DETAIL = gql`
  query getLeadsById($leadIds: [Int]!) {
    getLeadsById(leadIds: $leadIds) {
      id
      firstName
      lastName
      phoneNumbers {
        id
        phone
        isPrimary
      }
      emails {
        id
        email
        isPrimary
      }
      addresses {
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
    }
  }
`;

export const GET_LINK_TRACKING_DETAIL = gql`
  query GetLinkTrackingDetail($messageId: Int!) {
    getLinkTrackingDetail(messageId: $messageId) {
      linkType
      isOpened
      openCount
      firstOpenedAt
      lastOpenedAt
      createTs
      trackingData
      mediaCount {
        image
        video
        document
        total
      }
    }
  }
`;

export const GET_LEAD_LINK_TRACKING = gql`
  query GetLeadLinkTracking($leadId: Int!) {
    getLeadLinkTracking(leadId: $leadId) {
      linkTrackings {
        messageId
        linkType
        isOpened
        openCount
        firstOpenedAt
        lastOpenedAt
        createTs
        trackingData
        mediaCount {
          image
          video
          document
          total
        }
      }
      mediaCount {
        image
        video
        document
        total
      }
    }
  }
`;

export const GET_USER_MEDIA_ENGAGEMENT = gql`
  query GetUserMediaEngagement(
    $userId: Int!
    $mediaType: String!
    $locationId: Int
    $opportunityTypeId: Int
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getUserMediaEngagement(
      userId: $userId
      mediaType: $mediaType
      locationId: $locationId
      opportunityTypeId: $opportunityTypeId
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      totalLeads
      leads {
        leadId
        leadName
        totalMedia
        lastSentAt
        method
        status
        openedAt
        totalWatchTime
        downloadedCount
        items {
          messageId
          mmsObjectId
          mediaUrl
          thumbnail
          sentAt
          method
          link
          status
          openedAt
          totalPlayDuration
          isDownloaded
          downloadCount
        }
      }
    }
  }
`;

export const GET_MMS_USERS_REPORT_DETAIL = gql`
  query getMmsUsersReportDetail(
    $locationId: Int
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
    $departmentIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
  ) {
    getMmsUsersReportDetail(
      locationId: $locationId
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
      departmentIds: $departmentIds
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      userStats {
        userId
        username
        department
        totalLeadOppsAssigned
        leadsWithVideo
        imagesSent
        imageViews
        imageViewRate
        imagesDownloaded
        imageDownloadRate
        videosSent
        videoViews
        videoViewRate
        videosDownloaded
        videoDownloadRate
        videoSentRate
        watchRate
        avgVideoDurationSeconds
        avgWatchDurationSeconds
        docsSent
        docsOpened
        docOpenRate
        docsDownloaded
        docDownloadRate
        mmsSent
        repliesReceived
        engagementRate
      }
      totals {
        totalLeadOppsAssigned
        leadsWithVideo
        imagesSent
        imageViews
        imageViewRate
        imagesDownloaded
        imageDownloadRate
        videosSent
        videoSentRate
        videoViews
        videoViewRate
        watchRate
        videosDownloaded
        videoDownloadRate
        avgWatchDurationSeconds
        avgVideoDurationSeconds
        docsSent
        docsOpened
        docOpenRate
        docsDownloaded
        docDownloadRate
        engagementRate
      }
      cards {
        key
        title
        value
        subtitle
        changePercent
      }
      totalCount
      statusCode
      message
    }
  }
`;

export const EXPORT_COMMUNICATION_BY_SALESPERSON = gql`
  query exportCommunicationBySalesperson(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $dateRange: [DateTime]
    $orderBy: String
    $orderDirection: String
    $opportunityTypeId: Int
    $exportType: String
    $fileName: String
    $emailId: String
    $locationId: Int
  ) {
    exportCommunicationBySalesperson(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      dateRange: $dateRange
      orderBy: $orderBy
      orderDirection: $orderDirection
      opportunityTypeId: $opportunityTypeId
      exportType: $exportType
      fileName: $fileName
      emailId: $emailId
      locationId: $locationId
    ) {
      statusCode
      message
      exportRequest {
        id
        fileName
        fileUrl
        status
      }
    }
  }
`;

export const EXPORT_MMS_USERS_REPORT_DETAIL = gql`
  query ExportMmsUsersReportDetail(
    $locationId: Int
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
    $departmentIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $orderBy: String
    $orderDirection: String
    $exportType: String
    $fileName: String
    $emailId: String
  ) {
    exportMmsUsersReportDetail(
      locationId: $locationId
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
      departmentIds: $departmentIds
      filterType: $filterType
      dateRange: $dateRange
      orderBy: $orderBy
      orderDirection: $orderDirection
      exportType: $exportType
      fileName: $fileName
      emailId: $emailId
    ) {
      exportRequest {
        id
        status
        fileName
        fileUrl
        exportType
        exportCategory
        errorMessage
        createdAt
        updatedAt
      }
      statusCode
      message
    }
  }
`;

export const GET_COMMUNICATION_DETAILS = gql`
  query getCommunicationDetails(
    $direction: String
    $channel: String
    $sendType: String
    $emailStatus: [String]
    $filterType: String
    $dateRange: [DateTime]
    $search: String
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
    $opportunitySourceIds: [Int]
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
  ) {
    getCommunicationDetails(
      direction: $direction
      channel: $channel
      sendType: $sendType
      emailStatus: $emailStatus
      filterType: $filterType
      dateRange: $dateRange
      search: $search
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
      opportunitySourceIds: $opportunitySourceIds
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
    ) {
      count
      summary {
        otto
        aiAssisted
        aiAssistedEdited
        aiAssistedTotal
        manual
        textSent
        emailSent
        callSent
        totalSent
        textReceived
        emailReceived
        callReceived
        totalReceived
      }
      data {
        messageId
        leadId
        userId
        leadOpportunityId
        campaignId
        emailId
        customerName
        userName
        dateTime
        campaignName
        message
        direction
        channel
        messageType
        sendType
        messageStatus
        errorCode
        errorMessage
        statusCode
        email {
          id
          from_
          to
          subject
          bodyText
          bodyHtml
          status
          bounceType
          bounceSubtype
        }
        call {
          id
          callSid
          direction
          status
          wasAnswered
          callerOutcome
          eaiCallerOutcome
          startedAt
          answeredAt
          endedAt
          durationSeconds
          ringTimeSeconds
          talkTimeSeconds
          fromNumber
          toNumber
          fromName
          toName
          callType
          callPurpose
        }
      }
    }
  }
`;

export const GET_USER_REVIEW_DETAIL = gql`
  query getUserReviewDetail(
    $filterType: String
    $userIds: [Int]
    $teamIds: [Int]
    $reviewStatus: String
    $search: String
    $page: Int
    $pageSize: Int
    $orderBy: String
    $orderDirection: String
    $dateRange: [DateTime]
    $lastUpdatedRange: [DateTime]
    $opportunityTypeId: Int
  ) {
    getUserReviewDetail(
      filterType: $filterType
      userIds: $userIds
      teamIds: $teamIds
      reviewStatus: $reviewStatus
      search: $search
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      orderDirection: $orderDirection
      dateRange: $dateRange
      lastUpdatedRange: $lastUpdatedRange
      opportunityTypeId: $opportunityTypeId
    ) {
      count
      data {
        lead {
          id
          firstName
          lastName
          fullName
          crmLeadObj {
            dsExtractedLead {
              dsLeadId
            }
            sfExtractedLead {
              sfLeadId
            }
            dtExtractedLead {
              dtLeadId
            }
            vsExtractedLead {
              vsLeadId
            }
            elExtractedLead {
              elLeadId
            }
            mfExtractedLead {
              mfProspectId
              mfCustomerId
            }
          }
        }
        user {
          id
          firstName
          lastName
          email
        }
        opportunity {
          id
          leadId
          name
          # BE-resolved CRM deep-link. crmUrl is the plain URL string;
          # crmLink is the unified url+label payload. Together they let
          # Service / Repair-Order opps (e.g. Tekion, where tkLeadId is NULL
          # but tkRepairOrderId is set) render a correct clickable CRM id
          # instead of falling back to a non-linked EAI id. Mirrors the
          # opportunity card: prefer crmUrl, fall back to the FE-resolved link.
          crmUrl
          crmLink {
            url
            id
            prefix
            kind
          }
          dsOpportunityEvents {
            dsLeadId
            dsEventId
          }
          dtLeadOpportunities {
            dtOpportunityId
          }
          tkLeadOpportunities {
            id
            tkLeadId
            tkContactId
            tkCustomerId
          }
          sfLeadOpportunities {
            sfLeadId
            sfOpportunityId
          }
          vsLeadOpportunities {
            vsContactId
            vsLeadId
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            isActive
            user {
              id
              firstName
              lastName
              email
              companyRole {
                id
                name
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            customerInterest
            isCurrent
            isPrimary
          }
          opportunityType {
            parentType {
              name
            }
          }
        }
        links {
          shortenUrlId
          activities {
            id
            actionType
            messageId
            actionValue
            createTs
            user {
              id
              fullName
            }
          }
        }
        # Lead's free-text feedback response. Shown as a tooltip on the
        # "feedback submitted" status icon and in the View Feedback drawer.
        # user/leadOpportunity are nested here (not the top-level user/
        # opportunity fields above, which feed the User name / Opportunity
        # table columns) — BE contract for the review-response entity.
        reviewResponse {
          responseType
          comment
          commentTs
          user {
            id
            firstName
            lastName
            companyRole {
              name
            }
          }
          leadOpportunity {
            id
            leadId
            name
            crmUrl
            crmLink {
              url
              id
              prefix
              kind
            }
            leadOpportunityUsers {
              id
              userTypeId
              userId
              isActive
              user {
                id
                firstName
                lastName
                email
                companyRole {
                  id
                  name
                }
              }
              userType {
                name
              }
            }
            vehiclesOfInterest {
              year
              make
              model
              customerInterest
              isPrimary
            }
            opportunityType {
              parentType {
                name
              }
            }
          }
        }
      }
    }
  }
`;

// ---------------------------------------------------------------------------
// OttoVin Reports (vehicle/content engagement) — proxied via WebApp-API from
// OttoVin's /api/analytics. Each returns a GenericScalar (JSON) mirroring
// OttoVin's response shapes verbatim, so no sub-selection is needed.
// ---------------------------------------------------------------------------
export const GET_OTTO_VIN_OVERVIEW = gql`
  query getOttoVinOverview($locationId: Int!, $days: Int, $start: String, $end: String) {
    getOttoVinOverview(locationId: $locationId, days: $days, start: $start, end: $end)
  }
`;

export const GET_OTTO_VIN_PRINT_JOBS = gql`
  query getOttoVinPrintJobs($locationId: Int!) {
    getOttoVinPrintJobs(locationId: $locationId)
  }
`;

// Vehicle Assets → Documents: list a location's documents (proxy to the
// document-service). Returns a GenericScalar array; each item carries its
// association, doc_type, kind, label, signed url, public_url, etc.
export const GET_VEHICLE_DOCUMENTS = gql`
  query getDocuments($companyId: Int!, $locationId: Int) {
    getDocuments(companyId: $companyId, locationId: $locationId)
  }
`;

// Inventory → Embed: mint the OttoVin website-embed token for a location
// (proxy to OttoVin's machine embed-token API). Returns { token, base_url }.
export const GET_OTTOVIN_EMBED_TOKEN = gql`
  query getOttoVinEmbedToken($locationId: Int!) {
    getOttoVinEmbedToken(locationId: $locationId)
  }
`;

// Inventory → Vehicle Assets → Vehicle Brochures: manufacturer-brochure catalog
// search (proxy to OttoVin). Returns { brochures: [{ id, title, year, make,
// model, trim, mime_type, url }] } where url is an absolute signed PDF proxy.
export const GET_OTTOVIN_BROCHURES = gql`
  query getOttoVinBrochures(
    $make: String
    $model: String
    $year: String
    $trim: String
    $limit: Int
  ) {
    getOttoVinBrochures(make: $make, model: $model, year: $year, trim: $trim, limit: $limit)
  }
`;

export const GET_OTTO_VIN_PRINT_JOB = gql`
  query getOttoVinPrintJob($locationId: Int!, $jobId: String!) {
    getOttoVinPrintJob(locationId: $locationId, jobId: $jobId)
  }
`;

export const GET_OTTO_VIN_VEHICLES = gql`
  query getOttoVinVehicles(
    $locationId: Int!
    $days: Int
    $start: String
    $end: String
    $limit: Int
  ) {
    getOttoVinVehicles(
      locationId: $locationId
      days: $days
      start: $start
      end: $end
      limit: $limit
    )
  }
`;

export const GET_OTTO_VIN_SESSIONS = gql`
  query getOttoVinSessions(
    $locationId: Int!
    $days: Int
    $start: String
    $end: String
    $kind: String
    $limit: Int
  ) {
    getOttoVinSessions(
      locationId: $locationId
      days: $days
      start: $start
      end: $end
      kind: $kind
      limit: $limit
    )
  }
`;

export const GET_OTTO_VIN_LEADS = gql`
  query getOttoVinLeads($locationId: Int!, $days: Int, $start: String, $end: String, $limit: Int) {
    getOttoVinLeads(locationId: $locationId, days: $days, start: $start, end: $end, limit: $limit)
  }
`;

export const GET_OTTO_VIN_LIVE_ACTIVITY = gql`
  query getOttoVinLiveActivity($locationId: Int!, $start: String, $end: String, $limit: Int) {
    getOttoVinLiveActivity(locationId: $locationId, start: $start, end: $end, limit: $limit)
  }
`;

export const GET_OTTO_VIN_CONTENT_STATUS = gql`
  query getOttoVinContentStatus($locationId: Int!, $status: String) {
    getOttoVinContentStatus(locationId: $locationId, status: $status)
  }
`;

export const GET_OTTO_VIN_SESSION_DETAIL = gql`
  query getOttoVinSessionDetail($locationId: Int!, $sessionId: String!) {
    getOttoVinSessionDetail(locationId: $locationId, sessionId: $sessionId)
  }
`;

export const GET_OTTO_VIN_VEHICLE_DETAIL = gql`
  query getOttoVinVehicleDetail(
    $locationId: Int!
    $vin: String!
    $days: Int
    $start: String
    $end: String
  ) {
    getOttoVinVehicleDetail(
      locationId: $locationId
      vin: $vin
      days: $days
      start: $start
      end: $end
    )
  }
`;

export const GET_OTTO_VIN_LEAD_DETAIL = gql`
  query getOttoVinLeadDetail(
    $locationId: Int!
    $leadId: String!
    $days: Int
    $start: String
    $end: String
  ) {
    getOttoVinLeadDetail(
      locationId: $locationId
      leadId: $leadId
      days: $days
      start: $start
      end: $end
    )
  }
`;

export const GET_OTTO_VIN_LEAD_CHAT = gql`
  query getOttoVinLeadChat($locationId: Int!, $leadId: String!) {
    getOttoVinLeadChat(locationId: $locationId, leadId: $leadId)
  }
`;

export const GET_OTTO_VIN_ELEMENT_LEADS = gql`
  query getOttoVinElementLeads(
    $locationId: Int!
    $kind: String!
    $key: String!
    $days: Int
    $start: String
    $end: String
    $limit: Int
  ) {
    getOttoVinElementLeads(
      locationId: $locationId
      kind: $kind
      key: $key
      days: $days
      start: $start
      end: $end
      limit: $limit
    )
  }
`;

export const DAILY_CHECKIN_REPORT_SUMMARY = gql`
  query getCheckoutReportSummary(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
  ) {
    getCheckoutReportSummary(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      statusCode
      message
      kpiCards {
        key
        title
        value
        subtitle
      }
      messageSentBreakdown {
        total
        items {
          name
          value
        }
      }
      newLeadsBreakdown {
        total
        items {
          name
          value
        }
      }
      appointmentsBreakdown {
        total
        items {
          name
          value
        }
      }
      taskStatusBreakdown {
        completedPct
        items {
          name
          value
        }
      }
      callsChart {
        inboundCall
        outboundCall
        inboundVm
        outboundVm
        totalCalls
        talktimeSeconds
      }
      salesPipeline {
        total
        items {
          name
          value
        }
      }
      completedPipeline {
        total
        items {
          name
          value
        }
      }
    }
  }
`;

export const GET_DAILY_ACTIVITIES = gql`
  query getCheckoutActivityNeedsAttention(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $completed: Boolean
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $taskType: String
  ) {
    getCheckoutActivityNeedsAttention(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      completed: $completed
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      taskType: $taskType
    ) {
      statusCode
      message
      count
      data {
        id
        type
        title
        opportunity
        status
        vehicle
        dueDate
        leadName
        leadId
        leadOpportunityId
        lead {
          leadOpportunities {
            id
            name
            isActive
            dtLeadOpportunities {
              id
              dtLeadSource {
                dtLeadSourceName
                leadSource {
                  id
                  name
                }
              }
              dtLeadStatusMapping {
                leadStatusType {
                  id
                  type
                  status
                }
                dtLeadStatus
              }
            }
            dsOpportunityEvents {
              id
              dsEventId
              dsLeadId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
              leadSource {
                name
              }
            }
            sfLeadOpportunities {
              id
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
              vsLeadStatusMapping {
                vsLeadStatusType
                vsLeadStatus
              }
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            dtLeadOpportunities {
              id
              dtOpportunityId
              dtOpportunityStage
            }
            tkLeadOpportunities {
              id
              tkLeadId
              tkContactId
              tkCustomerId
            }
          }
        }
      }
    }
  }
`;

export const GET_DAILY_ABANDONED_CALL_ACTIVITY = gql`
  query getCheckoutAbandonedCallActivity(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $completed: Boolean
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getCheckoutAbandonedCallActivity(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      completed: $completed
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        type
        title
        opportunity
        status
        vehicle
        dueDate
        leadName
        leadId
        leadOpportunityId
        lead {
          leadOpportunities {
            id
            name
            isActive
            dtLeadOpportunities {
              id
              dtLeadSource {
                dtLeadSourceName
                leadSource {
                  id
                  name
                }
              }
              dtLeadStatusMapping {
                leadStatusType {
                  id
                  type
                  status
                }
                dtLeadStatus
              }
            }
            dsOpportunityEvents {
              id
              dsEventId
              dsLeadId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
              leadSource {
                name
              }
            }
            sfLeadOpportunities {
              id
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
              vsLeadStatusMapping {
                vsLeadStatusType
                vsLeadStatus
              }
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            dtLeadOpportunities {
              id
              dtOpportunityId
              dtOpportunityStage
            }
            tkLeadOpportunities {
              id
              tkLeadId
              tkContactId
              tkCustomerId
            }
          }
        }
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_DAILY_MESSAGE_ACTIVITIES = gql`
  query getCheckoutMessagesActivity(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $completed: Boolean
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getCheckoutMessagesActivity(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      completed: $completed
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        type
        title
        status
        dueDate
        waitingTime
        leadName
        leadId
        messageId
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_DAILY_CALL_DETAILS = gql`
  query getCheckoutCallDetails(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $direction: String
    $answered: Boolean
    $outcome: [String]
  ) {
    getCheckoutCallDetails(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      direction: $direction
      answered: $answered
      outcome: $outcome
    ) {
      data {
        leadName
        direction
        answered
        outcome
        duration
        phone
        dateTime
        leadId
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_DAILY_EMAIL_DETAILS = gql`
  query CheckoutEmailDetails(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $status: [String]
  ) {
    getCheckoutEmailDetails(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      status: $status
    ) {
      data {
        leadName
        leadId
        messageId
        status
        subject
        sentAt
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_DAILY_CHECKOUT_MESSAGE_DETAILS = gql`
  query getCheckoutMessageDetails(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getCheckoutMessageDetails(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        leadId
        messageId
        leadName
        message
        direction
        sentAt
      }
      count
      statusCode
      message
    }
  }
`;

export const GET_DAILY_CHECKOUT_REPORT_CONFIGS = gql`
  query getCheckoutConfig($locationId: Int) {
    getCheckoutConfig(locationId: $locationId) {
      activitySource
      statusCode
      message
    }
  }
`;

export const EXPORT_REVIEWS_REPORT_BY_LOCATION = gql`
  query exportReviewsReportByLocation(
    $companyId: Int!
    $locationIds: [Int]
    $dateRange: [DateTime]
    $filterType: String
    $platform: [String]
    $rating: [Int]
    $status: [String]
    $userIds: [Int]
    $search: String
    $opportunityTypeIds: [Int]
    $isAiGenerated: Boolean
    $isDeleted: Boolean
  ) {
    exportReviewsReportByLocation(
      companyId: $companyId
      locationIds: $locationIds
      dateRange: $dateRange
      filterType: $filterType
      platform: $platform
      rating: $rating
      status: $status
      userIds: $userIds
      search: $search
      opportunityTypeIds: $opportunityTypeIds
      isAiGenerated: $isAiGenerated
      isDeleted: $isDeleted
    ) {
      statusCode
      message
      requestsFileUrl
      exportRequest {
        id
        fileName
        fileUrl
        status
      }
    }
  }
`;

export const GET_REVIEW_EXPORT_PREFERENCE = gql`
  query GetReviewExportPreference($locationId: Int) {
    getReviewExportPreference(locationId: $locationId) {
      locationId
      reportFormat
      includeAppliedFilters
      includeSummarySection
      columns
    }
  }
`;

export const EXPORT_DAILY_CHECKOUT_REPORT = gql`
  query exportCheckoutReport(
    $locationId: Int
    $userId: Int
    $teamIds: [Int]
    $filterType: String
    $dateRange: [DateTime]
  ) {
    exportCheckoutReport(
      locationId: $locationId
      userId: $userId
      teamIds: $teamIds
      filterType: $filterType
      dateRange: $dateRange
    ) {
      exportRequest {
        id
        fileName
        fileUrl
        status
        exportCategory
      }
      statusCode
      message
    }
  }
`;

// ─── Report Scheduling (EAI-1543) ──────────────────────────────────────────
export const GET_REPORT_SCHEDULES = gql`
  query getReportSchedules(
    $reportCategory: String
    $status: [String]
    $frequency: [String]
    $search: String
    $orderBy: String
    $orderDirection: String
    $page: Int
    $pageSize: Int
  ) {
    getReportSchedules(
      reportCategory: $reportCategory
      status: $status
      frequency: $frequency
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      pageSize: $pageSize
    ) {
      statusCode
      message
      count
      data {
        id
        name
        description
        reportKey
        scope
        userIds
        userList
        frequency
        interval
        intervalUnit
        dayOfWeek
        dayOfMonth
        monthlyMode
        monthlyWeekday
        runTime
        timezone
        dateRangeType
        customRangeStart
        customRangeEnd
        startDate
        endDate
        exportFormat
        deliveryMode
        status
        lastRunStatus
        companyId
        locationId
        userId
        nextRunAt
        lastRunAt
        sendToSubject
        oneShot
        recipients {
          id
          userId
          email
          isActive
        }
        ccUserIds
        ccEmails
        reportConfig
      }
    }
  }
`;

export const GET_VEHICLE_INVENTORY_FILTER_DATA = gql`
  query GetVehicleFilterOptions($locationIds: [Int]!) {
    getVehicleFilterOptions(locationIds: $locationIds) {
      makes
      models
      trims
      exteriorColors
      interiorColors
      bodyStyles
      years
      conditions
    }
  }
`;

export const EXPORT_OTTOLYTICS_REPORT = gql`
  query OttolyticsExport(
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $userIds: [Int]
    $teamIds: [Int]
    $opportunityTypeId: Int
    $exportType: String
    $fileName: String
  ) {
    exportOttolyticsSummaryReport(
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      userIds: $userIds
      teamIds: $teamIds
      opportunityTypeId: $opportunityTypeId
      exportType: $exportType
      fileName: $fileName
    ) {
      statusCode
      message
      exportRequest {
        locationId
        id
        status
        fileUrl
        fileName
        exportType
        exportCategory
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * Consent audit trail for one lead — powers the "Audit log" drawer on the lead
 * profile. `category` is one of AUDIT_LOG_CATEGORY (auditLog/constants.js);
 * omit it for "All". Paged server-side: `count` is the unfiltered-by-page total.
 */
export const GET_LEAD_AUDIT_LOG = gql`
  query getLeadAuditLog($leadId: Int!, $category: String, $page: Int, $pageSize: Int) {
    getLeadAuditLog(leadId: $leadId, category: $category, page: $page, pageSize: $pageSize) {
      count
      data {
        id
        action
        entityType
        entityId
        oldValues
        newValues
        changedFields
        updatedById
        updatedByType
        updatedByName
        createdAt
      }
    }
  }
`;

export const GET_ASSIGNED_OPPS_VIDEO_DETAILS = gql`
  query getAssignedOppsVideoDetail(
    $userId: Int!
    $locationId: Int
    $filterType: String
    $dateRange: [DateTime]
    $opportunityTypeId: Int
    $hasVideo: Boolean
    $page: Int
    $pageSize: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    getAssignedOppsVideoDetail(
      userId: $userId
      locationId: $locationId
      filterType: $filterType
      dateRange: $dateRange
      opportunityTypeId: $opportunityTypeId
      hasVideo: $hasVideo
      page: $page
      pageSize: $pageSize
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      statusCode
      message
      totalLeads
      totalOpps
      oppsWithVideo
      totalVideosSent
      leads {
        leadId
        leadName
        oppsTotal
        oppsWithVideo
        opportunities {
          leadOpportunityId
          opportunityType
          opportunityStatus
          createdDate
          videosSent
          hasVideo
          firstVideoSentAt
          videosViewed
          totalWatchTime
          items {
            messageId
            mmsObjectId
            linkTrackingId
            mediaUrl
            thumbnail
            sentAt
            method
            link
            status
            openedAt
            totalPlayDuration
            downloadCount
          }
        }
      }
    }
  }
`;
